export const QUESTIONS = [
  {
    "id": 1,
    "question": "Bob is accessing a self-service portal in the cloud to instantly create additional servers, storage, and database instances for his firm\u2019s DevOps group. Which of the following options best describes this operation?",
    "choice_a": "Bursting",
    "choice_b": "Pay-as-you-grow",
    "choice_c": "Multitenancy",
    "choice_d": "On-demand",
    "correct_answer": "D",
    "explanation": "On-demand cloud computing allows the consumer to add and change resources dynamically with the use of an online portal.",
    "topic_id": 1,
    "practice_test_id": 2,
    "related_articles": [
      2,
      4,
      8,
      3,
      10
    ],
    "source": "333776_AssessmentTest"
  },
  {
    "id": 2,
    "question": "Jillian is working on a project to interconnect her company\u2019s private data center to a cloud company that offers email services and another that can provide burstable compute capacity. What type of cloud delivery model is she creating?",
    "choice_a": "Public",
    "choice_b": "Hybrid",
    "choice_c": "Community",
    "choice_d": "Private",
    "correct_answer": "B",
    "explanation": "The interconnection of multiple cloud models is referred to as a hybrid cloud.",
    "topic_id": 2,
    "practice_test_id": 2,
    "related_articles": [
      5,
      96,
      72,
      6,
      7
    ],
    "source": "333776_AssessmentTest"
  },
  {
    "id": 3,
    "question": "Carl is learning how cloud service providers allocate physical resources into a group. These resources are then dynamically associated with cloud services as demand requires. What best describes this?",
    "choice_a": "On-demand virtualization",
    "choice_b": "Dynamic scaling",
    "choice_c": "Resource pooling",
    "choice_d": "Elasticity",
    "correct_answer": "C",
    "explanation": "Resource pooling is the allocation of compute resources into a group, or pool, and then these pools are made available to a multitenant cloud environment.",
    "topic_id": 1,
    "practice_test_id": 2,
    "related_articles": [
      10,
      3,
      8,
      27,
      11
    ],
    "source": "333776_AssessmentTest"
  },
  {
    "id": 4,
    "question": "Liza is a new Cloud+ architect for BigCo Inc. She is investigating cloud services that provide server hardware, but not applications. What cloud service is she using?",
    "choice_a": "IaaS",
    "choice_b": "PaaS",
    "choice_c": "SaaS",
    "choice_d": "CaaS",
    "correct_answer": "A",
    "explanation": "Infrastructure as a service offers computing hardware, storage, and networking but not applications.",
    "topic_id": 1,
    "practice_test_id": 2,
    "related_articles": [
      26,
      4,
      24,
      91,
      1
    ],
    "source": "333776_AssessmentTest"
  },
  {
    "id": 5,
    "question": "Harold is investigating his options to migrate his company\u2019s time and attendance application to the cloud. He wants to be responsible only for maintaining the application and would prefer that the public cloud company manage all underlying infrastructure and servers that are required to support his application. Harold calls you and asks for assistance in selecting a cloud service model that would meet his requirements. What would you suggest that he implement?",
    "choice_a": "IaaS",
    "choice_b": "PaaS",
    "choice_c": "SaaS",
    "choice_d": "CaaS",
    "correct_answer": "B",
    "explanation": "Platform as a service offers computing hardware, storage, networking, and the operating systems but not the applications.",
    "topic_id": 1,
    "practice_test_id": 2,
    "related_articles": [
      4,
      26,
      24,
      91,
      1
    ],
    "source": "333776_AssessmentTest"
  },
  {
    "id": 6,
    "question": "Jane is a Cloud+ architect working on a physical-to-virtual migration to the public cloud. She has matched VM performance levels to her established baselines. She knows that her organization may need to adjust hardware resources in the future. What cloud characteristics can she use to match cloud capacity with future growth? (Choose three.)",
    "choice_a": "Elasticity",
    "choice_b": "On-demand computing",
    "choice_c": "Availability zones",
    "choice_d": "Resiliency virtualization",
    "correct_answer": [
      "A",
      "B",
      "E"
    ],
    "explanation": "Elasticity, on-demand computing, and pay-as-you-grow are all examples of being able to expand cloud compute resources as your needs require.",
    "topic_id": 1,
    "practice_test_id": 2,
    "related_articles": [
      2,
      8,
      3,
      10,
      42
    ],
    "source": "333776_AssessmentTest",
    "choice_e": "Pay-as-you grow",
    "choice_f": "Resource pooling"
  },
  {
    "id": 7,
    "question": "What are two elements that together distinguish the cloud from a traditional data center operation? (Choose two.)",
    "choice_a": "Load balancing",
    "choice_b": "Automation",
    "choice_c": "Autoscaling groups",
    "choice_d": "Virtualization",
    "correct_answer": [
      "B",
      "D"
    ],
    "explanation": "One of the prime advantages of cloud-based computing and the automation and virtualization it offers in the background is the ability to leverage the rapid provisioning of virtual resources to allow for on-demand computing.",
    "topic_id": 1,
    "practice_test_id": 2,
    "related_articles": [
      3,
      10,
      2,
      1,
      8
    ],
    "source": "333776_AssessmentTest"
  },
  {
    "id": 8,
    "question": "Dawn is interested in selecting a community cloud provider that offers a specialized financial reporting application. What type of cloud model would you recommend Dawn investigate to meet her requirements?",
    "choice_a": "IaaS",
    "choice_b": "PaaS",
    "choice_c": "SaaS",
    "choice_d": "CaaS",
    "correct_answer": "C",
    "explanation": "Software as a service offers cloud-managed applications as well as the underlying platform and infrastructure support.",
    "topic_id": 1,
    "practice_test_id": 2,
    "related_articles": [
      4,
      26,
      35,
      24,
      91
    ],
    "source": "333776_AssessmentTest"
  },
  {
    "id": 9,
    "question": "Carol is a cloud customer that your consulting company is assisting with their migration. She is asking you about the demarcation point of operations for her public PaaS service. Which of the following defines what you are responsible for and the responsibility of the provider?",
    "choice_a": "Availability zones",
    "choice_b": "Community",
    "choice_c": "Shared responsibility model",
    "choice_d": "Baselines",
    "correct_answer": "C",
    "explanation": "The shared responsibility model outlines what services and portions of the cloud operations the cloud consumer and the provider are responsible for.",
    "topic_id": 1,
    "practice_test_id": 2,
    "related_articles": [
      24,
      91,
      26,
      4,
      113
    ],
    "source": "333776_AssessmentTest"
  },
  {
    "id": 10,
    "question": "Jonathan is architecting his client\u2019s global public cloud presence for an upcoming e-commerce deployment. You have been brought on to help design the network. He asks about providing local connections in Singapore and Malaysia. What would you suggest that he investigate?",
    "choice_a": "Regions",
    "choice_b": "Auto-scaling groups",
    "choice_c": "Availability zones",
    "choice_d": "Global DNS affinity",
    "correct_answer": "A",
    "explanation": "Cloud operators segment their operations into regions for customer proximity, regulatory compliance, resiliency, and survivability.",
    "topic_id": 1,
    "practice_test_id": 2,
    "related_articles": [
      21,
      143,
      16,
      1,
      11
    ],
    "source": "333776_AssessmentTest"
  },
  {
    "id": 11,
    "question": "Zale is working on a collaborative project that requires the implementation of a large-scale NoSQL database that will access three petabytes of historical data. He needs durable block storage in remote flash arrays. You have been tasked with designing the storage connectivity from the database to the stored data. What type of network connection would you recommend for NoSQL read/write access to the arrays?",
    "choice_a": "Block access",
    "choice_b": "Zoning",
    "choice_c": "VMFS",
    "choice_d": "SAN",
    "correct_answer": "D",
    "explanation": "A storage area network (SAN) is a high-speed network dedicated to storage transfers across a shared network. Block access is not a networking technology. Zoning is for restricting access to LUNs in a SAN, and VMFS is a VMware filesystem.",
    "topic_id": 1,
    "practice_test_id": 2,
    "related_articles": [
      53,
      12,
      71,
      52,
      55
    ],
    "source": "333776_AssessmentTest"
  },
  {
    "id": 12,
    "question": "Physical resources are virtualized and presented as resources to virtual machines running on hypervisors. What common resources does the hypervisor virtualize? (Choose three.)",
    "choice_a": "Layer 2",
    "choice_b": "RAM",
    "choice_c": "Layer 3",
    "choice_d": "CPUs",
    "correct_answer": [
      "B",
      "D",
      "F"
    ],
    "explanation": "A hypervisor will virtualize RAM, compute, and storage; the VMs operating on the hypervisor will access these pools.",
    "topic_id": 1,
    "practice_test_id": 2,
    "related_articles": [
      42,
      10,
      3,
      12,
      71
    ],
    "source": "333776_AssessmentTest",
    "choice_e": "RAID",
    "choice_f": "Storage"
  },
  {
    "id": 13,
    "question": "As a new Cloud+ professional, you have been hired by a company that operates its own data center; however, the company is calling it a cloud. What delivery model are you working with?",
    "choice_a": "Hybrid",
    "choice_b": "Public",
    "choice_c": "Private",
    "choice_d": "Community",
    "correct_answer": "C",
    "explanation": "A private cloud is used exclusively by a single organization.",
    "topic_id": 2,
    "practice_test_id": 2,
    "related_articles": [
      5,
      96,
      6,
      7,
      28
    ],
    "source": "333776_AssessmentTest"
  },
  {
    "id": 14,
    "question": "Tim just logged into his cloud management dashboard to check the health monitors of his server fleet. What is the process that he completed at login?",
    "choice_a": "Authorization",
    "choice_b": "Accounting",
    "choice_c": "Authentication",
    "choice_d": "Federation",
    "correct_answer": "C",
    "explanation": "Authentication is the term used to describe the process of determining the identity of a user or device.",
    "topic_id": 4,
    "practice_test_id": 2,
    "related_articles": [
      69,
      92,
      165,
      109,
      101
    ],
    "source": "333776_AssessmentTest",
    "choice_e": "Identity access"
  },
  {
    "id": 15,
    "question": "Martha is studying SAN technologies that use the Fibre Channel protocol, and she is asking about disk configuration in the remote storage array. She asks you which type of storage she can use on her Linux servers. What storage type can she deploy? (Choose the best answer.)",
    "choice_a": "Meta",
    "choice_b": "Object",
    "choice_c": "Block",
    "choice_d": "File",
    "correct_answer": "C",
    "explanation": "Storage area networks support block-based storage.",
    "topic_id": 1,
    "practice_test_id": 2,
    "related_articles": [
      52,
      53,
      12,
      55,
      71
    ],
    "source": "333776_AssessmentTest"
  },
  {
    "id": 16,
    "question": "Patesh is becoming familiar with the interfaces available for his operations team to use to access his hybrid cloud deployment. You have been asked to explain the common types of user-based interfaces available to manage cloud objects. What are the common interfaces that you would explain to Patesh? (Choose three.)",
    "choice_a": "Web console",
    "choice_b": "SNMP",
    "choice_c": "API",
    "choice_d": "PaaS",
    "correct_answer": [
      "A",
      "C",
      "E"
    ],
    "explanation": "Application programming interfaces, command-line interfaces, and GUI-based interfaces are all commonly used tools to migrate, monitor, manage, and troubleshoot cloud-based resources.",
    "topic_id": 4,
    "practice_test_id": 2,
    "related_articles": [
      165,
      87,
      93,
      60,
      97
    ],
    "source": "333776_AssessmentTest",
    "choice_e": "CLI"
  },
  {
    "id": 17,
    "question": "You work for a company that offers cloud services to the railroad industry. All railroads have a similar set of requirements and access the same applications. BigWest Rail has contacted you about becoming a customer and is asking what applications are shared with other rail operators. They also ask what type of cloud model your company offers. What type of cloud is this?",
    "choice_a": "Hybrid",
    "choice_b": "Public",
    "choice_c": "Private",
    "choice_d": "Community",
    "correct_answer": "D",
    "explanation": "A community cloud is used by companies with similar needs such as railroad companies.",
    "topic_id": 2,
    "practice_test_id": 2,
    "related_articles": [
      5,
      96,
      7,
      6,
      30
    ],
    "source": "333776_AssessmentTest"
  },
  {
    "id": 18,
    "question": "Kevin is exploring a durable block storage option that offers high performance. It also needs to support striping that allows a parity bit to be used to reconstruct a volume if a single magnetic disk fails in his array. Which storage type stripes file data and performs a parity check of data over multiple disks that can recover from a single hard disk failure?",
    "choice_a": "RAID 0",
    "choice_b": "RAID 1",
    "choice_c": "RAID 3",
    "choice_d": "RAID 5",
    "correct_answer": "D",
    "explanation": "RAID 5 uses parity information that is striped across multiple drives, which allows the drive array to be rebuilt if a single drive in the array fails. The other options do not have parity data.",
    "topic_id": 1,
    "practice_test_id": 2,
    "related_articles": [
      52,
      12,
      53,
      55,
      62
    ],
    "source": "333776_AssessmentTest"
  },
  {
    "id": 19,
    "question": "You are involved in a large-scale migration project that requires moving a Windows OS running on a dual-slot, eight-core server with no hypervisor in a data center to a virtual server in the public cloud. What type of migration is this?",
    "choice_a": "vMotion",
    "choice_b": "P2V",
    "choice_c": "Private to public",
    "choice_d": "V2V",
    "correct_answer": "B",
    "explanation": "When migrating a server that is running on bare metal to a hypervisor-based system, you would be performing a physical-to-virtual migration.",
    "topic_id": 2,
    "practice_test_id": 2,
    "related_articles": [
      28,
      64,
      72,
      63,
      66
    ],
    "source": "333776_AssessmentTest",
    "choice_e": "Synchronous replication"
  },
  {
    "id": 20,
    "question": "You have been asked by a new customer what type of authentication systems require something that you have and something that you know. What type of authentication technology would you recommend?",
    "choice_a": "Single sign-on",
    "choice_b": "Confederations",
    "choice_c": "Active Directory/LDAP",
    "choice_d": "Multifactor",
    "correct_answer": "D",
    "explanation": "Multifactor authentication systems use a token generator as something you have and a PIN/password as something you know.",
    "topic_id": 4,
    "practice_test_id": 2,
    "related_articles": [
      101,
      97,
      95,
      165,
      69
    ],
    "source": "333776_AssessmentTest"
  },
  {
    "id": 21,
    "question": "Beatriz stops at her bank\u2019s ATM on her way home from work. She inserts her card into the ATM and then enters her PIN on the keypad. What type of authentication is she using?",
    "choice_a": "SSO",
    "choice_b": "Two-factor",
    "choice_c": "LDAP",
    "choice_d": "User-based",
    "correct_answer": "B",
    "explanation": "Two-factor authentication includes something you have and something you know.",
    "topic_id": 4,
    "practice_test_id": 2,
    "related_articles": [
      101,
      95,
      97,
      92,
      69
    ],
    "source": "333776_AssessmentTest"
  },
  {
    "id": 22,
    "question": "Roman is the cloud administrator for a company that stores object-based data in a hybrid cloud. Because of the sensitivity of the data and various regulatory restrictions on allowing users access to sensitive security data, what type of access control would meet his security policies?",
    "choice_a": "Mandatory access control",
    "choice_b": "Nondiscretionary",
    "choice_c": "Roles",
    "choice_d": "Multifactor",
    "correct_answer": "A",
    "explanation": "The mandatory access control approach is implemented in high-security environments where access to sensitive data needs to be highly controlled. Using the mandatory access control approach, a user will authenticate, or log into, a system. Based on the user\u2019s identity and security levels of the individual, access rights will be determined by comparing that data against the security properties of the system being accessed.",
    "topic_id": 4,
    "practice_test_id": 2,
    "related_articles": [
      94,
      98,
      92,
      97,
      102
    ],
    "source": "333776_AssessmentTest"
  },
  {
    "id": 23,
    "question": "William is implementing an access control rollout for a cluster of Windows SQL database servers in a hybrid cloud environment. Developers will need full read/write access to the database servers, whereas other business units will need read-only access to particular databases. What type of access control should William deploy?",
    "choice_a": "Mandatory access control",
    "choice_b": "Nondiscretionary",
    "choice_c": "Role-based",
    "choice_d": "Multifactor",
    "correct_answer": "C",
    "explanation": "The question outlines the function of a role-based access control approach.",
    "topic_id": 4,
    "practice_test_id": 2,
    "related_articles": [
      68,
      94,
      165,
      97,
      93
    ],
    "source": "333776_AssessmentTest"
  },
  {
    "id": 24,
    "question": "Quentin is a defense contractor investigating server compliance requirements needed to be certified to meet the U.S. Department of Defense security requirements for contractors. What requirement would you recommend that he focus on?",
    "choice_a": "FedRAMP",
    "choice_b": "DIACAP",
    "choice_c": "FISMA",
    "choice_d": "Section 405.13 for DoD rule A286",
    "correct_answer": "B",
    "explanation": "The Department of Defense Information Assurance Certification and Accreditation Process (DIACAP) is the process for computer systems\u2019 IT security. DIACAP compliance is required to be certified to meet the U.S. Department of Defense security requirements for contractors.",
    "topic_id": 4,
    "practice_test_id": 2,
    "related_articles": [
      76,
      73,
      102,
      79,
      75
    ],
    "source": "333776_AssessmentTest"
  },
  {
    "id": 25,
    "question": "Leanna wants to deploy a public cloud service that allows her to retain responsibility only for her applications and requires the cloud provider to maintain the underlying operating system and virtualized hardware. Which service model would you recommend that she implement?",
    "choice_a": "IaaS",
    "choice_b": "PaaS",
    "choice_c": "SaaS",
    "choice_d": "CaaS",
    "correct_answer": "B",
    "explanation": "The platform-as-a-service model offers operating system maintenance to be provided by the service provider.",
    "topic_id": 1,
    "practice_test_id": 2,
    "related_articles": [
      4,
      24,
      26,
      91,
      113
    ],
    "source": "333776_AssessmentTest"
  },
  {
    "id": 26,
    "question": "Robert is configuring a new cloud interconnect to access his locally hosted Active Directory services. He wants to prevent his user base from having fragmented rights and no unified authorization services. You are brought in as a service consultant to assist in optimizing and controlling user access by implementing a technology that will give access to all allowed systems at the time of user authentication. What type of system are you deploying?",
    "choice_a": "Token-based 2FA",
    "choice_b": "SSO",
    "choice_c": "RSA",
    "choice_d": "Nondiscretionary",
    "correct_answer": "B",
    "explanation": "Single sign-on allows a user to log in one time and be granted access to multiple systems without having to authenticate to each one individually.",
    "topic_id": 4,
    "practice_test_id": 2,
    "related_articles": [
      95,
      97,
      165,
      69,
      92
    ],
    "source": "333776_AssessmentTest"
  },
  {
    "id": 27,
    "question": "Cathy is preparing her company\u2019s migration plan from a private to a hybrid cloud. She wants to outline firewall and DDoS requirements. What document should she create?",
    "choice_a": "DIACAP",
    "choice_b": "Security policy",
    "choice_c": "Service level agreement",
    "choice_d": "SOC-2",
    "correct_answer": "B",
    "explanation": "The security policy outlines all aspects of your cloud security posture.",
    "topic_id": 4,
    "practice_test_id": 2,
    "related_articles": [
      75,
      37,
      38,
      88,
      97
    ],
    "source": "333776_AssessmentTest"
  },
  {
    "id": 28,
    "question": "Perry is investigating options for interconnecting a private cloud to a new public cloud region that supports analysis of customer-streamed IoT data. He is planning on implementing a tunnel across the Internet to interconnect the two locations to avoid the high costs of a dedicated interconnection. What transport protocol would you suggest that can offer a secure connection across the unsecure Internet?",
    "choice_a": "AES",
    "choice_b": "SOC-3",
    "choice_c": "IPsec",
    "choice_d": "RC5",
    "correct_answer": "C",
    "explanation": "IPsec implementations are found in routers and firewalls with VPN services to provide a secure connection over an insecure network such as the Internet.",
    "topic_id": 1,
    "practice_test_id": 2,
    "related_articles": [
      16,
      11,
      35,
      8,
      70
    ],
    "source": "333776_AssessmentTest"
  },
  {
    "id": 29,
    "question": "Jarleen is a consultant tasked with migrating Health Med Records Inc. customer records to a cloud-based service offering a long-term archival system. Which U.S. compliance mandate must her company align with?",
    "choice_a": "SOC 3",
    "choice_b": "HIPAA",
    "choice_c": "MPAA",
    "choice_d": "ISA 2701",
    "correct_answer": "B",
    "explanation": "The Health Insurance Portability and Accountability Act defines the standards for protecting medical data.",
    "topic_id": 4,
    "practice_test_id": 2,
    "related_articles": [
      73,
      76,
      74,
      79,
      102
    ],
    "source": "333776_AssessmentTest"
  },
  {
    "id": 30,
    "question": "Fluentes is a security consultant for a day trading company that must implement strong encryption of data at rest for their cloud storage tiers. What is the best option that meets most security regulations for the encryption of stored data?",
    "choice_a": "3DES",
    "choice_b": "RSA",
    "choice_c": "AES-256",
    "choice_d": "Rivest Cipher 5",
    "correct_answer": "C",
    "explanation": "Advanced Encryption Standard is a symmetrical block cipher that has options to use three lengths, including 128, 192, and 256 bits. AES 256 is a very secure standard, and it would take an extremely long time and a lot of processing power to come even close to breaking the code.",
    "topic_id": 4,
    "practice_test_id": 2,
    "related_articles": [
      83,
      82,
      57,
      100,
      73
    ],
    "source": "333776_AssessmentTest"
  },
  {
    "id": 31,
    "question": "Randy is developing a new application that will be deployed in an IaaS-based public cloud. He builds a test image and deploys a test VM in his private cloud\u2019s development zone. When he stops and restarts one of the Linux-based servers, he notices that his storage volume data is missing. What type of storage exhibits this behavior? (Choose two.)",
    "choice_a": "Durable",
    "choice_b": "RAID",
    "choice_c": "Ephemeral",
    "choice_d": "Nondurable",
    "correct_answer": [
      "C",
      "D"
    ],
    "explanation": "Temporary storage volumes that are destroyed when the VM is stopped are referred to as ephemeral or nondurable storage.",
    "topic_id": 1,
    "practice_test_id": 2,
    "related_articles": [
      52,
      12,
      55,
      8,
      71
    ],
    "source": "333776_AssessmentTest",
    "choice_e": "Block",
    "choice_f": "Object"
  },
  {
    "id": 32,
    "question": "Matt has finished running some security automation scripts on three newly deployed Linux servers. After applying intrusion detection, virus, and malware protection on the Linux images, he notices an increase in which VM metric on his server management dashboard?",
    "choice_a": "DMA",
    "choice_b": "BIOS",
    "choice_c": "CPU",
    "choice_d": "IPsec",
    "correct_answer": "C",
    "explanation": "Applying security applications on a virtual server will cause an increase in CPU usage.",
    "topic_id": 3,
    "practice_test_id": 2,
    "related_articles": [
      176,
      182,
      105,
      122,
      23
    ],
    "source": "333776_AssessmentTest",
    "choice_e": "I/O"
  },
  {
    "id": 33,
    "question": "Jill works in the operations center, and she is tasked with monitoring security operations. What cloud-based GUI can she use for a real-time overview of security operations?",
    "choice_a": "Puppet automation",
    "choice_b": "Gemalto system",
    "choice_c": "Dashboard",
    "choice_d": "Vendor-based security appliance",
    "correct_answer": "C",
    "explanation": "A dashboard is a graphical portal that provides updates and an overview of operations.",
    "topic_id": 3,
    "practice_test_id": 2,
    "related_articles": [
      105,
      34,
      173,
      157,
      178
    ],
    "source": "333776_AssessmentTest"
  },
  {
    "id": 34,
    "question": "Larken is reviewing the SLA and statement of responsibility with his community cloud provider PaaS. To whom does the responsibility for stored data integrity in the cloud belong?",
    "choice_a": "Cloud provider",
    "choice_b": "Compliance agency",
    "choice_c": "Cloud customer",
    "choice_d": "Shared responsibility",
    "correct_answer": "D",
    "explanation": "Ultimately the responsibility for data in the cloud belongs to the organization that owns the data.",
    "topic_id": 1,
    "practice_test_id": 2,
    "related_articles": [
      24,
      91,
      4,
      26,
      141
    ],
    "source": "333776_AssessmentTest"
  },
  {
    "id": 35,
    "question": "Mindy has been tasked with developing a new QA test logging application, but she is concerned that the application must pull data from many different cloud locations and devices. What is a good interface for her to use to meet her requirements?",
    "choice_a": "Python",
    "choice_b": "XML",
    "choice_c": "API",
    "choice_d": "SNMP",
    "correct_answer": "C",
    "explanation": "An application programming interface (API) offers programmatic access, control, and configuration of a device between different and discrete software components.",
    "topic_id": 5,
    "practice_test_id": 2,
    "related_articles": [
      103
    ],
    "source": "333776_AssessmentTest",
    "choice_e": "TLS"
  },
  {
    "id": 36,
    "question": "What technology was instrumental in the growth of cloud services?",
    "choice_a": "XML",
    "choice_b": "Python",
    "choice_c": "Automation",
    "choice_d": "Authentication",
    "correct_answer": "C",
    "explanation": "Automation of cloud deployments was instrumental in the growth of cloud-based services.",
    "topic_id": 5,
    "practice_test_id": 2,
    "related_articles": [
      121,
      103,
      117
    ],
    "source": "333776_AssessmentTest",
    "choice_e": "Security",
    "choice_f": "Workflow services",
    "choice_g": "Encryption"
  },
  {
    "id": 37,
    "question": "Vicky is investigating multiple hacking attempts on her cloud-based e-commerce web servers. She wants to add a front-end security system that can actively deploy countermeasures that shut down the hacking attempts. What application would you suggest that Vicky deploy?",
    "choice_a": "DMZ",
    "choice_b": "IDS",
    "choice_c": "IPS",
    "choice_d": "RAID",
    "correct_answer": "C",
    "explanation": "Intrusion prevention systems monitor for malicious activity and actively take countermeasures to eliminate or reduce the effects of the intrusion.",
    "topic_id": 4,
    "practice_test_id": 2,
    "related_articles": [
      107,
      38,
      111,
      87,
      108
    ],
    "source": "333776_AssessmentTest",
    "choice_e": "HIDS"
  },
  {
    "id": 38,
    "question": "What options can you offer your user base for MFA tokens? (Choose two.)",
    "choice_a": "One-time password",
    "choice_b": "Smartphone app",
    "choice_c": "Automation systems",
    "choice_d": "Key fob",
    "correct_answer": [
      "B",
      "C"
    ],
    "explanation": "One-time numerical tokens are generated on key fob hardware devices or smartphone soft-token applications.",
    "topic_id": 4,
    "practice_test_id": 2,
    "related_articles": [
      101,
      95,
      165,
      97,
      69
    ],
    "source": "333776_AssessmentTest",
    "choice_e": "Cloud vendor management dashboard"
  },
  {
    "id": 39,
    "question": "Linda works in the IT security group of her firm and has been tasked with investigating options that will allow customers to access their personal records securely via the web. What is the most common in-flight e-commerce security protocol on the market?",
    "choice_a": "MD5",
    "choice_b": "SSL/TLS",
    "choice_c": "IPsec",
    "choice_d": "VPN",
    "correct_answer": "B",
    "explanation": "SSL/TLS is most commonly used with web and smartphone applications. MD5 is a hash algorithm. IPsec is used to create VPNs over a public network, but VPNs are not as common as SSL/TLS for the scenario given.",
    "topic_id": 4,
    "practice_test_id": 2,
    "related_articles": [
      81,
      82,
      80,
      84,
      83
    ],
    "source": "333776_AssessmentTest"
  },
  {
    "id": 40,
    "question": "Your company has purchased a specialized intrusion prevention system that is virtualized and designed for cloud-based network micro-segmentation deployments. When reading the documentation, you notice a link to download a Java-based application to monitor and configure the IPS application. What kind of configuration program is this?",
    "choice_a": "CLI",
    "choice_b": "GIU",
    "choice_c": "Vendor-based",
    "choice_d": "API",
    "correct_answer": "C",
    "explanation": "Based on the information given, the description is for a vendor-based management application.",
    "topic_id": 4,
    "practice_test_id": 2,
    "related_articles": [
      107,
      111,
      37,
      106,
      74
    ],
    "source": "333776_AssessmentTest",
    "choice_e": "RESTful"
  },
  {
    "id": 41,
    "question": "Name the type of software update that is designed to address a known bug and to bring a system up-to-date with previously released fixes.",
    "choice_a": "Hotfix",
    "choice_b": "Patch",
    "choice_c": "Version update",
    "choice_d": "Rollout",
    "correct_answer": "B",
    "explanation": "A patch is a piece of software that updates an application or operating system, to add a feature, fix a bug, or improve performance.",
    "topic_id": 3,
    "practice_test_id": 2,
    "related_articles": [
      122,
      116,
      115,
      177,
      160
    ],
    "source": "333776_AssessmentTest"
  },
  {
    "id": 42,
    "question": "Your employer has developed a mission-critical application for the medical industry, and there can be no downtime during maintenance. You have designed a web architecture to take this into account and that allows you to have an exact copy of your production fleet that can be brought online to replace your existing deployment for patching and maintenance. What type of model did you implement?",
    "choice_a": "Cluster",
    "choice_b": "DevOps",
    "choice_c": "Blue-green",
    "choice_d": "Rolling",
    "correct_answer": "B",
    "explanation": "Blue-green is a software deployment model that uses two configurations for production that are identical to each other. These deployments can alternate between each other, with one active and the other inactive.",
    "topic_id": 2,
    "practice_test_id": 2,
    "related_articles": [
      114,
      132,
      13,
      29,
      45
    ],
    "source": "333776_AssessmentTest"
  },
  {
    "id": 43,
    "question": "Jill is performing a Tuesday night backup of a Tier 2 storage volume of which she already completed a full backup on Sunday night. She only wants to back up files based on changes of the source data since the last backup. What type of backup is she performing?",
    "choice_a": "Full",
    "choice_b": "Differential",
    "choice_c": "Incremental",
    "choice_d": "Online",
    "correct_answer": "C",
    "explanation": "Incremental backups are operations based on changes of the source data since the last incremental backup was performed.",
    "topic_id": 3,
    "practice_test_id": 2,
    "related_articles": [
      126,
      124,
      129,
      119,
      46
    ],
    "source": "333776_AssessmentTest"
  },
  {
    "id": 44,
    "question": "What virtual machine backup method creates a file-based image of the current state of a VM, including the complete operating system and all applications that are stored on it?",
    "choice_a": "Full backup",
    "choice_b": "Snapshot",
    "choice_c": "Clone",
    "choice_d": "Replicate",
    "correct_answer": "B",
    "explanation": "A snapshot is a file-based image of the current state of a VM, including the complete operating system and all applications stored on it. The snapshot will record the data on the disk and optionally its memory contents at that instant in time.",
    "topic_id": 3,
    "practice_test_id": 2,
    "related_articles": [
      119,
      124,
      123,
      125,
      127
    ],
    "source": "333776_AssessmentTest"
  },
  {
    "id": 45,
    "question": "Ronald is a Cloud+ student studying systems that abstract and hide much of the complexity of modern cloud systems. What is he learning about?",
    "choice_a": "Runbooks",
    "choice_b": "Workflow",
    "choice_c": "Orchestration",
    "choice_d": "REST/API",
    "correct_answer": "C",
    "explanation": "Orchestration systems enable large-scale cloud deployments by automating operations.",
    "topic_id": 1,
    "practice_test_id": 2,
    "related_articles": [
      47,
      3,
      8,
      27,
      71
    ],
    "source": "333776_AssessmentTest"
  },
  {
    "id": 46,
    "question": "What are common automation platforms? (Choose three.)",
    "choice_a": "Chef",
    "choice_b": "Cloud-patch",
    "choice_c": "Ansible",
    "choice_d": "DevOps",
    "correct_answer": [
      "A",
      "C",
      "E"
    ],
    "explanation": "Common automation offerings are Chef, Puppet, and Ansible.",
    "topic_id": 5,
    "practice_test_id": 2,
    "related_articles": [
      103,
      117,
      121
    ],
    "source": "333776_AssessmentTest",
    "choice_e": "Puppet",
    "choice_f": "Cloud Deploy"
  },
  {
    "id": 47,
    "question": "Marlene is updating her horizontally scaled Internet-facing web servers to remediate a critical bug. Her manager has agreed to operate under reduced computing capacity during the process but stipulates that there can be no downtime. What upgrade approach should Marlene perform to meet these requirements?",
    "choice_a": "Orchestration",
    "choice_b": "Rolling",
    "choice_c": "Hotfix",
    "choice_d": "Blue-green",
    "correct_answer": "B",
    "explanation": "A rolling configuration will sequentially upgrade the web servers without causing a complete outage and would meet the requirements outlined in the question.",
    "topic_id": 2,
    "practice_test_id": 2,
    "related_articles": [
      114,
      132,
      29,
      31,
      66
    ],
    "source": "333776_AssessmentTest"
  },
  {
    "id": 48,
    "question": "What VM backup method can be used to create a master image to be used as a template to create additional systems?",
    "choice_a": "Full backup",
    "choice_b": "Snapshot",
    "choice_c": "Clone",
    "choice_d": "Replica",
    "correct_answer": "C",
    "explanation": "Cloning takes the master image and clones it to be used as another separate and independent VM. Important components of a server are changed to prevent address conflicts; these include the UUID and MAC addresses of the cloned server.",
    "topic_id": 1,
    "practice_test_id": 2,
    "related_articles": [
      10,
      27,
      42,
      113,
      52
    ],
    "source": "333776_AssessmentTest"
  },
  {
    "id": 49,
    "question": "A new application patch is being validated prior to release to the public. The developers have a release candidate, and the DevOps manager is requesting a report that shows the pass/fail data to verify that the fix does, in fact, resolve the problem. What process is the manager verifying?",
    "choice_a": "Rollout",
    "choice_b": "Orchestration",
    "choice_c": "Automation",
    "choice_d": "QA",
    "correct_answer": "D",
    "explanation": "The manager is requesting data on the results of the quality assurance testing on the release.",
    "topic_id": 3,
    "practice_test_id": 2,
    "related_articles": [
      177,
      116,
      142,
      123,
      34
    ],
    "source": "333776_AssessmentTest"
  },
  {
    "id": 50,
    "question": "Jane has found a table merge issue in her SQL database hosted in a private cloud. While reviewing the log files, the vendor requested that she install a software change designed for rapid deployment that corrects a specific and critical issue. What are they referring to?",
    "choice_a": "Hotfix",
    "choice_b": "Patch",
    "choice_c": "Version update",
    "choice_d": "Rollout",
    "correct_answer": "A",
    "explanation": "A hotfix is a software update type that is intended to fix an immediate and specific problem.",
    "topic_id": 3,
    "practice_test_id": 2,
    "related_articles": [
      160,
      116,
      123,
      168,
      174
    ],
    "source": "333776_AssessmentTest"
  },
  {
    "id": 51,
    "question": "To meet regulatory requirements, a medical records company is required to store customer transaction records for seven years. The records will most likely never be accessed after the second year and can be stored offline to reduce expenses. What type of storage should they implement to achieve this goal?",
    "choice_a": "File transfer",
    "choice_b": "Archive",
    "choice_c": "Replication",
    "choice_d": "Data store",
    "correct_answer": "B",
    "explanation": "Moving inactive data to a separate storage facility for long-term storage is called archiving.",
    "topic_id": 1,
    "practice_test_id": 2,
    "related_articles": [
      58,
      52,
      12,
      50,
      2
    ],
    "source": "333776_AssessmentTest"
  },
  {
    "id": 52,
    "question": "Mark is creating a disaster recovery plan based on directives from his company\u2019s executive management team. His company\u2019s business is an e-commerce website that sells children\u2019s apparel, with 85 percent of its revenue received during the holiday season. If there was a severe disruption in operations, the loss of business could put the company\u2019s ongoing financially viability in peril. Mark is creating a plan that will restore operations in the shortest amount of time possible if there is an outage. What DR model is he implementing?",
    "choice_a": "Hot site",
    "choice_b": "Active/active",
    "choice_c": "Warm site",
    "choice_d": "Active/passive",
    "correct_answer": "A",
    "explanation": "The hot site model is the most viable option given the requirements. A hot site is a fully functional backup site that can assume operations immediately should the primary location fail or go offline.",
    "topic_id": 1,
    "practice_test_id": 2,
    "related_articles": [
      135,
      146,
      141,
      138,
      143
    ],
    "source": "333776_AssessmentTest",
    "choice_e": "Cold site",
    "choice_f": "Rollover"
  },
  {
    "id": 53,
    "question": "You\u2019re researching data replication options for your SQL database. You\u2019ve decided to create a backup replica in a different availability zone that could become primary should the primary zone go offline. The replica iszupdated in near real time after the initial write operation on the primary database. What type of solution is this?",
    "choice_a": "Synchronous",
    "choice_b": "Asynchronous",
    "choice_c": "Volume sync",
    "choice_d": "Remote mirroring",
    "correct_answer": "B",
    "explanation": "Asynchronous replication is when data is written to the primary first, and then later a copy is written to the remote site on a scheduled arrangement or in near real time.",
    "topic_id": 1,
    "practice_test_id": 2,
    "related_articles": [
      131,
      21,
      135,
      141,
      71
    ],
    "source": "333776_AssessmentTest",
    "choice_e": "RAID 5"
  },
  {
    "id": 54,
    "question": "Pierre is deploying a solution that allows data for his e-commerce operations hosted in a public cloud to be reached at remote locations worldwide with local points of presence. He wants to reduce the load on his web servers and reduce the network latency of geographically distant customers. What are these facilities called?",
    "choice_a": "Regions",
    "choice_b": "Edge locations",
    "choice_c": "Availability zones",
    "choice_d": "Replication",
    "correct_answer": "B",
    "explanation": "Edge locations are not complete cloud data centers. There are cloud connection points located in major cities and offer local caching of data for reduced response times.",
    "topic_id": 1,
    "practice_test_id": 2,
    "related_articles": [
      40,
      131,
      146,
      16,
      18
    ],
    "source": "333776_AssessmentTest"
  },
  {
    "id": 55,
    "question": "Melinda is updating her firm\u2019s disaster recovery plans, and after receiving direction from her company\u2019s board of directors, she has been instructed to create a plan that restores operations within 48 hours of a disaster. What part of the plan should she update with the new requirements?",
    "choice_a": "RSO",
    "choice_b": "RPO",
    "choice_c": "RTO",
    "choice_d": "DBO",
    "correct_answer": "C",
    "explanation": "The recovery time objective is the amount of time a system can be offline during a disaster; it\u2019s the amount of time it takes to get a service online and available after a failure.",
    "topic_id": 1,
    "practice_test_id": 2,
    "related_articles": [
      135,
      141,
      143,
      146,
      21
    ],
    "source": "333776_AssessmentTest"
  },
  {
    "id": 56,
    "question": "Jillian is a Cloud+ consultant for an auto parts company based in central Michigan. She is putting together a disaster recovery plan that includes a remote backup site that has a SQL server instance running at that location with a synchronously refreshed data replica. Her plan calls for activating all other services in the event of a hurricane causing an outage at her primary data center. What model is Jillian going to deploy to meet the requirements?",
    "choice_a": "Hot site",
    "choice_b": "Warm site",
    "choice_c": "Cold site",
    "choice_d": "Active/passive",
    "correct_answer": "B",
    "explanation": "A warm site approach to recovering from a primary data center outage is when the remote backup of the site is offline except for critical data storage, which is usually a database.",
    "topic_id": 1,
    "practice_test_id": 2,
    "related_articles": [
      135,
      131,
      141,
      143,
      138
    ],
    "source": "333776_AssessmentTest"
  },
  {
    "id": 57,
    "question": "Pete has been busy updating the disaster recovery procedures for his client\u2019s business continuity plan. The DR facility will need to be ready with floor space, power, and cooling and have loading docks to unload server and equipment racks to restore service. What type of DR implementation is Pete planning on deploying?",
    "choice_a": "Hot site",
    "choice_b": "Active/active",
    "choice_c": "Warm site",
    "choice_d": "Active/passive",
    "correct_answer": "E",
    "explanation": "A cold site is a backup data center provisioned to take over operations in the event of a primary data center failure, but the servers and infrastructure are not deployed or operational until needed.",
    "topic_id": 1,
    "practice_test_id": 2,
    "related_articles": [
      135,
      143,
      141,
      146,
      16
    ],
    "source": "333776_AssessmentTest",
    "choice_e": "Cold site",
    "choice_f": "Rollover"
  },
  {
    "id": 58,
    "question": "Connie has been directed by her employer\u2019s finance department that they cannot afford to lose any more than 30 minutes of data in the case of a database failure or other catastrophic event. Connie has updated her corporate business continuity and disaster recovery plans. What metric did she change?",
    "choice_a": "RSO",
    "choice_b": "RPO",
    "choice_c": "RTO",
    "choice_d": "DBO",
    "correct_answer": "B",
    "explanation": "The restore point objective is the point in time that data can be recovered.",
    "topic_id": 1,
    "practice_test_id": 2,
    "related_articles": [
      135,
      131,
      141,
      143,
      21
    ],
    "source": "333776_AssessmentTest"
  },
  {
    "id": 59,
    "question": "Will is testing his backup DR site and using his DNS configuration to load-balance the primary and backup sites. He wants to verify that the database in the DR facility is updated in real time and remains current with the production replica in the primary data center. What type of updates should he define in his primary data center servers prior to enabling the DNS load balancing?",
    "choice_a": "Synchronous replication",
    "choice_b": "Asynchronous replication",
    "choice_c": "Volume sync",
    "choice_d": "Mirroring",
    "correct_answer": "A",
    "explanation": "Synchronous replication offerings write data to both the primary storage system and the replica simultaneously to ensure that the remote data is current with local replicas.",
    "topic_id": 1,
    "practice_test_id": 2,
    "related_articles": [
      131,
      135,
      18,
      70,
      113
    ],
    "source": "333776_AssessmentTest",
    "choice_e": "RAID 5"
  },
  {
    "id": 60,
    "question": "Leonard is creating disaster recovery documents for his company\u2019s online operations. He is documenting metrics for a measurable SLA that outlines when you can expect operations to be back online and how much data loss can be tolerated when recovering from an outage. Which metrics is he documenting? (Choose all that apply.)",
    "choice_a": "RSO",
    "choice_b": "RTO",
    "choice_c": "RPO",
    "choice_d": "DR",
    "correct_answer": [
      "B",
      "C"
    ],
    "explanation": "The restore point and restore time objectives are the measurements for the amount of data lost and the time needed to get back online after an outage.",
    "topic_id": 1,
    "practice_test_id": 2,
    "related_articles": [
      135,
      141,
      146,
      143,
      21
    ],
    "source": "333776_AssessmentTest",
    "choice_e": "VxRestore"
  },
  {
    "id": 61,
    "question": "The ability to dynamically add additional resources on demand such as storage, CPUs, memory, and even servers is referred to as what?",
    "choice_a": "Bursting",
    "choice_b": "Pooling",
    "choice_c": "Elasticity",
    "choice_d": "Orchestration",
    "correct_answer": "C",
    "explanation": "Cloud automation systems offer the ability to add and remove resources dynamically as needed; this is referred to as elasticity.",
    "topic_id": 1,
    "practice_test_id": 2,
    "related_articles": [
      8,
      3,
      10,
      55,
      43
    ],
    "source": "333776_AssessmentTest"
  },
  {
    "id": 62,
    "question": "Margo is reviewing the maintenance responsibilities between her company and its public cloud service provider. She notices that the cloud provider takes responsibility for the operating system, and her company assumes responsibility for all applications and services running on the operating system. What type of service model is she operating under?",
    "choice_a": "IaaS",
    "choice_b": "PaaS",
    "choice_c": "SaaS",
    "choice_d": "XaaS",
    "correct_answer": "B",
    "explanation": "With the PaaS model, the cloud provider will maintain the operating system and all supporting infrastructure.",
    "topic_id": 1,
    "practice_test_id": 2,
    "related_articles": [
      24,
      26,
      4,
      91,
      113
    ],
    "source": "333776_AssessmentTest"
  },
  {
    "id": 63,
    "question": "Which service model has the most lock-ins and is the most complex to migrate?",
    "choice_a": "IaaS",
    "choice_b": "PaaS",
    "choice_c": "SaaS",
    "choice_d": "XaaS",
    "correct_answer": "B",
    "explanation": "The higher up the services stack you go, from IaaS to PaaS to SaaS, the more difficult it will be to migrate. With IaaS, most of the cloud operations are under your direct control, which gives you the most flexibility to migrate. However, if the cloud provider controls the application, you may not have many migration options.",
    "topic_id": 1,
    "practice_test_id": 2,
    "related_articles": [
      4,
      24,
      26,
      91,
      35
    ],
    "source": "333776_AssessmentTest"
  },
  {
    "id": 64,
    "question": "Joe is in the planning stages to make sure that an upcoming company promotion during a major sporting event will not overwhelm his company\u2019s cloud-based e-commerce site. He needs to determine his options to add capacity to the web server farm so that it can process the anticipated additional workload. What do you recommend as possible solutions? (Choose three.)",
    "choice_a": "Vertical scaling",
    "choice_b": "Horizontal scaling",
    "choice_c": "Edge cache",
    "choice_d": "Cloud bursting",
    "correct_answer": [
      "B",
      "D",
      "E"
    ],
    "explanation": "Cloud computing operates with a utility business model that charges you only for the resources that you consume. This model enables you to scale your cloud fleet to meet its current workload and be able to add and remove capacity as needed. There are many options to use elasticity to scale cloud operations, including vertical and horizontal scaling and bursting.",
    "topic_id": 1,
    "practice_test_id": 2,
    "related_articles": [
      2,
      10,
      18,
      35,
      50
    ],
    "source": "333776_AssessmentTest",
    "choice_e": "Core elasticity"
  },
  {
    "id": 65,
    "question": "Janice manages the MySQL database back end that runs on a multi-CPU instance that has reached 100 percent utilization. The database can run on only a single server. What options does she have to support the requirements of this database?",
    "choice_a": "Horizontal scaling",
    "choice_b": "Vertical scaling",
    "choice_c": "Pooling",
    "choice_d": "Bursting",
    "correct_answer": "B",
    "explanation": "Scaling up, or vertical scaling, will add resources such as CPU instances or more RAM. When you scale up, you are increasing your compute, network, or storage capabilities.",
    "topic_id": 3,
    "practice_test_id": 2,
    "related_articles": [
      163,
      199,
      208,
      182,
      183
    ],
    "source": "333776_AssessmentTest"
  },
  {
    "id": 66,
    "question": "A popular e-commerce site is hosting its public-facing front-end web server fleet in a public cloud. You have been tasked with determining what the normal day-to-day web hit count is so that capacity plans for the upcoming holiday selling season can be assessed. You want to track incoming web requests and graph them against delayed and missed connection counts. What type of dataset are you producing?",
    "choice_a": "Metric",
    "choice_b": "Variance",
    "choice_c": "Baseline",
    "choice_d": "Smoothing",
    "correct_answer": "C",
    "explanation": "The establishment of average usage over time is the data that gets collected for a baseline report.",
    "topic_id": 3,
    "practice_test_id": 2,
    "related_articles": [
      157,
      175,
      161,
      178,
      34
    ],
    "source": "333776_AssessmentTest"
  },
  {
    "id": 67,
    "question": "Eva is the network architect for her company\u2019s large cloud deployment; she has interconnected her private cloud to a community cloud in another state. She is investigating using the community cloud to supplement her private cloud workload during end-of-month processing. What operation is she going to perform?",
    "choice_a": "Elasticity",
    "choice_b": "Cloud bursting",
    "choice_c": "Vertical scaling",
    "choice_d": "Autoscaling",
    "correct_answer": "B",
    "explanation": "Cloud bursting allows for adding capacity from another cloud service during times when additional resources are needed.",
    "topic_id": 1,
    "practice_test_id": 2,
    "related_articles": [
      35,
      2,
      8,
      16,
      21
    ],
    "source": "333776_AssessmentTest"
  },
  {
    "id": 68,
    "question": "CPU utilization on a database server has consistently been at more than 80 percent utilization. The baselines show that 57 percent utilization is normal. What is this called?",
    "choice_a": "Deviation",
    "choice_b": "Variance",
    "choice_c": "Triggers",
    "choice_d": "Baseline imbalance",
    "correct_answer": "B",
    "explanation": "The measurement of the difference between a current reading and the baseline value is referred to as the variance.",
    "topic_id": 3,
    "practice_test_id": 2,
    "related_articles": [
      175,
      177,
      51,
      161,
      34
    ],
    "source": "333776_AssessmentTest"
  },
  {
    "id": 69,
    "question": "Harold will modify an NACL to adjust remote access to a cloud-based HR application. He will be submitting a plan that outlines all details of the change. What process is he following?",
    "choice_a": "Cloud automation",
    "choice_b": "Change advisory",
    "choice_c": "Change management",
    "choice_d": "Rollout",
    "correct_answer": "C",
    "explanation": "Change management includes recording the change, planning for the change, testing the documentation, getting approvals, evaluating and validating, writing instructions for backing out the change if needed, and doing post-change review if desired.",
    "topic_id": 3,
    "practice_test_id": 2,
    "related_articles": [
      160,
      174,
      148,
      116,
      152
    ],
    "source": "333776_AssessmentTest"
  },
  {
    "id": 70,
    "question": "To increase TipoftheHat.com\u2019s security posture, Alice is reviewing user accounts that access the community cloud resources. Alice notices that the summer interns have left to go back to school but their accounts are still active. She knows that they will return over the winter break. What would you suggest that Alice do with these accounts?",
    "choice_a": "Do nothing.",
    "choice_b": "Delete the accounts.",
    "choice_c": "Disable the accounts.",
    "choice_d": "Change the resource access definitions.",
    "correct_answer": "C",
    "explanation": "The ability to disable an account can be helpful in situations where the account will need to be reactivated at a future date and does not need to be deleted.",
    "topic_id": 4,
    "practice_test_id": 2,
    "related_articles": [
      166,
      165,
      89,
      75,
      102
    ],
    "source": "333776_AssessmentTest",
    "choice_e": "Modify the confederation settings.",
    "choice_f": "Change the access control."
  },
  {
    "id": 71,
    "question": "Object tracking can be helpful in identifying which of the following? (Choose three.)",
    "choice_a": "Resiliency",
    "choice_b": "Trends",
    "choice_c": "Metrics",
    "choice_d": "ACLs",
    "correct_answer": [
      "B",
      "E",
      "F"
    ],
    "explanation": "Trends, usage, and deficiencies are all management report outputs that can be identified using object tracking.",
    "topic_id": 3,
    "practice_test_id": 2,
    "related_articles": [
      179,
      173,
      178,
      157,
      200
    ],
    "source": "333776_AssessmentTest",
    "choice_e": "Peak usage",
    "choice_f": "Anomalies"
  },
  {
    "id": 72,
    "question": "Capacity and utilization reporting often contains data on which of the following objects? (Choose three.)",
    "choice_a": "CPU",
    "choice_b": "OS version",
    "choice_c": "Volume tier",
    "choice_d": "RAM",
    "correct_answer": [
      "A",
      "D",
      "E"
    ],
    "explanation": "CPU, RAM, and network utilization are all important objects to manage for capacity and utilization tracking. Storage volume tiers and OS versions do not apply to this scenario.",
    "topic_id": 3,
    "practice_test_id": 2,
    "related_articles": [
      176,
      199,
      197,
      161,
      189
    ],
    "source": "333776_AssessmentTest",
    "choice_e": "Network"
  },
  {
    "id": 73,
    "question": "What does a cloud management system monitor to collect performance metrics?",
    "choice_a": "Database",
    "choice_b": "Server",
    "choice_c": "Hypervisor",
    "choice_d": "Objects",
    "correct_answer": "D",
    "explanation": "Objects are queried to gather metric data.",
    "topic_id": 3,
    "practice_test_id": 2,
    "related_articles": [
      34,
      173,
      157,
      105,
      183
    ],
    "source": "333776_AssessmentTest"
  },
  {
    "id": 74,
    "question": "Object tracking should be aligned with which of the following?",
    "choice_a": "VPC",
    "choice_b": "SLA",
    "choice_c": "RDP",
    "choice_d": "JSON",
    "correct_answer": "B",
    "explanation": "Tracking object performance data should match with the guaranteed levels outlined in the service level agreement.",
    "topic_id": 3,
    "practice_test_id": 2,
    "related_articles": [
      178,
      41,
      129,
      175,
      158
    ],
    "source": "333776_AssessmentTest"
  },
  {
    "id": 75,
    "question": "What is a visual representation of current cloud operations?",
    "choice_a": "Operational matrix",
    "choice_b": "Management console",
    "choice_c": "Dashboard",
    "choice_d": "Ticker",
    "correct_answer": "C",
    "explanation": "A dashboard is a configurable graphical representation of current operational data.",
    "topic_id": 3,
    "practice_test_id": 2,
    "related_articles": [
      105,
      34,
      173,
      157,
      183
    ],
    "source": "333776_AssessmentTest"
  },
  {
    "id": 76,
    "question": "Hanna is monitoring performance metrics on a video server; she sees that the server is utilizing 100 percent of the available network bandwidth. What action will most likely address the problem?",
    "choice_a": "Implement 802.1Q tagging.",
    "choice_b": "Install a second network adapter.",
    "choice_c": "Update the network adapter\u2019s firmware.",
    "choice_d": "Install a network coprocessor ASIC.",
    "correct_answer": "B",
    "explanation": "If a server is using all of its network bandwidth, then the most logical solution is to increase the network adapters\u2019 bandwidth or add a second adapter and create a teaming configuration.",
    "topic_id": 6,
    "practice_test_id": 2,
    "related_articles": [
      220,
      228,
      213,
      227,
      224
    ],
    "source": "333776_AssessmentTest"
  },
  {
    "id": 77,
    "question": "What type of scaling includes adding servers to a pool?",
    "choice_a": "Horizontal",
    "choice_b": "Round robin",
    "choice_c": "Elasticity",
    "choice_d": "Autoscale",
    "correct_answer": "A",
    "explanation": "Horizontal scaling is the process of adding servers to a pool for increased capacity. Round-robin is a load-balancing metric and does not apply. Elasticity is the ability to add and remove resources, autoscaling is the automated process of adding and removing capacity, and vertical scaling is expanding a server.",
    "topic_id": 3,
    "practice_test_id": 2,
    "related_articles": [
      163,
      182,
      208,
      183,
      164
    ],
    "source": "333776_AssessmentTest",
    "choice_e": "Vertical"
  },
  {
    "id": 78,
    "question": "What type of scaling involves replacing an existing server with another that has more capabilities?",
    "choice_a": "Horizontal",
    "choice_b": "Round robin",
    "choice_c": "Elasticity",
    "choice_d": "Autoscale",
    "correct_answer": "E",
    "explanation": "Vertical scaling is the process of upgrading or replacing a server with one that has greater capabilities.",
    "topic_id": 3,
    "practice_test_id": 2,
    "related_articles": [
      163,
      182,
      199,
      208,
      183
    ],
    "source": "333776_AssessmentTest",
    "choice_e": "Vertical"
  },
  {
    "id": 79,
    "question": "Ichika is preparing a change management plan to increase the processing abilities of one of her middleware servers. What components can she upgrade to increase server performance? (Choose three.)",
    "choice_a": "CPU",
    "choice_b": "SLA",
    "choice_c": "RAM",
    "choice_d": "Network I/O",
    "correct_answer": [
      "A",
      "C",
      "D"
    ],
    "explanation": "Server performance can be increased by adding CPU processing, memory, and network capacity. SLA, ACL, and DNS are not related to increasing server capacity.",
    "topic_id": 1,
    "practice_test_id": 2,
    "related_articles": [
      42,
      43,
      49,
      138,
      50
    ],
    "source": "333776_AssessmentTest",
    "choice_e": "ACL",
    "choice_f": "DNS"
  },
  {
    "id": 80,
    "question": "Niko is generating baseline reports for her quarterly review meeting. She is interested in a public cloud application server\u2019s memory utilization. Where does she generate these reports?",
    "choice_a": "Hypervisor",
    "choice_b": "Databases",
    "choice_c": "Logging servers",
    "choice_d": "Cloud management and monitoring application",
    "correct_answer": "D",
    "explanation": "Cloud reports are formatted collections of data contained in the management or monitoring applications.",
    "topic_id": 3,
    "practice_test_id": 2,
    "related_articles": [
      34,
      173,
      175,
      179,
      157
    ],
    "source": "333776_AssessmentTest"
  },
  {
    "id": 81,
    "question": "SaaS orchestration systems are whose responsibility in the public cloud?",
    "choice_a": "Customer",
    "choice_b": "Provider",
    "choice_c": "Automation vendor",
    "choice_d": "DevOps",
    "correct_answer": "B",
    "explanation": "The cloud service provider owns its automation and orchestration systems, and they cannot be directly accessed by the customer.",
    "topic_id": 1,
    "practice_test_id": 2,
    "related_articles": [
      24,
      4,
      26,
      91,
      8
    ],
    "source": "333776_AssessmentTest"
  },
  {
    "id": 82,
    "question": "What type of application commonly uses batch processing?",
    "choice_a": "DNS",
    "choice_b": "NTP",
    "choice_c": "Databases",
    "choice_d": "Middleware",
    "correct_answer": "C",
    "explanation": "It\u2019s common for batch processing to be performed on database applications.",
    "topic_id": 1,
    "practice_test_id": 2,
    "related_articles": [
      12,
      8,
      10,
      71,
      62
    ],
    "source": "333776_AssessmentTest"
  },
  {
    "id": 83,
    "question": "Giulia posted a new software update to her company\u2019s popular smartphone application. After announcing the release, she has been monitoring her dashboard information and has noticed a large spike in activity. What cloud resource should she focus on?",
    "choice_a": "CPU",
    "choice_b": "Network bandwidth",
    "choice_c": "RAM",
    "choice_d": "API",
    "correct_answer": "B",
    "explanation": "A large number of users downloading a new application would cause an increase in network bandwidth usage.",
    "topic_id": 1,
    "practice_test_id": 2,
    "related_articles": [
      138,
      40,
      49,
      27,
      18
    ],
    "source": "333776_AssessmentTest",
    "choice_e": "Storage"
  },
  {
    "id": 84,
    "question": "Cloud capacity can be measured by comparing current usage to what?",
    "choice_a": "Orchestration",
    "choice_b": "Automation",
    "choice_c": "NTP",
    "choice_d": "Baseline",
    "correct_answer": "D",
    "explanation": "A baseline measurement is used as a reference to determine cloud capacity increases and decreases.",
    "topic_id": 6,
    "practice_test_id": 2,
    "related_articles": [
      196,
      220,
      224,
      226,
      159
    ],
    "source": "333776_AssessmentTest",
    "choice_e": "APIs"
  },
  {
    "id": 85,
    "question": "Emma is modifying a publicly accessible IP subnet on her company\u2019s e-commerce site hosted in a hybrid cloud. After performing address changes for all of her public-facing web servers, she validated the change by connecting from a bastion host located offshore. She was unable to connect to the web servers. What does she need to modify to allow the remote site to connect to the web server?",
    "choice_a": "NTP",
    "choice_b": "STP",
    "choice_c": "DNS",
    "choice_d": "API",
    "correct_answer": "C",
    "explanation": "The Domain Name System records need to be changed to reflect the new IP address mapped to the domain name.",
    "topic_id": 6,
    "practice_test_id": 2,
    "related_articles": [
      214,
      205,
      204,
      209,
      227
    ],
    "source": "333776_AssessmentTest"
  },
  {
    "id": 86,
    "question": "Maria has noticed an increase in the response time of the NoSQL application she runs in her IaaS cloud deployment. When comparing current results against her baseline measurements that she recorded when the database was originally deployed, she verified that there has been a steady increase in the number of read requests. You have been asked to evaluate the baseline variances. Where should you focus your troubleshooting efforts?",
    "choice_a": "Memory",
    "choice_b": "CPU",
    "choice_c": "Storage",
    "choice_d": "Networking",
    "correct_answer": "C",
    "explanation": "Databases read and write requests utilize storage I/O and should be the focus for troubleshooting.",
    "topic_id": 1,
    "practice_test_id": 2,
    "related_articles": [
      62,
      52,
      12,
      8,
      42
    ],
    "source": "333776_AssessmentTest"
  },
  {
    "id": 87,
    "question": "Derek is monitoring storage volume utilization and is preparing a company change request to add storage capacity. He has decided to automate the volume allocation size. What cloud feature can he take advantage of?",
    "choice_a": "SaaS",
    "choice_b": "API",
    "choice_c": "Elasticity",
    "choice_d": "OpenStack",
    "correct_answer": "C",
    "explanation": "Elasticity allows for cloud services to expand and contract based on actual usage and would be applicable to increasing storage capacity.",
    "topic_id": 3,
    "practice_test_id": 2,
    "related_articles": [
      22,
      164,
      200,
      14,
      105
    ],
    "source": "333776_AssessmentTest"
  },
  {
    "id": 88,
    "question": "What application tracks a process from start to finish?",
    "choice_a": "API",
    "choice_b": "NTP",
    "choice_c": "Workflow",
    "choice_d": "Orchestration",
    "correct_answer": "C",
    "explanation": "Workflow applications track a process from start to finish and sequence the applications that are required to complete the process.",
    "topic_id": 1,
    "practice_test_id": 2,
    "related_articles": [
      8,
      4,
      26,
      24,
      47
    ],
    "source": "333776_AssessmentTest"
  },
  {
    "id": 89,
    "question": "Common cloud resources in your deployment that may saturate over time include which of the following? (Choose three.)",
    "choice_a": "RAM",
    "choice_b": "Power",
    "choice_c": "CPU",
    "choice_d": "Storage",
    "correct_answer": [
      "A",
      "C",
      "D"
    ],
    "explanation": "Resources such as the amount of RAM needed, CPU cycles, and storage capacity are common systems that may become saturated as your cloud compute requirements grow.",
    "topic_id": 5,
    "practice_test_id": 2,
    "related_articles": [
      103,
      117,
      121
    ],
    "source": "333776_AssessmentTest",
    "choice_e": "Monitoring",
    "choice_f": "IaaS"
  },
  {
    "id": 90,
    "question": "Homer designed an application tier for his company\u2019s new e-commerce site. He decided on an IP subnet that uses the /28 IPv4 subnet. He is planning for a maximum of 14 servers. You are brought in as a cloud architect to validate his design. What other devices may be on this subnet other than the servers that would also require IP address assignments? (Choose two.)",
    "choice_a": "SLA",
    "choice_b": "Default gateway",
    "choice_c": "DNS",
    "choice_d": "NTP",
    "correct_answer": [
      "B",
      "C"
    ],
    "explanation": "In addition to the web servers, IP addresses may be required for the DNS server and the default gateway.",
    "topic_id": 1,
    "practice_test_id": 2,
    "related_articles": [
      70,
      39,
      11,
      36,
      8
    ],
    "source": "333776_AssessmentTest",
    "choice_e": "API",
    "choice_f": "SNMP"
  },
  {
    "id": 91,
    "question": "Elena manages user accounts for her company\u2019s cloud presence. She has a trouble ticket open with Jill to assist her in accessing an SSD storage volume in the San Paulo region of the public cloud. What kind of user issue is she investigating?",
    "choice_a": "Authentication",
    "choice_b": "Authorization",
    "choice_c": "Federation",
    "choice_d": "SSO",
    "correct_answer": "B",
    "explanation": "The question is asking about being able to access a specific cloud service. This would concern Jill having the authorization to access the storage volume. Authentication and SSO are login systems and not rights to services. A federation links user databases.",
    "topic_id": 4,
    "practice_test_id": 2,
    "related_articles": [
      92,
      68,
      167,
      60,
      69
    ],
    "source": "333776_AssessmentTest"
  },
  {
    "id": 92,
    "question": "Emma is unable to reach her Linux-based web server hosted in the Singapore zone of the cloud. She is located in Austin, Texas. What command can she use to verify the connection path?",
    "choice_a": "<code>traceroute</code>",
    "choice_b": "<code>ipconfig</code>",
    "choice_c": "<code>arp</code>",
    "choice_d": "<code>netstat</code>",
    "correct_answer": "A",
    "explanation": "The <code>tracert</code> and <code>traceroute</code> commands are useful for network path troubleshooting. These commands show the routed path a packet of data takes from source to destination. You can use them to determine whether routing is working as expected or whether there is a route failure in the path. The other options are all incorrect because they do not provide network path data.",
    "topic_id": 6,
    "practice_test_id": 2,
    "related_articles": [
      217,
      188,
      211,
      226,
      209
    ],
    "source": "333776_AssessmentTest",
    "choice_e": "<code>ping</code>",
    "choice_f": "<code>tcpdump</code>",
    "choice_g": "<code>route print</code>"
  },
  {
    "id": 93,
    "question": "After deploying a new public website, your validation steps ask you to check the domain name\u2013to\u2013IP address mappings. What utility can you use for validation? (Choose two.)",
    "choice_a": "RDP",
    "choice_b": "dig",
    "choice_c": "SSH",
    "choice_d": "nslookup",
    "correct_answer": [
      "B",
      "D"
    ],
    "explanation": "The Windows command-line utility nslookup resolves domain names to IP addressing. The Linux equivalent is the <code>dig</code> command. The other options are not valid for the solution required in the question.",
    "topic_id": 6,
    "practice_test_id": 2,
    "related_articles": [
      214,
      217,
      205,
      209,
      227
    ],
    "source": "333776_AssessmentTest",
    "choice_e": "IPsec",
    "choice_f": "IPS"
  },
  {
    "id": 94,
    "question": "Nicola is deploying a new fleet of IIS web servers on his IaaS e-commerce site. The company has elected to use a hybrid approach and wants graphical connections to the Windows bastion hosts. What traffic must he permit through the external-facing firewall to the host?",
    "choice_a": "SSH",
    "choice_b": "RDP",
    "choice_c": "DNS",
    "choice_d": "IPS",
    "correct_answer": "B",
    "explanation": "The Windows Remote Desktop Protocol allows for remote connections to a Windows graphical user desktop.",
    "topic_id": 4,
    "practice_test_id": 2,
    "related_articles": [
      86,
      37,
      38,
      75,
      111
    ],
    "source": "333776_AssessmentTest"
  },
  {
    "id": 95,
    "question": "Martina is troubleshooting a networking problem and needs to capture network frames being sent and received from the server\u2019s network adapter. What command would she use to collect the traces?",
    "choice_a": "<code>dig</code>",
    "choice_b": "<code>netstat</code>",
    "choice_c": "<code>tcpdump</code>",
    "choice_d": "<code>nslookup</code>",
    "correct_answer": "C",
    "explanation": "The tcpdump utility allows a Linux system to capture live network traffic, and it is useful in monitoring and troubleshooting. Think of tcpdump as a command-line network analyzer. The <code>dig</code> and <code>nslookup</code> commands show DNS resolution but do not display the actual packets going across the wire. <code>netstat</code> shows connection information and is not DNS related.",
    "topic_id": 6,
    "practice_test_id": 2,
    "related_articles": [
      217,
      214,
      209,
      188,
      226
    ],
    "source": "333776_AssessmentTest"
  },
  {
    "id": 96,
    "question": "The remote disaster recovery location follows the warm site model. To configure the network switches, routers, and firewalls remotely, Joyce will need serial port access from her company\u2019s operations center. She has 14 serial ports currently available but needs to be prepared for any unplanned expansion requirements during a disaster recovery cutover. What device would you recommend that she install at the warm site?",
    "choice_a": "RDP",
    "choice_b": "Telnet",
    "choice_c": "IPsec",
    "choice_d": "SSH",
    "correct_answer": "E",
    "explanation": "In a data center, terminal servers are deployed and have several serial ports, each cabled to a console port on a device that is being managed. This allows you to make an SSH or a Telnet connection to the terminal server and then use the serial interfaces to access the console ports on the devices to which you want to connect. The other options do not provide serial port connections.",
    "topic_id": 1,
    "practice_test_id": 2,
    "related_articles": [
      27,
      146,
      135,
      16,
      8
    ],
    "source": "333776_AssessmentTest",
    "choice_e": "Terminal server"
  },
  {
    "id": 97,
    "question": "The cloud data center is in a large industrial park with no company signage, extensive video cameras in the parking lot, high-security fences, and biometrics at the guard shack. What type of security is the provider implementing?",
    "choice_a": "Building",
    "choice_b": "Device",
    "choice_c": "Infrastructure",
    "choice_d": "Tunneling",
    "correct_answer": "C",
    "explanation": "Infrastructure security is the hardening of the facility and includes the steps outlined in the question, including nondescript facilities, video surveillance, and biometric access.",
    "topic_id": 4,
    "practice_test_id": 2,
    "related_articles": [
      89,
      75,
      73,
      37,
      88
    ],
    "source": "333776_AssessmentTest"
  },
  {
    "id": 98,
    "question": "Mergie is documenting different methods that her remote operations center can use to access a fleet of servers operating in a community cloud. Which of the following are not viable methods? (Choose two.)",
    "choice_a": "RDP",
    "choice_b": "Telnet",
    "choice_c": "IDS/IPS",
    "choice_d": "Terminal server",
    "correct_answer": [
      "C",
      "E"
    ],
    "explanation": "Common remote access tools include RDP, SSH, and terminal servers. IDSs/IPSs are for intrusion detection, and DNS is for domain name\u2013to\u2013IP address mappings and is not a utility for remote access.",
    "topic_id": 4,
    "practice_test_id": 2,
    "related_articles": [
      86,
      107,
      69,
      165,
      37
    ],
    "source": "333776_AssessmentTest",
    "choice_e": "DNS",
    "choice_f": "HTTP"
  },
  {
    "id": 99,
    "question": "Vasile is working a support ticket that shows the connection between the Ames field office and the Kansas City cloud edge location has dropped. She confirms it\u2019s a secure Internet-based access solution. What type of connection is this?",
    "choice_a": "Direct peering",
    "choice_b": "IDS",
    "choice_c": "VPN",
    "choice_d": "AES-256",
    "correct_answer": "C",
    "explanation": "A secure Internet-based connection would be a VPN.",
    "topic_id": 1,
    "practice_test_id": 2,
    "related_articles": [
      16,
      11,
      27,
      36,
      8
    ],
    "source": "333776_AssessmentTest",
    "choice_e": "RDP"
  },
  {
    "id": 100,
    "question": "Company users are complaining that they cannot log into a cloud-based collaboration system. The operations center has been investigating and has, so far, verified that the MFA applications are operational. What user system are they troubleshooting?",
    "choice_a": "Authentication",
    "choice_b": "Authorization",
    "choice_c": "Federation",
    "choice_d": "Kerberos",
    "correct_answer": "A",
    "explanation": "Logging into systems is referred to as authentication. Also, the question references multifactor authentication (MFA) as part of the system.",
    "topic_id": 4,
    "practice_test_id": 2,
    "related_articles": [
      101,
      95,
      165,
      92,
      97
    ],
    "source": "333776_AssessmentTest"
  },
  {
    "id": 101,
    "question": "What cloud model gives you complete control of the operating system?",
    "choice_a": "IaaS",
    "choice_b": "PaaS",
    "choice_c": "SaaS",
    "choice_d": "CaaS",
    "correct_answer": "A",
    "explanation": "Infrastructure as a service (IaaS) gives you complete control of the operating system.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      4,
      26,
      24,
      91,
      8
    ],
    "source": "333776_Ch01"
  },
  {
    "id": 102,
    "question": "A cloud service provider allocates resources into a group. These resources are then dynamically allocated and reallocated as the demand requires. What is this referred to as?",
    "choice_a": "On-demand virtualization",
    "choice_b": "Dynamic scaling",
    "choice_c": "Resource pooling",
    "choice_d": "Elasticity",
    "correct_answer": "C",
    "explanation": "Resource pooling is the allocation of compute resources into a group or pool; these pools are then made available to a multitenant cloud environment.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      10,
      3,
      8,
      27,
      11
    ],
    "source": "333776_Ch01"
  },
  {
    "id": 103,
    "question": "What are three examples of IaaS elements you can provision in the cloud? (Choose three.)",
    "choice_a": "CPU",
    "choice_b": "OS ACLs",
    "choice_c": "Memory",
    "choice_d": "Storage",
    "correct_answer": [
      "A",
      "C",
      "D"
    ],
    "explanation": "Elements and objects are examples of devices and systems in the cloud. In this question, the elements are CPU, memory, and storage.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      4,
      26,
      42,
      43,
      10
    ],
    "source": "333776_Ch01",
    "choice_e": "Scalability",
    "choice_f": "SSH"
  },
  {
    "id": 104,
    "question": "Which of the following is not a valid pooled resource?",
    "choice_a": "Memory",
    "choice_b": "Storage",
    "choice_c": "Security",
    "choice_d": "Networking",
    "correct_answer": "C",
    "explanation": "Pooled virtual resources include memory, storage, networking, and CPU. Security is a concept and not a physical resource that can be pooled.",
    "topic_id": 1,
    "practice_test_id": 4,
    "related_articles": [
      10,
      8,
      3,
      42,
      55
    ],
    "source": "333776_Ch01",
    "choice_e": "CPU"
  },
  {
    "id": 105,
    "question": "What technologies are used to enable on-demand computing? (Choose two.)",
    "choice_a": "Load balancing",
    "choice_b": "Automation",
    "choice_c": "Autoscaling groups",
    "choice_d": "Virtualization",
    "correct_answer": [
      "B",
      "D"
    ],
    "explanation": "One of the prime advantages of cloud-based computing and the automation and virtualization it offers in the background is the ability to leverage the rapid provisioning of virtual resources to allow for on-demand computing.",
    "topic_id": 1,
    "practice_test_id": 7,
    "related_articles": [
      3,
      10,
      47,
      8,
      2
    ],
    "source": "333776_Ch01"
  },
  {
    "id": 106,
    "question": "When you migrate your operations to the cloud and you decide to match computing resources with your current requirements, what can you take advantage of to expand your compute capacity in the future? (Choose three.)",
    "choice_a": "Elasticity",
    "choice_b": "On-demand computing",
    "choice_c": "Availability zones",
    "choice_d": "Resiliency virtualization",
    "correct_answer": [
      "A",
      "B",
      "E"
    ],
    "explanation": "Elasticity, on-demand-computing, and pay-as-you-grow are all examples of being able to expand cloud compute resources as your needs require.",
    "topic_id": 3,
    "practice_test_id": 7,
    "related_articles": [
      22,
      14,
      163,
      199,
      208
    ],
    "source": "333776_Ch01",
    "choice_e": "Pay-as-you grow",
    "choice_f": "Regions"
  },
  {
    "id": 107,
    "question": "Your company has decided to use one cloud provider for a production application while using a different cloud provider for storing backups. What type of cloud delivery model is this?",
    "choice_a": "Public",
    "choice_b": "Hybrid",
    "choice_c": "Community",
    "choice_d": "Private",
    "correct_answer": "B",
    "explanation": "The interconnection of multiple cloud providers is referred to as a hybrid cloud.",
    "topic_id": 2,
    "practice_test_id": 5,
    "related_articles": [
      5,
      96,
      72,
      65,
      28
    ],
    "source": "333776_Ch01"
  },
  {
    "id": 108,
    "question": "In a traditional virtualized data center, what shared network resource do VMs on the same host use to communicate with each other?",
    "choice_a": "Virtual NIC",
    "choice_b": "Region",
    "choice_c": "Virtual switch",
    "choice_d": "LAN",
    "correct_answer": "C",
    "explanation": "A virtual switch is a virtual resource that\u2019s associated with one or more physical network interfaces on the host. VMs can connect to a virtual switch to connect to each other or to an external network.",
    "topic_id": 1,
    "practice_test_id": 7,
    "related_articles": [
      3,
      10,
      27,
      49,
      71
    ],
    "source": "333776_Ch01"
  },
  {
    "id": 109,
    "question": "Which cloud characteristic allows you to pay for only the services used?",
    "choice_a": "Bursting",
    "choice_b": "Pay-as-you-grow",
    "choice_c": "Chargeback",
    "choice_d": "Autoscaling",
    "correct_answer": "B",
    "explanation": "The pay-as-you-grow cloud characteristic allows billing for only the services used.",
    "topic_id": 1,
    "practice_test_id": 4,
    "related_articles": [
      2,
      50,
      8,
      10,
      35
    ],
    "source": "333776_Ch01"
  },
  {
    "id": 110,
    "question": "When migrating an application from the data center to the cloud, which of the following is a best practice?",
    "choice_a": "Deploy to a test environment to validate functionality and performance",
    "choice_b": "Deploy directly to production so that end users can immediately report any problems",
    "choice_c": "Clone the VM running the application and upload it to the cloud",
    "choice_d": "Copy the application files to a fresh VM running in the cloud",
    "correct_answer": "A",
    "explanation": "It is best practice to split operations into different and isolated sections of the cloud for testing and isolation.",
    "topic_id": 2,
    "practice_test_id": 3,
    "related_articles": [
      13,
      25,
      6,
      67,
      31
    ],
    "source": "333776_Ch01"
  },
  {
    "id": 111,
    "question": "Which cloud characteristic allows you to access a self-service portal to create additional servers, storage, or other services instantly?",
    "choice_a": "Bursting",
    "choice_b": "Pay-as-you-grow",
    "choice_c": "Multitenancy",
    "choice_d": "On-demand",
    "correct_answer": "D",
    "explanation": "On-demand cloud computing allows the consumer to add and change resources dynamically with the use of an online portal.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      2,
      4,
      10,
      27,
      24
    ],
    "source": "333776_Ch01"
  },
  {
    "id": 112,
    "question": "In which cloud service model does the provider handle everything up to and including the application?",
    "choice_a": "IaaS",
    "choice_b": "PaaS",
    "choice_c": "SaaS",
    "choice_d": "ZaaS",
    "correct_answer": "C",
    "explanation": "Software as a Service offers cloud-managed applications as well as the underlying platform and infrastructure support.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      4,
      26,
      24,
      91,
      1
    ],
    "source": "333776_Ch01"
  },
  {
    "id": 113,
    "question": "Which of the following metrics can you typically monitor in the cloud? (Choose two.)",
    "choice_a": "Network latency",
    "choice_b": "Physical CPU host utilization",
    "choice_c": "The number of available physical virtualization hosts",
    "choice_d": "Inter-availability zone latency",
    "correct_answer": [
      "A",
      "E"
    ],
    "explanation": "Network delays, storage input/output performance, swap file usage, and the ability to scale are all examples of cloud performance components. Firewalls and encryption are security components, IaaS is a service model, and memory pooling is not relevant to the question.",
    "topic_id": 3,
    "practice_test_id": 5,
    "related_articles": [
      176,
      15,
      183,
      157,
      163
    ],
    "source": "333776_Ch01",
    "choice_e": "Storage I/O operations per second"
  },
  {
    "id": 114,
    "question": "Cloud service providers will often segment their operations to allow for resiliency, geographic proximity, and data protection regulations. What are these geographical segmentations referred to as?",
    "choice_a": "Regions",
    "choice_b": "Autoscaling groups",
    "choice_c": "Availability zones",
    "choice_d": "Global DNS affinity",
    "correct_answer": "A",
    "explanation": "Cloud operators segment their operations into regions for customer proximity, regulatory compliance, and resiliency.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      21,
      143,
      141,
      146,
      131
    ],
    "source": "333776_Ch01"
  },
  {
    "id": 115,
    "question": "What are critical steps to take prior to performing a migration to the cloud? (Choose three.)",
    "choice_a": "Baselines",
    "choice_b": "Capacity requirements",
    "choice_c": "Variance measurements",
    "choice_d": "Documentation",
    "correct_answer": [
      "A",
      "B",
      "D"
    ],
    "explanation": "Prior to performing a cloud migration, baseline measurements, a determination of capacity requirements, and complete documentation are all requirements for success.",
    "topic_id": 2,
    "practice_test_id": 1,
    "related_articles": [
      6,
      64,
      32,
      25,
      66
    ],
    "source": "333776_Ch01",
    "choice_e": "Automation rollout"
  },
  {
    "id": 116,
    "question": "Cloud operations are the responsibility of both your organization and the cloud service provider. What is this model called?",
    "choice_a": "Availability zone model",
    "choice_b": "Community model",
    "choice_c": "Shared responsibility model",
    "choice_d": "Shared regional model",
    "correct_answer": "C",
    "explanation": "The shared responsibility model outlines for which services and portions of the cloud operations the cloud consumer and provider are responsible.",
    "topic_id": 1,
    "practice_test_id": 6,
    "related_articles": [
      24,
      4,
      26,
      91,
      113
    ],
    "source": "333776_Ch01"
  },
  {
    "id": 117,
    "question": "What is the process of testing your cloud access to determine whether there is any vulnerability that an attacker could exploit?",
    "choice_a": "Elasticity",
    "choice_b": "Heat testing",
    "choice_c": "Penetration testing",
    "choice_d": "Load testing",
    "correct_answer": "C",
    "explanation": "Penetration testing is the process of trying to exploit vulnerabilities that exist in your infrastructure.",
    "topic_id": 2,
    "practice_test_id": 4,
    "related_articles": [
      19,
      25,
      13,
      67,
      72
    ],
    "source": "333776_Ch01"
  },
  {
    "id": 118,
    "question": "A hospital wants to use a medical records application but must minimize its capital expenditure, minimize ongoing maintenance, and comply with various regulations. What type of cloud service model and cloud delivery model would you recommend that they use? (Choose two.)",
    "choice_a": "Hybrid",
    "choice_b": "SaaS",
    "choice_c": "Community",
    "choice_d": "Private",
    "correct_answer": [
      "B",
      "C"
    ],
    "explanation": "Community clouds are offered for a specific community of interest and shared by companies with similar requirements for regulatory compliance, security, or policy. Because in the SaaS model the cloud provider fully manages the app, they\u2019re responsible for the ongoing maintenance of it.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      35,
      4,
      26,
      24,
      2
    ],
    "source": "333776_Ch01",
    "choice_e": "IaaS"
  },
  {
    "id": 119,
    "question": "What systems do cloud providers implement for rapid deployment of customer-requested services?",
    "choice_a": "RDMS",
    "choice_b": "Orchestration",
    "choice_c": "On-demand provisions",
    "choice_d": "Service catalogs",
    "correct_answer": "B",
    "explanation": "Orchestration platforms automate the provisioning of cloud services and often include a self-service dashboard that allows the consumer to manage and deploy cloud services with a web browser. The automation used by cloud providers allows for fast deployment of new services and applications.",
    "topic_id": 2,
    "practice_test_id": 3,
    "related_articles": [
      120,
      33,
      20,
      45,
      194
    ],
    "source": "333776_Ch01"
  },
  {
    "id": 120,
    "question": "In which cloud service model does the provider manage everything except the application?",
    "choice_a": "IaaS",
    "choice_b": "PaaS",
    "choice_c": "SaaS",
    "choice_d": "CaaS",
    "correct_answer": "B",
    "explanation": "Platform as a Service offers computing hardware, storage, networking, and the operating systems but not the application software.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      4,
      26,
      24,
      91,
      8
    ],
    "source": "333776_Ch01"
  },
  {
    "id": 121,
    "question": "Carl is documenting his employer\u2019s cloud deployments and needs to label the cloud delivery model used by his single organization. As a Cloud+ consultant, what would you suggest he name his internal cloud?",
    "choice_a": "Hybrid",
    "choice_b": "Public",
    "choice_c": "Private",
    "choice_d": "Community",
    "correct_answer": "C",
    "explanation": "A private cloud is used exclusively by a single organization.",
    "topic_id": 2,
    "practice_test_id": 5,
    "related_articles": [
      5,
      96,
      32,
      28,
      6
    ],
    "source": "333776_Ch02"
  },
  {
    "id": 122,
    "question": "A national tax preparation firm is accessing industry-specific productivity applications in the cloud; many other tax preparation companies are also subscribing to the same service. What model of cloud are they accessing?",
    "choice_a": "Hybrid",
    "choice_b": "Public",
    "choice_c": "Private",
    "choice_d": "Community",
    "correct_answer": "D",
    "explanation": "A community cloud is used by companies with similar needs such as medical or financial services.",
    "topic_id": 2,
    "practice_test_id": 5,
    "related_articles": [
      5,
      96,
      7,
      6,
      30
    ],
    "source": "333776_Ch02"
  },
  {
    "id": 123,
    "question": "Mary is a Cloud+ certified security consultant for her company. She is researching enhanced security access systems. What could she suggest that requires something you have and something you know?",
    "choice_a": "Single sign-on",
    "choice_b": "Confederations",
    "choice_c": "Active Directory/LDAP",
    "choice_d": "Multifactor",
    "correct_answer": "D",
    "explanation": "Multifactor authentication systems use a token generator as something that you have and a PIN/password as something you know.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      101,
      95,
      97,
      92,
      69
    ],
    "source": "333776_Ch02"
  },
  {
    "id": 124,
    "question": "Pete is concerned about stored data that is replicated to a standby zone but not immediately. The delay means that there is going to be a short period of time where the data is not consistent. What storage replication service ensures eventual consistency?",
    "choice_a": "Synchronous",
    "choice_b": "Asynchronous",
    "choice_c": "Block",
    "choice_d": "Tier 1",
    "correct_answer": "B",
    "explanation": "With asynchronous replication, there will be a delay as the data is copied to the backup site and provides eventual consistency as it uses a store-and-forward design. The backup storage array is normally several transactions behind the primary.",
    "topic_id": 1,
    "practice_test_id": 3,
    "related_articles": [
      131,
      135,
      141,
      21,
      71
    ],
    "source": "333776_Ch02",
    "choice_e": "File-based",
    "choice_f": "RAID 6"
  },
  {
    "id": 125,
    "question": "Scott is planning his company\u2019s upload of stored data to the cloud. What are two common storage migration types? (Choose two.)",
    "choice_a": "Physical to virtual",
    "choice_b": "Block to object",
    "choice_c": "Online",
    "choice_d": "Offline",
    "correct_answer": [
      "C",
      "D"
    ],
    "explanation": "When migrating stored data to the cloud, the two available options are online and offline.",
    "topic_id": 2,
    "practice_test_id": 3,
    "related_articles": [
      31,
      66,
      67,
      6,
      28
    ],
    "source": "333776_Ch02",
    "choice_e": "Synchronous",
    "choice_f": "Asynchronous"
  },
  {
    "id": 126,
    "question": "Judy is migrating a Linux OS from running on a dual-slot, eight-core server in a private cloud to a VM in the public cloud. What type of migration would she perform?",
    "choice_a": "vMotion",
    "choice_b": "P2V",
    "choice_c": "Private to public",
    "choice_d": "V2V",
    "correct_answer": "B",
    "explanation": "When migrating a server that is running on bare metal to a hypervisor-based system, you would be performing a physical-to-virtual migration.",
    "topic_id": 2,
    "practice_test_id": 1,
    "related_articles": [
      28,
      64,
      63,
      72,
      66
    ],
    "source": "333776_Ch02",
    "choice_e": "Synchronous replication"
  },
  {
    "id": 127,
    "question": "Christina has been asked by the firewall administration group to identify secure network protocols that can be used to prevent network analyzers from being able to read data in flight. Which of the following are considered secure network protocols that she recommends using? (Choose three.)",
    "choice_a": "SHHTP",
    "choice_b": "DHCP",
    "choice_c": "HTTPS",
    "choice_d": "DNS",
    "correct_answer": [
      "C",
      "E",
      "G"
    ],
    "explanation": "HTTPS, SSH, and FTPS all provide encrypted transmission of data.",
    "topic_id": 4,
    "practice_test_id": 3,
    "related_articles": [
      86,
      80,
      57,
      83,
      100
    ],
    "source": "333776_Ch02",
    "choice_e": "SSH",
    "choice_f": "SMTP",
    "choice_g": "FTPS"
  },
  {
    "id": 128,
    "question": "What technique makes it difficult for malicious hackers or hijackers to use or understand stolen data?",
    "choice_a": "PKI",
    "choice_b": "Obfuscation",
    "choice_c": "Cipher",
    "choice_d": "Symmetrical",
    "correct_answer": "B",
    "explanation": "Obfuscation is a technique to make information difficult to understand. One example of obfuscation is using random strings for usernames instead of obvious names like \u201cadmin.\u201d.",
    "topic_id": 4,
    "practice_test_id": 4,
    "related_articles": [
      60,
      78,
      57,
      81,
      82
    ],
    "source": "333776_Ch02"
  },
  {
    "id": 129,
    "question": "Jerri is learning about cloud storage systems. She is interested in learning about high-speed network storage solutions. What would you recommend she focus her research on?",
    "choice_a": "Block access",
    "choice_b": "Zoning",
    "choice_c": "VMFS",
    "choice_d": "SAN",
    "correct_answer": "D",
    "explanation": "A storage area network (SAN) is a high-speed network dedicated to storage transfers across a shared network. Block access is not a networking technology. Zoning is for restricting LUNs in a SAN, and VMFS is a VMware filesystem.",
    "topic_id": 1,
    "practice_test_id": 5,
    "related_articles": [
      53,
      71,
      12,
      55,
      62
    ],
    "source": "333776_Ch02"
  },
  {
    "id": 130,
    "question": "What is the process of determining the identity of a client usually by a login process?",
    "choice_a": "Authorization",
    "choice_b": "Accounting",
    "choice_c": "Authentication",
    "choice_d": "Federation",
    "correct_answer": "C",
    "explanation": "Authentication is the term used to describe the process of determining the identity of a user or device.",
    "topic_id": 4,
    "practice_test_id": 4,
    "related_articles": [
      69,
      165,
      92,
      109,
      101
    ],
    "source": "333776_Ch02",
    "choice_e": "Identity access"
  },
  {
    "id": 131,
    "question": "What are common management interfaces that are used to migrate and manage cloud-based resources? (Choose three.)",
    "choice_a": "Web console",
    "choice_b": "SNMP",
    "choice_c": "API",
    "choice_d": "PaaS",
    "correct_answer": [
      "A",
      "C",
      "E"
    ],
    "explanation": "Application programming interfaces (APIs), command-line interfaces (CLI), and GUI-based interfaces are all commonly used tools to migrate, monitor, manage, and troubleshoot cloud-based resources.",
    "topic_id": 4,
    "practice_test_id": 1,
    "related_articles": [
      87,
      106,
      165,
      167,
      75
    ],
    "source": "333776_Ch02",
    "choice_e": "CLI"
  },
  {
    "id": 132,
    "question": "VMs running on a hypervisor consume which of the following resources? (Choose three.)",
    "choice_a": "Bare-metal cores",
    "choice_b": "Virtual RAM",
    "choice_c": "SaaS",
    "choice_d": "Virtual CPUs",
    "correct_answer": [
      "B",
      "D",
      "F"
    ],
    "explanation": "A virtual machine will consume virtualized resources, including virtual RAM, virtual CPUs, and memory pools.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      42,
      10,
      3,
      71,
      44
    ],
    "source": "333776_Ch02",
    "choice_e": "RAID",
    "choice_f": "Memory pools"
  },
  {
    "id": 133,
    "question": "What system was developed to address the different types of storage needs a cloud consumer may require for availability, response times, backups, and economics?",
    "choice_a": "RAID",
    "choice_b": "Multipathing",
    "choice_c": "Tiering",
    "choice_d": "Policies",
    "correct_answer": "C",
    "explanation": "Tiering is the process of defining the storage needs of the cloud customer and aligning them with the cloud provider\u2019s offerings. RAID is a hardware storage family of redundancy types. Multipathing is a redundant SAN technique, and policies are not related to the question.",
    "topic_id": 1,
    "practice_test_id": 5,
    "related_articles": [
      58,
      62,
      52,
      50,
      12
    ],
    "source": "333776_Ch02"
  },
  {
    "id": 134,
    "question": "Samira is planning on implementing physical disk redundancy on her SQL database in the public cloud. She is creating specifications for her virtual machine image that will become the template for the database servers. What type of disk redundancy options could she implement to meet the needs of a SQL deployment?",
    "choice_a": "Multipathing",
    "choice_b": "RAID",
    "choice_c": "Masking",
    "choice_d": "Tiering",
    "correct_answer": "B",
    "explanation": "RAID combines physical disks for redundancy and performance. Multipathing is a redundancy SAN design, masking is a LUN access process, and tiering is a storage hierarchy technique.",
    "topic_id": 1,
    "practice_test_id": 5,
    "related_articles": [
      53,
      55,
      62,
      71,
      12
    ],
    "source": "333776_Ch02"
  },
  {
    "id": 135,
    "question": "Which storage type stripes file data and performs a parity check of data over multiple disks that can recover from a hard disk failure?",
    "choice_a": "RAID 0",
    "choice_b": "RAID 1",
    "choice_c": "RAID 1+0",
    "choice_d": "RAID 5",
    "correct_answer": "D",
    "explanation": "RAID 5 has parity information that is striped across multiple drives, which allows the drive array to be rebuilt if a single drive in the array fails. The other options do not have parity data.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      52,
      12,
      62,
      53,
      71
    ],
    "source": "333776_Ch02"
  },
  {
    "id": 136,
    "question": "Jill is reviewing a document from her secondary community cloud provider. What is the document that outlines specific metrics and the minimum performance that is offered by the cloud provider?",
    "choice_a": "SSL",
    "choice_b": "SLA",
    "choice_c": "Benchmark",
    "choice_d": "Baseline",
    "correct_answer": "B",
    "explanation": "The service level agreement (SLA) outlines specific metrics and the minimum performance provided by the cloud provider.",
    "topic_id": 1,
    "practice_test_id": 7,
    "related_articles": [
      141,
      26,
      24,
      91,
      1
    ],
    "source": "333776_Ch02"
  },
  {
    "id": 137,
    "question": "Storage area networks support which type of storage? (Choose the best answer.)",
    "choice_a": "Meta",
    "choice_b": "Object",
    "choice_c": "Block",
    "choice_d": "File",
    "correct_answer": "C",
    "explanation": "Storage area networks support block-based storage.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      53,
      12,
      52,
      55,
      71
    ],
    "source": "333776_Ch02"
  },
  {
    "id": 138,
    "question": "What identity system gives multiple discrete organizations access to your NoSQL community cloud database via your cloud-based application server?",
    "choice_a": "Single sign-on",
    "choice_b": "Federations",
    "choice_c": "LDAP",
    "choice_d": "Authorization manager",
    "correct_answer": "B",
    "explanation": "Identity systems using federations allow multiple organizations to use the same data for identification when accessing the networks or resources of everyone in the group.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      165,
      97,
      167,
      68,
      102
    ],
    "source": "333776_Ch02"
  },
  {
    "id": 139,
    "question": "When performing a migration from your on-site private cloud to a new community cloud data center, which of the following do you need to check to ensure a successful migration? (Choose two.)",
    "choice_a": "RAID array durability rating",
    "choice_b": "VM file format",
    "choice_c": "Benchmark compatibility",
    "choice_d": "Online migration bandwidth",
    "correct_answer": [
      "B",
      "D"
    ],
    "explanation": "Both migration WAN bandwidth and compatible VM file formats are critical to a successful migration.",
    "topic_id": 2,
    "practice_test_id": 4,
    "related_articles": [
      6,
      66,
      67,
      25,
      28
    ],
    "source": "333776_Ch02"
  },
  {
    "id": 140,
    "question": "What systems monitor the network and report security issues?",
    "choice_a": "CloudShield",
    "choice_b": "Intrusion prevention system",
    "choice_c": "Firewall",
    "choice_d": "Intrusion detection system",
    "correct_answer": "D",
    "explanation": "Intrusion detection systems monitor network traffic for malicious activity and generate reports and alerts. Intrusion prevention takes this a step further and actively attempts to shut down the intrusion as it is happening.",
    "topic_id": 4,
    "practice_test_id": 3,
    "related_articles": [
      107,
      111,
      87,
      110,
      108
    ],
    "source": "333776_Ch02"
  },
  {
    "id": 141,
    "question": "Harry is investigating cloud service models and wants to outsource the security responsibility to the cloud company and not have to take responsibility for maintaining and patching the operating systems. But he still wants control over the application and its data. Which service model will meet his requirements?",
    "choice_a": "IaaS",
    "choice_b": "PaaS",
    "choice_c": "SaaS",
    "choice_d": "CaaS",
    "correct_answer": "B",
    "explanation": "The Platform as a Service model offers operating system security provided by the service provider.",
    "topic_id": 1,
    "practice_test_id": 3,
    "related_articles": [
      91,
      24,
      26,
      4,
      113
    ],
    "source": "333776_Ch03"
  },
  {
    "id": 142,
    "question": "What is the name of the process when a cloud administrator uses their token, username, and password to log in to the cloud console? (Choose two.)",
    "choice_a": "Authorization",
    "choice_b": "Two-factor",
    "choice_c": "Authentication",
    "choice_d": "Role-based access",
    "correct_answer": [
      "B",
      "C"
    ],
    "explanation": "Logging in to a system is referred to as authentication, and the use of a password and a token to log in describes two-factor authentication.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      69,
      92,
      165,
      95,
      60
    ],
    "source": "333776_Ch03"
  },
  {
    "id": 143,
    "question": "Robert has been tasked with creating an access control solution for his company\u2019s fleet of servers in a hybrid cloud configuration. He has been asked to define the required tasks and then to put users, groups, and servers into this task-based implementation. What type of access control should Robert deploy?",
    "choice_a": "Mandatory access control",
    "choice_b": "Nondiscretionary",
    "choice_c": "Role-based",
    "choice_d": "Multifactor",
    "correct_answer": "C",
    "explanation": "The question outlines the function of a role-based access control approach.",
    "topic_id": 4,
    "practice_test_id": 5,
    "related_articles": [
      68,
      94,
      93,
      97,
      165
    ],
    "source": "333776_Ch03"
  },
  {
    "id": 144,
    "question": "What is a report for the public disclosure of financial controls and security reporting that does not contain sensitive and technical information called?",
    "choice_a": "SOC 1",
    "choice_b": "SOC 2",
    "choice_c": "SOC 3",
    "choice_d": "ISO 27001",
    "correct_answer": "C",
    "explanation": "Service Organization Controls 3 reports are for public disclosure of financial controls and security reporting.",
    "topic_id": 4,
    "practice_test_id": 7,
    "related_articles": [
      77,
      73,
      76,
      102,
      75
    ],
    "source": "333776_Ch03",
    "choice_e": "FIPS 140-2"
  },
  {
    "id": 145,
    "question": "What is the National Institute of Standards and Technology publication that coordinates the requirements and standards for cryptography modules?",
    "choice_a": "PCI DSS",
    "choice_b": "FIPS 140-2",
    "choice_c": "ISO 27001",
    "choice_d": "FedRAMP",
    "correct_answer": "B",
    "explanation": "The National Institute of Standards and Technology (NIST) FIPS 140-2 publication coordinates the requirements and standards for cryptography modules.",
    "topic_id": 4,
    "practice_test_id": 5,
    "related_articles": [
      83,
      82,
      78,
      85,
      81
    ],
    "source": "333776_Ch03"
  },
  {
    "id": 146,
    "question": "What is a compliance requirement to be certified to meet the U.S. Department of Defense (DoD) security requirements for contractors working with the DoD?",
    "choice_a": "FedRAMP",
    "choice_b": "RMF",
    "choice_c": "FISMA",
    "choice_d": "123",
    "correct_answer": "B",
    "explanation": "The Risk Management Framework (RMF) is the process for computer systems IT security. RMF compliance is required to be certified to meet the U.S. Department of Defense security requirements for contractors.",
    "topic_id": 4,
    "practice_test_id": 5,
    "related_articles": [
      76,
      73,
      79,
      102,
      106
    ],
    "source": "333776_Ch03"
  },
  {
    "id": 147,
    "question": "Mary\u2019s boss has asked her to investigate moving the company\u2019s medical records to the cloud. What compliance mandate must the cloud provider meet for Mary to recommend deploying her company\u2019s operations to the cloud?",
    "choice_a": "SOC 3",
    "choice_b": "HIPAA",
    "choice_c": "MPAA",
    "choice_d": "ISA 2701",
    "correct_answer": "B",
    "explanation": "The Health Insurance Portability and Accountability Act defines the standards for protecting medical data, and it is mandatory for Mary\u2019s requirements.",
    "topic_id": 4,
    "practice_test_id": 4,
    "related_articles": [
      73,
      76,
      98,
      79,
      102
    ],
    "source": "333776_Ch03"
  },
  {
    "id": 148,
    "question": "Sue is preparing a change management process to harden various resources. What resources are her responsibility to harden? (Choose three.)",
    "choice_a": "Webservers running on a fleet of VMs",
    "choice_b": "Self-hosted MySQL server",
    "choice_c": "Managed elastic filesystem",
    "choice_d": "Linux virtual snapshot image",
    "correct_answer": [
      "A",
      "B",
      "E"
    ],
    "explanation": "Hardening webservers, self-hosted databases, and on-premises DHCP servers is the responsibility of the customer. The cloud provider is responsible for hardening managed services, such as elastic filesystems.",
    "topic_id": 1,
    "practice_test_id": 1,
    "related_articles": [
      24,
      26,
      91,
      113,
      70
    ],
    "source": "333776_Ch03",
    "choice_e": "On-premises DHCP server"
  },
  {
    "id": 149,
    "question": "Harry is the cloud administrator for a company that stores object-based data in a public cloud. Because of regulatory restrictions on user access to sensitive security data, what type of access control would you suggest he implement to meet his company\u2019s security policies?",
    "choice_a": "Mandatory access control",
    "choice_b": "Nondiscretionary",
    "choice_c": "Roles",
    "choice_d": "Multifactor",
    "correct_answer": "A",
    "explanation": "The mandatory access control approach is often found in high-security environments where access to sensitive data needs to be highly controlled. Using the mandatory access control approach, a user will authenticate, or log in to, a system. Based on the user\u2019s identity and security levels of the individual, access rights will be determined by comparing that data against the security properties of the system being accessed.",
    "topic_id": 4,
    "practice_test_id": 7,
    "related_articles": [
      94,
      92,
      98,
      165,
      102
    ],
    "source": "333776_Ch03"
  },
  {
    "id": 150,
    "question": "Christina is investigating obtaining compliance for her employer, which is a large public cloud company. She has been asked to provide a report on the process to enable her company to host a large U.S. federal government database. Which compliance certification is she investigating?",
    "choice_a": "HIPAA",
    "choice_b": "FedRAMP",
    "choice_c": "DIACAP",
    "choice_d": "FISMA",
    "correct_answer": "B",
    "explanation": "The Federal Risk and Authorization Management Program is a U.S. federal government program that outlines the standards for a security assessment, authorization, and continuous monitoring for cloud products and services.",
    "topic_id": 4,
    "practice_test_id": 3,
    "related_articles": [
      76,
      73,
      102,
      74,
      75
    ],
    "source": "333776_Ch03"
  },
  {
    "id": 151,
    "question": "What is the process document that outlines your company\u2019s responsibilities for safely deploying your fleet of servers in the public cloud?",
    "choice_a": "DIACAP",
    "choice_b": "Security policy",
    "choice_c": "Service level agreement",
    "choice_d": "SOC 2",
    "correct_answer": "B",
    "explanation": "The company\u2019s security policy outlines all aspects of your cloud security posture.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      75,
      97,
      106,
      89,
      73
    ],
    "source": "333776_Ch03"
  },
  {
    "id": 152,
    "question": "Hank goes to his local bank and inserts his card into the ATM and then enters his PIN on the keypad. What type of authentication is he participating in?",
    "choice_a": "SSO",
    "choice_b": "Two-factor",
    "choice_c": "LDAP",
    "choice_d": "User based",
    "correct_answer": "B",
    "explanation": "Two-factor authentication includes something that you have (in this case, a card) and something that you know (in this case, a PIN).",
    "topic_id": 4,
    "practice_test_id": 1,
    "related_articles": [
      101,
      95,
      97,
      92,
      69
    ],
    "source": "333776_Ch03"
  },
  {
    "id": 153,
    "question": "You work in the financial services industry and are required to encrypt your data at rest in the public cloud to comply with securities regulations. You want to implement a strong encryption protocol that is widely approved by industry best practices. Which one of the following meets your requirements?",
    "choice_a": "3DES",
    "choice_b": "RSA",
    "choice_c": "AES-256",
    "choice_d": "Rivest Cipher 5",
    "correct_answer": "C",
    "explanation": "Advanced Encryption Standard is a symmetrical block cipher that has options to use three lengths, including 128, 192, and 256 bits. AES-256 is a very secure standard, and it would take an extremely long time and a lot of processing power to come even close to breaking the code. AES has been approved and adopted by many governments, including the United States and Canada, to encrypt sensitive data. AES has also been adopted as a standard by the National Institute of Standards and Technology.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      83,
      57,
      82,
      78,
      73
    ],
    "source": "333776_Ch03"
  },
  {
    "id": 154,
    "question": "Single sign-on services allow a user to log in to the system one time and be granted device access without having to perform multiple system authentications. What two technologies enable SSO systems? (Choose two.)",
    "choice_a": "PKI",
    "choice_b": "LDAP",
    "choice_c": "Active Directory",
    "choice_d": "Roles",
    "correct_answer": [
      "B",
      "C"
    ],
    "explanation": "Lightweight Directory Access Protocol and Active Directory are two technologies that enable SSO access to cloud resources.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      165,
      97,
      95,
      101,
      60
    ],
    "source": "333776_Ch03"
  },
  {
    "id": 155,
    "question": "Which of the following functions might a reverse proxy perform?",
    "choice_a": "Content filtering",
    "choice_b": "Load balancing",
    "choice_c": "Data loss prevention",
    "choice_d": "Issuing digital certificates",
    "correct_answer": "B",
    "explanation": "A reverse proxy sits at the edge of a network and intercepts incoming requests and then proxies the request to the server. A reverse proxy is in a perfect position to perform load balancing.",
    "topic_id": 1,
    "practice_test_id": 3,
    "related_articles": [
      18,
      27,
      40,
      11,
      131
    ],
    "source": "333776_Ch03"
  },
  {
    "id": 156,
    "question": "Sarah has been tasked to implement a strong user authentication strategy to secure dashboard access to her SaaS cloud services. She wants to use temporarily issued tokens to prevent unauthorized users from accessing her cloud administrator\u2019s account. What type of authentication would you recommend that Sarah implement?",
    "choice_a": "Multifactor",
    "choice_b": "Mandatory access control",
    "choice_c": "Roles",
    "choice_d": "Nondiscretionary",
    "correct_answer": "A",
    "explanation": "Multifactor uses temporarily issued numerical tokens that must be entered at the time of user authentication.",
    "topic_id": 4,
    "practice_test_id": 6,
    "related_articles": [
      101,
      97,
      95,
      165,
      102
    ],
    "source": "333776_Ch03"
  },
  {
    "id": 157,
    "question": "Brad has been tasked with encrypting traffic to and from his e-commerce application running in a community cloud. He is investigating a standards-based secure solution that web customers can easily implement to ensure secure transactions. What is a good solution that you would recommend to Brad?",
    "choice_a": "AH/ESP",
    "choice_b": "AES-256",
    "choice_c": "TLS",
    "choice_d": "IPsec",
    "correct_answer": "C",
    "explanation": "Transport Layer Security (TLS) provides an encrypted session between the client and the server. To secure websites, it\u2019s a part of the Hypertext Transfer Protocol Secure (HTTPS) protocol.",
    "topic_id": 4,
    "practice_test_id": 1,
    "related_articles": [
      81,
      82,
      78,
      80,
      38
    ],
    "source": "333776_Ch03"
  },
  {
    "id": 158,
    "question": "You have been asked to investigate cloud-based VPN access from your corporate data center that offers data integrity and confidentiality. Your manager does not want to incur the costs of a dedicated circuit to the cloud provider. What connection protocol should you suggest?",
    "choice_a": "AES",
    "choice_b": "SOC-3",
    "choice_c": "IPsec",
    "choice_d": "RC5",
    "correct_answer": "C",
    "explanation": "Many IPsec implementations are found in routers and firewalls within VPNs, application security, and network security to provide a secure connection over an insecure network such as the Internet.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      16,
      36,
      91,
      11,
      27
    ],
    "source": "333776_Ch03"
  },
  {
    "id": 159,
    "question": "Bob is compiling a list of security tasks to implement to harden his public cloud posture. What are four recommendations that you would suggest? (Choose four.)",
    "choice_a": "Install antivirus protection software on public-facing servers.",
    "choice_b": "Shut down unused services.",
    "choice_c": "Implement whitelisting for public-facing webservers.",
    "choice_d": "Implement a host-based firewall or security groups.",
    "correct_answer": [
      "A",
      "B",
      "D",
      "F"
    ],
    "explanation": "Securing user accounts and policies include installing antivirus software, disabling unused servers, implementing host-based firewall services, and shutting down all default user accounts.",
    "topic_id": 4,
    "practice_test_id": 4,
    "related_articles": [
      89,
      90,
      166,
      110,
      37
    ],
    "source": "333776_Ch03",
    "choice_e": "Allow all storage volumes\u2019 authenticated users full access.",
    "choice_f": "Disable all default accounts.",
    "choice_g": "Grant ephemeral ports access to the DMZ."
  },
  {
    "id": 160,
    "question": "Jill plans to optimize and control user access by implementing a technology that will allow access to all allowed systems at the time of user authentication. She is implementing the LDAP protocol to enable this service. What does she plan to deploy?",
    "choice_a": "Token-based 2FA",
    "choice_b": "SSO",
    "choice_c": "RSA",
    "choice_d": "Nondiscretionary",
    "correct_answer": "B",
    "explanation": "Single sign-on allows a user to log in one time and be granted access to multiple systems without having to authenticate to each one individually.",
    "topic_id": 4,
    "practice_test_id": 6,
    "related_articles": [
      95,
      97,
      165,
      69,
      92
    ],
    "source": "333776_Ch03"
  },
  {
    "id": 161,
    "question": "Roberto has been tasked with creating a security implementation that segments his employer\u2019s e-commerce design to allow for policy enforcement. What are some of the areas that he is investigating? (Choose three.)",
    "choice_a": "Network",
    "choice_b": "Automation",
    "choice_c": "Storage",
    "choice_d": "Compute",
    "correct_answer": [
      "A",
      "C",
      "D"
    ],
    "explanation": "Cloud segmentation is the process of dividing up your cloud deployment into sections that allow for granular security. Common segments include compute, network, and storage. APIs, JSON, and XML are used in automation.",
    "topic_id": 1,
    "practice_test_id": 6,
    "related_articles": [
      8,
      11,
      52,
      91,
      47
    ],
    "source": "333776_Ch04",
    "choice_e": "APIs",
    "choice_f": "JSON/XML"
  },
  {
    "id": 162,
    "question": "Where can MFA tokens be obtained? (Choose two.)",
    "choice_a": "Python app",
    "choice_b": "Smartphone app",
    "choice_c": "Automation systems",
    "choice_d": "Keyfob",
    "correct_answer": [
      "B",
      "D"
    ],
    "explanation": "One-time numerical tokens are generated on keyfob hardware devices and smartphone soft-token applications.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      101,
      95,
      165,
      60,
      102
    ],
    "source": "333776_Ch04",
    "choice_e": "Cloud vendor management dashboard"
  },
  {
    "id": 163,
    "question": "Hank just completed running some security automation scripts on his new fleet of application virtual machines. After applying intrusion detection, virus, and malware protection on the Linux images, he notices an increase in which VM metric on his management dashboard?",
    "choice_a": "DMA",
    "choice_b": "BIOS",
    "choice_c": "CPU",
    "choice_d": "IPsec",
    "correct_answer": "C",
    "explanation": "Applying security applications on a virtual server will cause an increase in CPU usage.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      43,
      42,
      10,
      8,
      3
    ],
    "source": "333776_Ch04",
    "choice_e": "I/O"
  },
  {
    "id": 164,
    "question": "What technology was instrumental in the growth of cloud services?",
    "choice_a": "XML",
    "choice_b": "Python",
    "choice_c": "Automation",
    "choice_d": "Authentication",
    "correct_answer": "C",
    "explanation": "Automation of cloud deployments was instrumental in the growth of cloud-based services.",
    "topic_id": 5,
    "practice_test_id": 1,
    "related_articles": [
      121,
      103,
      117
    ],
    "source": "333776_Ch04",
    "choice_e": "Scripting",
    "choice_f": "Workflow services",
    "choice_g": "Encryption"
  },
  {
    "id": 165,
    "question": "Carl is planning his cloud migration and must meet HIPAA requirements for confidential storage of data at rest in the cloud. What services must be addressed by Carl? (Choose two.)",
    "choice_a": "Virtual private network",
    "choice_b": "Storage",
    "choice_c": "Client-side",
    "choice_d": "Database",
    "correct_answer": [
      "B",
      "D"
    ],
    "explanation": "Storage systems and database applications both can store data at rest, so Carl must ensure that these services properly encrypt the data. VPNs deal with data in transit, whereas client encryption falls outside of the purview of the cloud.",
    "topic_id": 4,
    "practice_test_id": 4,
    "related_articles": [
      100,
      57,
      78,
      73,
      76
    ],
    "source": "333776_Ch04"
  },
  {
    "id": 166,
    "question": "What is a common cloud-based GUI used to get an overview of your security operations?",
    "choice_a": "Puppet automation",
    "choice_b": "Gemalto system",
    "choice_c": "Dashboard",
    "choice_d": "Vendor-based security appliance",
    "correct_answer": "C",
    "explanation": "A dashboard is a graphical portal that provides updates and an overview of operations.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      105,
      157,
      176,
      179,
      122
    ],
    "source": "333776_Ch04"
  },
  {
    "id": 167,
    "question": "Who is responsible for the security of customer data stored in the cloud?",
    "choice_a": "Cloud provider",
    "choice_b": "Compliance agency",
    "choice_c": "Cloud customer",
    "choice_d": "Shared responsibility",
    "correct_answer": "C",
    "explanation": "Ultimately the responsibility for data in the cloud belongs to the organization that owns the data.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      24,
      91,
      26,
      1,
      141
    ],
    "source": "333776_Ch04"
  },
  {
    "id": 168,
    "question": "What are systems that automate cloud operations called?",
    "choice_a": "Authentication",
    "choice_b": "Federations",
    "choice_c": "Orchestration",
    "choice_d": "Ephemeral",
    "correct_answer": "C",
    "explanation": "Orchestration systems automate cloud operations. Some examples are Chef, Puppet, and Kubernetes.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      47,
      8,
      48,
      113,
      10
    ],
    "source": "333776_Ch04",
    "choice_e": "API"
  },
  {
    "id": 169,
    "question": "RESTful APIs using JSON can be used to provision what cloud-based services? (Choose all that apply.)",
    "choice_a": "Firewalls",
    "choice_b": "Load balancers",
    "choice_c": "Linux virtual machines",
    "choice_d": "Windows DNS servers",
    "correct_answer": [
      "A",
      "B",
      "C",
      "E"
    ],
    "explanation": "All of these cloud services have APIs that can be accessed for creation, configuration, and monitoring using standard RESTful APIs.",
    "topic_id": 2,
    "practice_test_id": 4,
    "related_articles": [
      20,
      112,
      33,
      45,
      120
    ],
    "source": "333776_Ch04",
    "choice_e": "Durable storage volumes"
  },
  {
    "id": 170,
    "question": "Ann has a critical server in the application tier of her cloud-based deployment. She is looking at a device-specific security solution to add defense-in-depth capabilities to her currently deployed network-based security defenses. She has been researching ways to mitigate potential hacking attempts. What is a good solution for her?",
    "choice_a": "DMZ",
    "choice_b": "IDS",
    "choice_c": "IPS",
    "choice_d": "Classifications automation",
    "correct_answer": "E",
    "explanation": "A host-based intrusion detection system will allow Ann to apply intrusion protection to a specific virtual machine.",
    "topic_id": 4,
    "practice_test_id": 1,
    "related_articles": [
      110,
      107,
      99,
      89,
      87
    ],
    "source": "333776_Ch04",
    "choice_e": "HIDS"
  },
  {
    "id": 171,
    "question": "A constantly changing six-digit numerical token is used in what type of cloud service?",
    "choice_a": "XML",
    "choice_b": "TLS",
    "choice_c": "SSL",
    "choice_d": "MFA",
    "correct_answer": "D",
    "explanation": "Multifactor authentication services use a token that is generated on a schedule and can be a numerical value. The other options are not cloud services.",
    "topic_id": 4,
    "practice_test_id": 5,
    "related_articles": [
      101,
      95,
      97,
      92,
      69
    ],
    "source": "333776_Ch04",
    "choice_e": "JSON"
  },
  {
    "id": 172,
    "question": "You\u2019re developing a web-based dashboard that must pull data from many different cloud locations and devices. Which of the following will you need to use?",
    "choice_a": "Python",
    "choice_b": "XML",
    "choice_c": "API",
    "choice_d": "SNMP",
    "correct_answer": "C",
    "explanation": "An application programming interface (API) offers programmatic access, control, and configuration of a device between different and discrete software components.",
    "topic_id": 5,
    "practice_test_id": 3,
    "related_articles": [
      103
    ],
    "source": "333776_Ch04",
    "choice_e": "TLS"
  },
  {
    "id": 173,
    "question": "Samantha has been tasked to meet FedRAMP compliance for her customer\u2019s new contract. Where should she integrate compliance in her project? (Choose four.)",
    "choice_a": "Handoff",
    "choice_b": "Design",
    "choice_c": "Implementation",
    "choice_d": "Automation rollout",
    "correct_answer": [
      "B",
      "C",
      "E",
      "F"
    ],
    "explanation": "All compliance requirements should be integrated into the complete life cycle of a project. including the design, planning, implementation, and validation phases of the project.",
    "topic_id": 4,
    "practice_test_id": 4,
    "related_articles": [
      102,
      73,
      75,
      79,
      106
    ],
    "source": "333776_Ch04",
    "choice_e": "Planning",
    "choice_f": "Validation",
    "choice_g": "HIDS",
    "choice_h": "JSON/XML scripting"
  },
  {
    "id": 174,
    "question": "Sharon is investigating a standards-based construct to enable automation on her load balancers. What is a good lightweight data-interchange format standard that is easily readable and for computing systems to parse and generate? (Choose two.)",
    "choice_a": "XML",
    "choice_b": "JSON",
    "choice_c": "REST",
    "choice_d": "Python",
    "correct_answer": [
      "A",
      "B"
    ],
    "explanation": "Extensible Markup Language (XML) and JavaScript Object Notation (JSON) provide a flexible way to describe data, create information formats, and electronically share structured data among computing systems. Both are lightweight data-interchange formats that are easily readable for computing systems to parse and generate.",
    "topic_id": 2,
    "practice_test_id": 4,
    "related_articles": [
      20,
      112,
      104,
      120,
      33
    ],
    "source": "333776_Ch04"
  },
  {
    "id": 175,
    "question": "Mike has been investigating multiple hacking attempts on his cloud e-commerce webservers. He wants to add a frontend with a service that actively takes countermeasures to shut down the hacking attempts. What application would you suggest that Mike deploy?",
    "choice_a": "DMZ",
    "choice_b": "IDS",
    "choice_c": "IPS",
    "choice_d": "RAID",
    "correct_answer": "C",
    "explanation": "Intrusion prevention systems will monitor for malicious activity and actively take countermeasures to eliminate or reduce the effects of the intrusion.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      107,
      111,
      38,
      88,
      87
    ],
    "source": "333776_Ch04",
    "choice_e": "HIDS"
  },
  {
    "id": 176,
    "question": "What is the most common protocol for in-flight encryption of web traffic?",
    "choice_a": "MD5",
    "choice_b": "TLS",
    "choice_c": "IPsec",
    "choice_d": "VPN",
    "correct_answer": "B",
    "explanation": "TLS is the most common encryption protocol for web-based applications. MD5 is a hash algorithm. IPsec is used for encrypting VPN connections, not HTTP connections.",
    "topic_id": 4,
    "practice_test_id": 5,
    "related_articles": [
      81,
      82,
      83,
      85,
      80
    ],
    "source": "333776_Ch04"
  },
  {
    "id": 177,
    "question": "Storage that does not survive a virtual machine shutdown is referred to as what? (Choose two.)",
    "choice_a": "Durable",
    "choice_b": "RAID",
    "choice_c": "Ephemeral",
    "choice_d": "Nondurable",
    "correct_answer": [
      "C",
      "D"
    ],
    "explanation": "Temporary storage volumes that are only in existence when the VM is deployed are referred to as ephemeral or nondurable storage.",
    "topic_id": 1,
    "practice_test_id": 3,
    "related_articles": [
      55,
      12,
      52,
      3,
      10
    ],
    "source": "333776_Ch04",
    "choice_e": "Tiered"
  },
  {
    "id": 178,
    "question": "Cloud segmentation enhances security for cloud-based applications. What services is it a best practice to segment?",
    "choice_a": "Python",
    "choice_b": "Compute",
    "choice_c": "RAM",
    "choice_d": "VPN",
    "correct_answer": "B",
    "explanation": "It is considered a best practice to group compute resources into like segments and apply security to the segment.",
    "topic_id": 4,
    "practice_test_id": 7,
    "related_articles": [
      99,
      37,
      100,
      97,
      106
    ],
    "source": "333776_Ch04"
  },
  {
    "id": 179,
    "question": "What is a long-standing text-based interface that is used to configure network services both locally and remotely?",
    "choice_a": "GUI",
    "choice_b": "CLI",
    "choice_c": "REST",
    "choice_d": "SNMP",
    "correct_answer": "B",
    "explanation": "The command-line interface is a text-based interface to most network services that allows for remote and local configurations.",
    "topic_id": 4,
    "practice_test_id": 7,
    "related_articles": [
      87,
      74,
      90,
      165,
      37
    ],
    "source": "333776_Ch04",
    "choice_e": "API"
  },
  {
    "id": 180,
    "question": "Your company has purchased an IPS. When reading the documentation, you notice a link to download a Java application to monitor and configure the IPS. What kind of management application is this?",
    "choice_a": "CLI",
    "choice_b": "HTTP",
    "choice_c": "GUI",
    "choice_d": "API",
    "correct_answer": "C",
    "explanation": "Based on the information given, the description is for a GUI management application.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      107,
      111,
      87,
      106,
      75
    ],
    "source": "333776_Ch04",
    "choice_e": "REST"
  },
  {
    "id": 181,
    "question": "What backup type offers the advantage of a complete and up-to-date copy of your data in one operation?",
    "choice_a": "Full",
    "choice_b": "Differential",
    "choice_c": "Incremental",
    "choice_d": "Online",
    "correct_answer": "A",
    "explanation": "Full backups offer the advantage of a complete and up-to-date copy of your data in one operation. They have the disadvantage of taking a long time to perform because all the data in a storage system must be copied instead of just the modified data from the last backup.",
    "topic_id": 3,
    "practice_test_id": 7,
    "related_articles": [
      124,
      126,
      125,
      46,
      129
    ],
    "source": "333776_Ch05"
  },
  {
    "id": 182,
    "question": "When applying a series of patches to your fleet of middleware servers in the cloud, you are concerned about the monitoring systems generating invalid alerts. Which parts of the server maintenance process would cause this? (Choose two.)",
    "choice_a": "API polling",
    "choice_b": "Rolling upgrades",
    "choice_c": "Shutdown",
    "choice_d": "Restart",
    "correct_answer": [
      "C",
      "D"
    ],
    "explanation": "Cloud configuration frontends as well as automation systems using scripting or API calls can shut down and restart virtual machines as required. Both restarts and shutdowns may be performed because of a code upgrade, troubleshooting, or other needs. The shutdown and restart processes can be monitored through the management systems and dashboards that are offered by the cloud provider. If they do not respond, these systems can be configured to generate an alarm.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      122,
      158,
      105,
      149,
      160
    ],
    "source": "333776_Ch05"
  },
  {
    "id": 183,
    "question": "What are common automation systems that are used for patch management? (Choose three.)",
    "choice_a": "Chef",
    "choice_b": "Cloudpatch",
    "choice_c": "Ansible",
    "choice_d": "DevOps",
    "correct_answer": [
      "A",
      "C",
      "E"
    ],
    "explanation": "Common patch management offerings are Chef, Puppet, and Ansible.",
    "topic_id": 3,
    "practice_test_id": 4,
    "related_articles": [
      149,
      122,
      160,
      115,
      148
    ],
    "source": "333776_Ch05",
    "choice_e": "Puppet",
    "choice_f": "Cloud Deploy"
  },
  {
    "id": 184,
    "question": "What type of software change is designed to address a known bug or issue and to bring a system up-to-date with previous bug fixes?",
    "choice_a": "Hotfix",
    "choice_b": "Patch",
    "choice_c": "Version update",
    "choice_d": "Rollout",
    "correct_answer": "B",
    "explanation": "A patch is a piece of software that is intended to update an application, operating system, or any other software-based system to fix or improve its operations. Generally, patches are synonymous with fixes for security vulnerabilities or any other type of operational bug.",
    "topic_id": 3,
    "practice_test_id": 4,
    "related_articles": [
      122,
      116,
      177,
      123,
      160
    ],
    "source": "333776_Ch05"
  },
  {
    "id": 185,
    "question": "What backup method creates a master copy of a system image and uses it as a template to create additional systems?",
    "choice_a": "Full backup",
    "choice_b": "Snapshot",
    "choice_c": "Clone",
    "choice_d": "Replicate",
    "correct_answer": "C",
    "explanation": "Cloning takes the master image and clones it to be used as another separate and independent VM. Important components of a server are changed to prevent address conflicts. These include the UUID and MAC addresses of the cloned server.",
    "topic_id": 1,
    "practice_test_id": 5,
    "related_articles": [
      27,
      10,
      42,
      131,
      113
    ],
    "source": "333776_Ch05"
  },
  {
    "id": 186,
    "question": "What backup method creates a file-based image of the current state of a VM, including the complete operating system and all applications that are stored on it?",
    "choice_a": "Full backup",
    "choice_b": "Snapshot",
    "choice_c": "Clone",
    "choice_d": "Replicate",
    "correct_answer": "B",
    "explanation": "A snapshot is a file-based image of the current state of a VM, including the complete set of operating systems and all the applications that are stored on it. The snapshot will record the data on the disk, its current state, and the VM\u2019s configuration at that instant in time. Snapshots can be created while the VM is in operation and are used as a record of that VM\u2019s state. They can function as a backup that you can restore from later.",
    "topic_id": 3,
    "practice_test_id": 6,
    "related_articles": [
      119,
      124,
      133,
      123,
      46
    ],
    "source": "333776_Ch05"
  },
  {
    "id": 187,
    "question": "To meet regulatory requirements, your company must provide geographical separation between active data and backup data of certain medical records that your company collects and processes. The requirements stipulate that the data cannot leave the country and must be in two or more data centers. As the cloud professional for your company, what recommendation would you offer to meet these requirements?",
    "choice_a": "Remote",
    "choice_b": "Offline",
    "choice_c": "Target",
    "choice_d": "Incremental",
    "correct_answer": "A",
    "explanation": "Many corporate and most regulatory requirements will specify that the backup data must be located at a separate data center from the origin data center and that the two must be geographically away from each other. Many cloud providers interconnect their data centers into regions and availability zones using high-speed, directly connected fiber networks that allow large backup sets to traverse the data network between the data centers and that make remote backups feasible.",
    "topic_id": 3,
    "practice_test_id": 3,
    "related_articles": [
      127,
      46,
      17,
      59,
      145
    ],
    "source": "333776_Ch05"
  },
  {
    "id": 188,
    "question": "What type of software update may offer new features and benefits in addition to bug fixes?",
    "choice_a": "Hotfix",
    "choice_b": "Patch",
    "choice_c": "Version update",
    "choice_d": "Rollout",
    "correct_answer": "C",
    "explanation": "A version update is the process of replacing a software product with a newer version of the same product. Version updates can add new features, bring the system up-to-date, provide a rollup of all previous patches, and improve the product.",
    "topic_id": 3,
    "practice_test_id": 4,
    "related_articles": [
      168,
      122,
      177,
      160,
      123
    ],
    "source": "333776_Ch05"
  },
  {
    "id": 189,
    "question": "Which of the following offers a structured process for a series of actions that should be taken in order to complete a process?",
    "choice_a": "Automation",
    "choice_b": "Workflow",
    "choice_c": "Orchestration",
    "choice_d": "Application programming interface (API)",
    "correct_answer": "B",
    "explanation": "Workflow automation defines a structured process for a series of actions that should be taken to complete a process. With cloud-based workflow services, special workflow applications are offered as a managed service that creates a defined sequence of events, or workflow, with each procedure tracked and passed to the next process in the workflow.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      4,
      26,
      24,
      8,
      18
    ],
    "source": "333776_Ch05"
  },
  {
    "id": 190,
    "question": "These cloud-based systems abstract and hide much of the complexity of modern cloud systems and reduce operational errors by executing tested cloud systems, scripts, workflows, or runbooks to make sure that the systems are configured correctly.",
    "choice_a": "XML",
    "choice_b": "SDN",
    "choice_c": "Orchestration",
    "choice_d": "REST/API",
    "correct_answer": "C",
    "explanation": "The main function of orchestration systems is to combine and execute the multiple tasks that must be completed to accomplish an operation. These tasks are combined into a workflow that defines the order of events and steps needed to complete the operation. The orchestration system uses software systems and processes to carry out the workflow.",
    "topic_id": 1,
    "practice_test_id": 6,
    "related_articles": [
      47,
      48,
      8,
      3,
      18
    ],
    "source": "333776_Ch05"
  },
  {
    "id": 191,
    "question": "When a server is undergoing updates, it may be in a state that it will not respond to health checks, API calls, SNMP, or any other means used to monitor its health by network management systems. This may cause false alarms and trigger automated troubleshooting systems. What can be done to prevent false alarms? (Choose two.)",
    "choice_a": "Put the system into maintenance mode.",
    "choice_b": "Edit workflow scripts.",
    "choice_c": "Assign a workflow to the orchestration rollout.",
    "choice_d": "Disable system alerts.",
    "correct_answer": [
      "A",
      "D"
    ],
    "explanation": "Placing a system into maintenance mode and disabling system alerts ensure that the management systems will not alert on false positives when a system undergoing regular maintenance does not respond when polled by management systems, and it will not send out unsolicited alarms because of the maintenance being performed.",
    "topic_id": 3,
    "practice_test_id": 7,
    "related_articles": [
      122,
      158,
      105,
      173,
      160
    ],
    "source": "333776_Ch05"
  },
  {
    "id": 192,
    "question": "What type of software change is designed for rapid deployment and to correct a specific and critical issue?",
    "choice_a": "Hotfix",
    "choice_b": "Patch",
    "choice_c": "Version update",
    "choice_d": "Rollout",
    "correct_answer": "A",
    "explanation": "A hotfix is a software update type that is intended to fix an immediate and specific problem with a quick release procedure.",
    "topic_id": 3,
    "practice_test_id": 3,
    "related_articles": [
      160,
      116,
      174,
      148,
      115
    ],
    "source": "333776_Ch05"
  },
  {
    "id": 193,
    "question": "What type of backup system is intended to provide quick restore access if needed?",
    "choice_a": "Virtual Storage Area Network (SAN)",
    "choice_b": "Fibre Channel over Ethernet (FCOE)",
    "choice_c": "Online",
    "choice_d": "Replica",
    "correct_answer": "C",
    "explanation": "Online backup storage is a system that can be accessed at any time without the requirement for a network administrator to mount the media into a storage system. Online is the most common storage design, and backups offer an always-available method to store and retrieve the data.",
    "topic_id": 3,
    "practice_test_id": 5,
    "related_articles": [
      130,
      129,
      125,
      46,
      127
    ],
    "source": "333776_Ch05"
  },
  {
    "id": 194,
    "question": "Which of the following is a tightly coupled computer system that allows for software patching without incurring downtime?",
    "choice_a": "Blue-green",
    "choice_b": "RAID",
    "choice_c": "Cluster",
    "choice_d": "Availability zone",
    "correct_answer": "C",
    "explanation": "A cluster is a group of tightly coupled systems designed for high availability and that still operate if one or more nodes is offline.",
    "topic_id": 1,
    "practice_test_id": 6,
    "related_articles": [
      113,
      21,
      141,
      135,
      71
    ],
    "source": "333776_Ch05"
  },
  {
    "id": 195,
    "question": "Your IaaS cloud company has announced that there will be a brief outage for regularly scheduled maintenance over the weekend to apply a critical hotfix to vital infrastructure. What are the systems they may be applying patches to? (Choose three.)",
    "choice_a": "VM",
    "choice_b": "Load balancer",
    "choice_c": "Hypervisor",
    "choice_d": "NoSQL database",
    "correct_answer": [
      "B",
      "C",
      "E"
    ],
    "explanation": "Infrastructure that is part of the Infrastructure as a Service (IaaS) service provider\u2019s area of responsibility includes load balancers, hypervisors, and routers. A virtual machine, database, or email server would be the responsibility of the customer.",
    "topic_id": 1,
    "practice_test_id": 3,
    "related_articles": [
      24,
      26,
      91,
      113,
      18
    ],
    "source": "333776_Ch05",
    "choice_e": "Router",
    "choice_f": "Email server"
  },
  {
    "id": 196,
    "question": "You have been asked to update your entire fleet of Internet-facing webservers to remediate a critical bug. Your supervisor has agreed to operate under reduced computing capacity during the process but stipulates that there can be no downtime. What upgrade approach should you recommend that your company follow to meet these requirements?",
    "choice_a": "Orchestration",
    "choice_b": "Rolling",
    "choice_c": "Hotfix",
    "choice_d": "Blue-green",
    "correct_answer": "B",
    "explanation": "A rolling configuration will sequentially upgrade the webservers without causing a complete outage and would meet the requirements outlined in the question.",
    "topic_id": 2,
    "practice_test_id": 3,
    "related_articles": [
      114,
      132,
      31,
      29,
      66
    ],
    "source": "333776_Ch05"
  },
  {
    "id": 197,
    "question": "Before a new patch is released to the public, the release manager at a large software development house has requested a report that shows the pass/fail data to verify that the fix does, in fact, work. She is requesting data about the issue it was intended to fix and the results of the tests performed to make sure that the fix does not interfere with other processes and that there are no memory or buffer issues experienced with the patched version of software. What process is she verifying?",
    "choice_a": "Rollout",
    "choice_b": "Orchestration",
    "choice_c": "Automation",
    "choice_d": "QA",
    "correct_answer": "D",
    "explanation": "The manager is requesting data on the results of the quality assurance testing on the release. Rollout is a patch deployment process, and both automation and orchestration systems are used to install the patch.",
    "topic_id": 3,
    "practice_test_id": 5,
    "related_articles": [
      116,
      122,
      177,
      160,
      149
    ],
    "source": "333776_Ch05"
  },
  {
    "id": 198,
    "question": "You company\u2019s primary application is critical to the power generation industry and must be highly available. When critical patches need to be installed, downtime is not an option that your customers can tolerate. You have designed a web architecture to take this into account and that allows you to have an exact copy of your production fleet that can be brought online to replace your existing deployment for patching and maintenance. What type of model did you implement?",
    "choice_a": "Cluster",
    "choice_b": "DevOps",
    "choice_c": "Blue-green",
    "choice_d": "Rolling",
    "correct_answer": "C",
    "explanation": "Blue-green is a software deployment methodology that uses two configurations for production that are identical to each other. These deployments can alternate between each other, with one being active and the other being inactive.",
    "topic_id": 2,
    "practice_test_id": 4,
    "related_articles": [
      114,
      132,
      29,
      33,
      45
    ],
    "source": "333776_Ch05"
  },
  {
    "id": 199,
    "question": "What type of backup operation is based on the change of the source data since the last backup was performed?",
    "choice_a": "Full",
    "choice_b": "Differential",
    "choice_c": "Incremental",
    "choice_d": "Online",
    "correct_answer": "C",
    "explanation": "Incremental backups are operations based on the change of the source data since the last incremental backup was performed. Incremental backups can be run, for example, on a nightly basis and capture the changes that were made since the previous backup was run the night before. This allows for an efficient backup operation since only the changes in the past 24 hours are stored on the backup media. Incremental backups are much less time- and resource-consuming than full backups and are used to complement them.",
    "topic_id": 3,
    "practice_test_id": 4,
    "related_articles": [
      126,
      129,
      119,
      46,
      128
    ],
    "source": "333776_Ch05"
  },
  {
    "id": 200,
    "question": "What backup solution requires an administrator or tape jukebox to make it available by inserting a tape or other media into a storage system for retrieval?",
    "choice_a": "SAN A/B",
    "choice_b": "FCON",
    "choice_c": "Cluster",
    "choice_d": "Offline",
    "correct_answer": "D",
    "explanation": "Offline storage requires the administrator to make the data available by inserting a tape or other media into a storage system for retrieval. Offline storage can be transported to remote storage facilities or stored in vaults for protection.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      130,
      129,
      125,
      139,
      46
    ],
    "source": "333776_Ch05"
  },
  {
    "id": 201,
    "question": "Data replication is often used to store copies of real-time data in remote zones. When there is a need to have the master data immediately updated, and then update the remote zones on the backend, what type of replication would you recommend that your operations department configure?",
    "choice_a": "Synchronous",
    "choice_b": "Asynchronous",
    "choice_c": "Volume sync",
    "choice_d": "Mirroring",
    "correct_answer": "B",
    "explanation": "Asynchronous replication is when data is written to the primary first, and then later a copy is written to the remote site on a scheduled arrangement or after a delay.",
    "topic_id": 1,
    "practice_test_id": 6,
    "related_articles": [
      131,
      27,
      135,
      141,
      21
    ],
    "source": "333776_Ch06",
    "choice_e": "RAID 5"
  },
  {
    "id": 202,
    "question": "Sharon has been directed to put together a disaster recovery (DR) plan based on directives from her company\u2019s executive management team. The company\u2019s core business is operating an e-commerce website selling winter apparel, with 85 percent of its revenue received during the holiday season. If there was a prolonged outage, it would put the company\u2019s ability to continue as a financially viable operation in peril. Sharon has been instructed to create a plan that will restore operations in the shortest amount of time possible. What DR model should she implement?",
    "choice_a": "Hot site",
    "choice_b": "Active/active",
    "choice_c": "Warm site",
    "choice_d": "Active/passive",
    "correct_answer": "A",
    "explanation": "The hot site model is the most viable option given the requirements. A hot site is a fully functional backup site that can assume operations immediately should the primary location fail or go offline.",
    "topic_id": 1,
    "practice_test_id": 5,
    "related_articles": [
      135,
      141,
      138,
      2,
      35
    ],
    "source": "333776_Ch06",
    "choice_e": "Cold site",
    "choice_f": "Rollover"
  },
  {
    "id": 203,
    "question": "Which disaster recovery metrics are used to create a measurable SLA that outlines when you can expect your systems to be back online and how much data loss you sustained after an outage? (Choose all that apply.)",
    "choice_a": "RSO",
    "choice_b": "RTO",
    "choice_c": "RPO",
    "choice_d": "DR",
    "correct_answer": [
      "B",
      "C"
    ],
    "explanation": "The restore point and restore time objectives are the measurements for data loss and the time needed to get back online after an outage, respectively.",
    "topic_id": 1,
    "practice_test_id": 4,
    "related_articles": [
      141,
      135,
      131,
      138,
      21
    ],
    "source": "333776_Ch06",
    "choice_e": "VxRestore"
  },
  {
    "id": 204,
    "question": "These cloud facilities provide the ability to connect locally for fast, low-latency connections to the DR location. They can also store, or cache, data at these locations for very fast responses to local user requests.",
    "choice_a": "Region",
    "choice_b": "Edge location",
    "choice_c": "Availability zone",
    "choice_d": "Replication",
    "correct_answer": "B",
    "explanation": "Edge locations are not complete cloud data centers. They are cloud connection points located in major cities and offer the benefits outlined in the question.",
    "topic_id": 1,
    "practice_test_id": 1,
    "related_articles": [
      146,
      40,
      131,
      21,
      141
    ],
    "source": "333776_Ch06"
  },
  {
    "id": 205,
    "question": "Computer operating systems have mechanisms that grant rights to users for access to system objects like storage volume directories and files, administrator rights, and so on. What should you monitor to make sure that old or unused entries are deleted?",
    "choice_a": "Stale cache",
    "choice_b": "Access control",
    "choice_c": "MFA",
    "choice_d": "Dashboard",
    "correct_answer": "B",
    "explanation": "Access control systems are used to grant users object access in an operating system. For ongoing maintenance and best security practices, it is important to delete old and unused access control policies.",
    "topic_id": 3,
    "practice_test_id": 6,
    "related_articles": [
      152,
      153,
      160,
      149,
      174
    ],
    "source": "333776_Ch06"
  },
  {
    "id": 206,
    "question": "James has been directed by his employer\u2019s finance department that they cannot afford to lose any more than 30 minutes of data in case of a database failure or other catastrophic event. James has updated his corporate business continuity plan and has had his cloud provider update its SLA. What was the metric that was changed?",
    "choice_a": "RSO",
    "choice_b": "RPO",
    "choice_c": "RTO",
    "choice_d": "DBO",
    "correct_answer": "B",
    "explanation": "The restore point objective is the point in time at which data can be recovered. James had to update the RPO metric.",
    "topic_id": 1,
    "practice_test_id": 7,
    "related_articles": [
      141,
      131,
      21,
      138,
      143
    ],
    "source": "333776_Ch06"
  },
  {
    "id": 207,
    "question": "To meet regulatory requirements, Jill must store customer transaction records for seven years. The data will most likely never be accessed after the second year and can be stored offline to reduce storage costs. What type of storage operation can Jill implement to achieve her goal?",
    "choice_a": "File transfer",
    "choice_b": "Archive",
    "choice_c": "Replication",
    "choice_d": "Data store",
    "correct_answer": "B",
    "explanation": "Moving inactive data or data that is no longer being used to a separate storage facility for long-term storage is referred to as archiving. It can be more cost-effective to store archived data in less expensive storage systems and still allow the cloud consumer access to that data for backup and retrieval as needed.",
    "topic_id": 1,
    "practice_test_id": 6,
    "related_articles": [
      58,
      50,
      52,
      54,
      2
    ],
    "source": "333776_Ch06"
  },
  {
    "id": 208,
    "question": "Sharon is a network engineer for your firm and is investigating the WAN connection into the hot site. In the event of operations being moved to the backup location, she wants to make sure that the load capacity is available. What should she be most concerned about? (Choose two.)",
    "choice_a": "Traffic normalization",
    "choice_b": "Peak capacity",
    "choice_c": "QOS",
    "choice_d": "SLA",
    "correct_answer": [
      "B",
      "F"
    ],
    "explanation": "The backup site\u2019s network connections must be engineered to accept the expected traffic load and prevent bandwidth starvation.",
    "topic_id": 1,
    "practice_test_id": 4,
    "related_articles": [
      138,
      135,
      141,
      146,
      21
    ],
    "source": "333776_Ch06",
    "choice_e": "Packet loss and jitter",
    "choice_f": "Bandwidth starvation"
  },
  {
    "id": 209,
    "question": "If you have regularly scheduled backups for your cloud storage volumes, you can configure the cloud provider to perform specific operations for you using what backend systems?",
    "choice_a": "Replication",
    "choice_b": "Automation",
    "choice_c": "Synchronous",
    "choice_d": "Block chain based",
    "correct_answer": "B",
    "explanation": "Automation systems are backend processes for frontend systems such as dashboards or catalogs.",
    "topic_id": 3,
    "practice_test_id": 6,
    "related_articles": [
      149,
      129,
      105,
      122,
      160
    ],
    "source": "333776_Ch06"
  },
  {
    "id": 210,
    "question": "What service provides permit and deny policies that require regular review to delete unused entries?",
    "choice_a": "DNS",
    "choice_b": "DHCP",
    "choice_c": "Firewalls",
    "choice_d": "Active Directory",
    "correct_answer": "C",
    "explanation": "Firewalls contain a list of policies, or rules, that permit or deny traffic. Over time, as the environment changes, it is a best practice to review the firewall rules and remove or modify any rules that are obsolete or unused.",
    "topic_id": 1,
    "practice_test_id": 3,
    "related_articles": [
      8,
      70,
      91,
      24,
      113
    ],
    "source": "333776_Ch06"
  },
  {
    "id": 211,
    "question": "Christina has been pinging a new webserver by its URL and getting strange and seemingly unexplainable responses from unrecognized systems. She recalls that the new web farm is on a reclaimed subnet that was no longer in use in their cloud server fleet. What would you recommend that she investigate to resolve the issue?",
    "choice_a": "DHCP",
    "choice_b": "Orphaned services",
    "choice_c": "Stale network access control lists",
    "choice_d": "DNS",
    "correct_answer": "D",
    "explanation": "Stale or out-of-date domain name entries may point to servers that are no longer in use.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      39,
      11,
      36,
      16,
      8
    ],
    "source": "333776_Ch06"
  },
  {
    "id": 212,
    "question": "During a disaster recovery switchover, what network services may need to be modified as part of a multisite failover to the backup site? (Choose all that apply.)",
    "choice_a": "RADIUS",
    "choice_b": "TACACS",
    "choice_c": "DHCP",
    "choice_d": "FTP",
    "correct_answer": "H",
    "explanation": "It is important to review all of your network services to address any changes required when implementing a disaster recovery plan.",
    "topic_id": 1,
    "practice_test_id": 4,
    "related_articles": [
      138,
      70,
      39,
      16,
      135
    ],
    "source": "333776_Ch06",
    "choice_e": "DNS",
    "choice_f": "Active Directory",
    "choice_g": "None of the above",
    "choice_h": "All of the above"
  },
  {
    "id": 213,
    "question": "Mark has been reviewing disaster recovery planning, and after receiving direction from his company\u2019s board of directors, it has been determined that they can only withstand a maximum of 36 hours of downtime. Mark is updating his DR plan with this new metric. What part of the plan should he modify?",
    "choice_a": "RSO",
    "choice_b": "RPO",
    "choice_c": "RTO",
    "choice_d": "DBO",
    "correct_answer": "C",
    "explanation": "The recovery time objective is the amount of time a system can be offline during a disaster. It is the amount of time it takes to get a service online and available after a failure.",
    "topic_id": 1,
    "practice_test_id": 1,
    "related_articles": [
      135,
      141,
      138,
      143,
      146
    ],
    "source": "333776_Ch06"
  },
  {
    "id": 214,
    "question": "Jack is preparing to update his company\u2019s business continuity with details on its DR backup site. His plan is to have a facility ready with floor space, power, and cooling that has facilities for him to load in his server racks to restore service. What type of DR implementation is Jack deploying?",
    "choice_a": "Hot site",
    "choice_b": "Active/active",
    "choice_c": "Warm site",
    "choice_d": "Active/passive",
    "correct_answer": "E",
    "explanation": "A cold site is a backup data center provisioned to take over operations in the event of a primary data center failure, but the servers and infrastructure are not deployed or operational until needed.",
    "topic_id": 1,
    "practice_test_id": 6,
    "related_articles": [
      135,
      143,
      141,
      138,
      146
    ],
    "source": "333776_Ch06",
    "choice_e": "Cold site",
    "choice_f": "Rollover"
  },
  {
    "id": 215,
    "question": "Will is running his backup DR site in a DNS load-balancing rotation for testing. He needs to ensure that the database in the DR facility is updated in real time and current with the production replica in the primary data center. What type of updates should he define in his primary data center servers before enabling DNS load balancing?",
    "choice_a": "Synchronous replication",
    "choice_b": "Asynchronous replication",
    "choice_c": "Volume sync",
    "choice_d": "Mirroring",
    "correct_answer": "A",
    "explanation": "Synchronous replication offerings write data to both the primary storage system and the replica simultaneously to ensure that the remote data is current with local replicas.",
    "topic_id": 1,
    "practice_test_id": 5,
    "related_articles": [
      131,
      135,
      18,
      70,
      138
    ],
    "source": "333776_Ch06",
    "choice_e": "RAID 5"
  },
  {
    "id": 216,
    "question": "What DR location can be used to cache data close to your customer and ease access to your fleet of webservers?",
    "choice_a": "Hot",
    "choice_b": "Warm",
    "choice_c": "Cold",
    "choice_d": "Edge",
    "correct_answer": "D",
    "explanation": "Cloud edge locations are often used for proximity services at remote locations that provide data caching locally and offloads the need for calls to the webserver fleet.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      40,
      131,
      146,
      21,
      18
    ],
    "source": "333776_Ch06",
    "choice_e": "Zone",
    "choice_f": "Region"
  },
  {
    "id": 217,
    "question": "Jerry noticed on his WAN monitoring dashboard that there are peaks of traffic flow from the primary to his hot site. What two things might be taking place?",
    "choice_a": "Synchronous replication",
    "choice_b": "Asynchronous replication",
    "choice_c": "File transfer",
    "choice_d": "Continuity updates",
    "correct_answer": [
      "A",
      "B"
    ],
    "explanation": "Synchronous and asynchronous replication are ongoing file synchronization processes.",
    "topic_id": 1,
    "practice_test_id": 4,
    "related_articles": [
      131,
      135,
      138,
      71,
      27
    ],
    "source": "333776_Ch06"
  },
  {
    "id": 218,
    "question": "Tom has been performing an ongoing inventory of his public cloud assets and has found a number of storage volumes, CPU allocations, VMs, and firewall instances that are not connected to any project and are not being used. On what services is Tom collecting data?",
    "choice_a": "DNS",
    "choice_b": "Stale services",
    "choice_c": "Orphaned resources",
    "choice_d": "Dashboard service",
    "correct_answer": "C",
    "explanation": "Orphaned resources are left over when a service terminates and they are no longer needed or used.",
    "topic_id": 3,
    "practice_test_id": 6,
    "related_articles": [
      153,
      156,
      200,
      154,
      179
    ],
    "source": "333776_Ch06"
  },
  {
    "id": 219,
    "question": "Hank is preparing a disaster recovery test drill in advance of the upcoming hurricane season along the Gulf. His plan is to create a DR location in the Midwest and have a database server running at that location with a synchronously refreshed data replica. His DR plan calls for activating all other services in the event of a hurricane causing an outage at his primary data center. What model is Hank going to deploy to meet his requirements?",
    "choice_a": "Hot site",
    "choice_b": "Warm site",
    "choice_c": "Cold site",
    "choice_d": "Active/passive",
    "correct_answer": "B",
    "explanation": "A warm site approach to recovering from a primary data center outage is when the remote backup of the site is offline except for critical data storage, which is usually a database. The warm site will host an operational database server that is in sync with the database server at the primary data center and is sometimes referred to as the candlelight or pilot light design.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      135,
      131,
      143,
      141,
      138
    ],
    "source": "333776_Ch06"
  },
  {
    "id": 220,
    "question": "Carl has been investigating stale records in his database that were added by other applications but never deleted or timed out after they were no longer in use. This mappings application is now causing issues with the server addressing and troubleshooting. What system is he looking at?",
    "choice_a": "SNMP",
    "choice_b": "DHCP",
    "choice_c": "DNS",
    "choice_d": "FTP",
    "correct_answer": "C",
    "explanation": "DNS records can be modified by external operations and can map domain names to IP addresses. There you will find occurrences of DNS entries not being deleted and becoming stale over time.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      70,
      36,
      8,
      11,
      16
    ],
    "source": "333776_Ch06"
  },
  {
    "id": 221,
    "question": "Carol is collecting information on objects to monitor in her community cloud deployment. She is interested in establishing a baseline to produce a trend analysis report. What are some objects that she could natively monitor? (Choose all that apply.)",
    "choice_a": "Availability",
    "choice_b": "Instance initialization time",
    "choice_c": "Task runtime",
    "choice_d": "Total storage capacity",
    "correct_answer": "G",
    "explanation": "All of the options listed are valid metrics for establishing a baseline.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      175,
      173,
      176,
      178,
      183
    ],
    "source": "333776_Ch07",
    "choice_e": "MTBF",
    "choice_f": "None of the above",
    "choice_g": "All of these"
  },
  {
    "id": 222,
    "question": "An organization wants to know what its normal day-to-day web hit count is so that it can plan for the upcoming holiday selling season. Jim\u2019s job is to measure the incoming web requests and graph them against delayed and missed connection counts. What type of dataset is Jim producing?",
    "choice_a": "Metric",
    "choice_b": "Variance",
    "choice_c": "Baseline",
    "choice_d": "Smoothing",
    "correct_answer": "C",
    "explanation": "The establishment of average usage over time is collected for a baseline report.",
    "topic_id": 3,
    "practice_test_id": 6,
    "related_articles": [
      175,
      157,
      173,
      161,
      178
    ],
    "source": "333776_Ch07"
  },
  {
    "id": 223,
    "question": "Elaine works in IT security, and she is reviewing user count policies. She needs to strengthen passwords by enforcing a mandatory minimum of a nondictionary word that is six or more characters in length, contains at least one uppercase letter, and contains a special character. What is she defining?",
    "choice_a": "Object access",
    "choice_b": "User policy",
    "choice_c": "Complexity",
    "choice_d": "SSO",
    "correct_answer": "C",
    "explanation": "Password complexity defines password length, if it is a nondictionary word, and if uppercase/lowercase or special characters are required.",
    "topic_id": 4,
    "practice_test_id": 5,
    "related_articles": [
      166,
      165,
      89,
      75,
      102
    ],
    "source": "333776_Ch07",
    "choice_e": "Federation policy",
    "choice_f": "Firewall zone rules"
  },
  {
    "id": 224,
    "question": "Michelle has been tasked by the IT security group in his company to prevent dictionary login attacks to the company\u2019s VMs running in a private cloud at a remote data center. You have been brought in to offer him advice to deter the random but steady login attacks. What would you recommend he enable to help prevent this type of cyberattack?",
    "choice_a": "Object",
    "choice_b": "SSO",
    "choice_c": "LDAP",
    "choice_d": "Lockout",
    "correct_answer": "D",
    "explanation": "A lockout policy can be applied to an account that defines the parameters that create a lockup event. It is most common to apply a lockout policy to failed login attempts. For example, you can define a policy where four failed login attempts in five minutes will disable an account for 30 minutes. A lockout policy will most likely be defined by your information security group, and you may be asked to create and apply the policy as part of your duties.",
    "topic_id": 4,
    "practice_test_id": 6,
    "related_articles": [
      166,
      89,
      165,
      97,
      87
    ],
    "source": "333776_Ch07",
    "choice_e": "Access control list"
  },
  {
    "id": 225,
    "question": "Christina is configuring her public cloud object storage bucket for granular access from a new Linux VM. She wants to set the permissions on the storage system. What would you recommend?",
    "choice_a": "Access control list authorization",
    "choice_b": "Federations",
    "choice_c": "Permission-based",
    "choice_d": "SSO",
    "correct_answer": "A",
    "explanation": "Access control systems are user configurations that grant roles and duties to users or groups of users and also to systems such as VMs, applications, and storage volumes. For example, database administrators can be given full access to manage a database application but be restricted from performing VM or storage operations.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      68,
      60,
      167,
      92,
      69
    ],
    "source": "333776_Ch07"
  },
  {
    "id": 226,
    "question": "Liza is reviewing the maintenance responsibilities between her company and its public cloud service provider. She notices that the cloud provider takes responsibility for the operating system, and she needs to assume responsibility for any applications or services running on the operating system. Under what type of service model is she operating?",
    "choice_a": "IaaS",
    "choice_b": "PaaS",
    "choice_c": "SaaS",
    "choice_d": "XaaS",
    "correct_answer": "B",
    "explanation": "With the Platform-as-a-Service (PaaS) model, the cloud provider will maintain the operating system and all supporting infrastructure.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      41,
      174,
      170,
      172,
      46
    ],
    "source": "333776_Ch07"
  },
  {
    "id": 227,
    "question": "Dawn has been working in the network operations center (NOC) and has been tasked with performing a root-cause analysis on a recent outage that affected the middle-tier web stack in a private cloud. She is looking at the log files and notices that there are more than 430 logs that were generated around the time the site failed. What function does Dawn need to perform to distill all of these log files into a meaningful report?",
    "choice_a": "Baseline",
    "choice_b": "Event analysis",
    "choice_c": "Event correlation",
    "choice_d": "Logging",
    "correct_answer": "C",
    "explanation": "The process of taking a large amount of event data and comparing the logs to determine the sequence of events is referred to as event correlation.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      195,
      150,
      34,
      162,
      157
    ],
    "source": "333776_Ch07"
  },
  {
    "id": 228,
    "question": "To increase her organization\u2019s security posture, Allison is reviewing user accounts that access the fleet cloud resources. Allison notices that, although the summer interns have left to go back to school, their accounts are still active. She knows that they will return for the winter corporate announcements and new-product rollouts to assist in the project over winter break. What would you suggest Allison do with these accounts?",
    "choice_a": "Do nothing.",
    "choice_b": "Delete the accounts.",
    "choice_c": "Disable the accounts.",
    "choice_d": "Change the resource access definitions.",
    "correct_answer": "C",
    "explanation": "The ability to disable an account can be helpful in situations where the account will need to be reactivated at a future date and does not need to be deleted. Account disablement can be managed in the same manner as other account operations, with a web frontend or with the use of APIs for scripted and automated processes.",
    "topic_id": 4,
    "practice_test_id": 3,
    "related_articles": [
      166,
      165,
      89,
      87,
      75
    ],
    "source": "333776_Ch07",
    "choice_e": "Modify the confederation settings.",
    "choice_f": "Change the access control."
  },
  {
    "id": 229,
    "question": "To make sure that all users can access only approved resources, Marie is auditing her public cloud identity systems. She wants to control specific access and operations. What is Marie defining?",
    "choice_a": "Federated access",
    "choice_b": "Resource-based policies",
    "choice_c": "User-based policies",
    "choice_d": "Access control lists",
    "correct_answer": "C",
    "explanation": "User-based policies are tied to a user and define which permissions a user has. Contrast these with resource-based policies, which are tied to a particular resource.",
    "topic_id": 4,
    "practice_test_id": 6,
    "related_articles": [
      167,
      165,
      68,
      94,
      75
    ],
    "source": "333776_Ch07"
  },
  {
    "id": 230,
    "question": "To promote consistent cloud monitoring and to reduce configuration overhead, Lisa has created a number of policies to obtain baseline data. What type of policies is Lisa creating?",
    "choice_a": "Collection",
    "choice_b": "Dissemination",
    "choice_c": "Notification",
    "choice_d": "Publishing",
    "correct_answer": "A",
    "explanation": "Once the collection policy has been created, it can be reused and applied to other objects as they are created or migrated. Event collection policies reduce the amount of management overhead and enforce consistency in your deployments.",
    "topic_id": 3,
    "practice_test_id": 6,
    "related_articles": [
      162,
      173,
      175,
      157,
      161
    ],
    "source": "333776_Ch07"
  },
  {
    "id": 231,
    "question": "Matt is preparing for an upcoming promotion his company is offering during a major soccer game. He needs to determine his options to add capacity to his company\u2019s webserver farm so that it can handle the anticipated additional workload. You are brought in to consult with him on his options. What do you recommend as possible solutions? (Choose three.)",
    "choice_a": "Vertical scaling",
    "choice_b": "Horizontal scaling",
    "choice_c": "Edge cache",
    "choice_d": "Cloud bursting",
    "correct_answer": [
      "A",
      "B",
      "D"
    ],
    "explanation": "Cloud computing operates with a utility business model that charges you only for the resources that you consume. This model enables you to scale your cloud fleet to meet its current workload and be able to add and remove capacity as needed. There are many options for using elasticity to scale cloud operations, including vertical and horizontal scaling and bursting.",
    "topic_id": 3,
    "practice_test_id": 7,
    "related_articles": [
      22,
      163,
      170,
      164,
      208
    ],
    "source": "333776_Ch07",
    "choice_e": "Core elasticity"
  },
  {
    "id": 232,
    "question": "Bob is configuring an event notification service and notices that there are many different devices and services that can be subscribers to the notification system\u2019s published events queue. The notification services offer each event to be sent to a fan-out of multiple devices that can act upon the received information. What are examples of the notification server\u2019s receivers? (Choose all that apply.)",
    "choice_a": "A smartphone application",
    "choice_b": "Email",
    "choice_c": "APIs",
    "choice_d": "Service queues",
    "correct_answer": "F",
    "explanation": "All of the answers offered are valid event notification service receivers.",
    "topic_id": 3,
    "practice_test_id": 5,
    "related_articles": [
      158,
      162,
      34,
      157,
      195
    ],
    "source": "333776_Ch07",
    "choice_e": "Text message",
    "choice_f": "All of these"
  },
  {
    "id": 233,
    "question": "Samantha has been monitoring her cloud webserver dashboard, and she notices that the CPU utilization on her company\u2019s database servers has been consistently at more than 80 percent. She checked her baselines and reported that 57 percent utilization is normal. What is she noticing?",
    "choice_a": "Deviation",
    "choice_b": "Variance",
    "choice_c": "Triggers",
    "choice_d": "Baseline imbalance",
    "correct_answer": "B",
    "explanation": "The measurement of the difference between a current reading and the baseline value is referred to as the variance.",
    "topic_id": 3,
    "practice_test_id": 6,
    "related_articles": [
      175,
      177,
      173,
      157,
      183
    ],
    "source": "333776_Ch07"
  },
  {
    "id": 234,
    "question": "Mindy has a SQL database backend that runs on a multi-CPU instance that has reached 100 percent utilization. The database supports a single server. What options does she have to support the requirements of this database?",
    "choice_a": "Horizontal scaling",
    "choice_b": "Vertical scaling",
    "choice_c": "Pooling",
    "choice_d": "Bursting",
    "correct_answer": "B",
    "explanation": "Scaling up, or vertical scaling, will add resources such as CPU instances or more RAM. When you scale up, you are basically increasing your compute, network, or storage capabilities.",
    "topic_id": 3,
    "practice_test_id": 6,
    "related_articles": [
      199,
      163,
      208,
      182,
      183
    ],
    "source": "333776_Ch07"
  },
  {
    "id": 235,
    "question": "What is the ability to dynamically add resources such as storage, CPUs, memory, and even servers?",
    "choice_a": "Bursting",
    "choice_b": "Pooling",
    "choice_c": "Elasticity",
    "choice_d": "Orchestration",
    "correct_answer": "C",
    "explanation": "Cloud automation systems offer the ability to dynamically add and remove resources as needed; this is referred to as elasticity.",
    "topic_id": 3,
    "practice_test_id": 7,
    "related_articles": [
      22,
      208,
      105,
      161,
      173
    ],
    "source": "333776_Ch07"
  },
  {
    "id": 236,
    "question": "Ethel is the network architect for a hybrid cloud operation and has interconnected her private cloud to a community cloud in another state. She is investigating using the community cloud to supplement her private cloud operations during end-of-month processing. What operation is she going to perform?",
    "choice_a": "Elasticity",
    "choice_b": "Bursting",
    "choice_c": "Vertical scaling",
    "choice_d": "Autoscaling",
    "correct_answer": "B",
    "explanation": "Cloud bursting allows for adding capacity from another cloud service during times when additional compute resources are needed.",
    "topic_id": 3,
    "practice_test_id": 1,
    "related_articles": [
      170,
      22,
      208,
      161,
      183
    ],
    "source": "333776_Ch07"
  },
  {
    "id": 237,
    "question": "George and Wendy are working together as cloud engineers to combine two like systems into one. What type of activity would necessitate this? (Choose two.)",
    "choice_a": "Merger",
    "choice_b": "Acquisition",
    "choice_c": "Divestiture",
    "choice_d": "Bursting",
    "correct_answer": [
      "A",
      "B"
    ],
    "explanation": "Mergers and acquisitions may necessitate combining two cloud operations into one single system. You should be prepared to work with new groups and departments to look at how the other company\u2019s cloud deployment is architected and what options are available to integrate them. Applications may be duplicated, and there could be efficiencies gained by integrating them.",
    "topic_id": 3,
    "practice_test_id": 3,
    "related_articles": [
      169,
      171,
      172,
      160,
      148
    ],
    "source": "333776_Ch07",
    "choice_e": "SARBOX",
    "choice_f": "HIPAA"
  },
  {
    "id": 238,
    "question": "Allison is preparing to modify a network access control list and add three firewall rules to her private cloud HR systems. She is planning on submitting a detailed plan to accomplish these tasks. What process is Allison following?",
    "choice_a": "Cloud automation",
    "choice_b": "Change advisory",
    "choice_c": "Change management",
    "choice_d": "Rollout",
    "correct_answer": "C",
    "explanation": "Change management includes recording the change, planning for the change, testing the documentation, getting approvals, evaluating, validating, writing instructions for backing out the change if needed, and doing a post-change review if desired.",
    "topic_id": 3,
    "practice_test_id": 6,
    "related_articles": [
      160,
      174,
      148,
      154,
      116
    ],
    "source": "333776_Ch07"
  },
  {
    "id": 239,
    "question": "What does the application lifecycle include?",
    "choice_a": "Deployments",
    "choice_b": "Upgrades",
    "choice_c": "Migrations",
    "choice_d": "Retirements",
    "correct_answer": "F",
    "explanation": "Managing the lifecycle of an application includes deployments, upgrades, migrations, feature additions and deletions, replacements, and retirements.",
    "topic_id": 3,
    "practice_test_id": 3,
    "related_articles": [
      168,
      174,
      171,
      169,
      149
    ],
    "source": "333776_Ch07",
    "choice_e": "None of the above",
    "choice_f": "All of the above"
  },
  {
    "id": 240,
    "question": "Dimitry has been tasked to develop a cross-cloud provider migration plan as part of his company\u2019s business continuity plan. As he assesses the feasibility of migrating applications from one public cloud provider to another, what does he find is the service model that has the most lock-ins and is the most complex to migrate?",
    "choice_a": "IaaS",
    "choice_b": "PaaS",
    "choice_c": "SaaS",
    "choice_d": "XaaS",
    "correct_answer": "C",
    "explanation": "The higher up the services stack you go, from IaaS to SaaS, the more difficult it will be to migrate. With Infrastructure-as-a-Service (IaaS), most of the cloud operations are under your direct control, which gives you the most flexibility to migrate. However, if the cloud provider controls the application, you may not have many options to migrate.",
    "topic_id": 6,
    "practice_test_id": null,
    "related_articles": [
      191,
      202,
      186,
      209,
      222
    ],
    "source": "333776_Ch07"
  },
  {
    "id": 241,
    "question": "When monitoring performance metrics on one of your servers, you notice that the server is utilizing 100 percent of the network bandwidth available to it. What modification could you make to the server that will most likely address the problem?",
    "choice_a": "Add memory to the system.",
    "choice_b": "Install a second network adapter.",
    "choice_c": "Update the network adapter\u2019s firmware.",
    "choice_d": "Install a second processor.",
    "correct_answer": "B",
    "explanation": "If a server is using all of its network bandwidth, then the most logical solution is to add more. You can do this by installing a second network adapter and connecting it to a different subnet. The other solutions could conceivably address the problem, but success is less likely.",
    "topic_id": 6,
    "practice_test_id": 3,
    "related_articles": [
      220,
      228,
      213,
      226,
      224
    ],
    "source": "333776_Ch08"
  },
  {
    "id": 242,
    "question": "Which of the following is not a statistic that you would typically find in a server performance baseline?",
    "choice_a": "CPU utilization",
    "choice_b": "Disk transfer rate",
    "choice_c": "Network transmissions speed",
    "choice_d": "OS update history",
    "correct_answer": "D",
    "explanation": "Performance baselines characterize hardware performance, so the OS update history would be of little or no use for future comparisons. A server baseline typically consists of CPU, memory, disk, and network performance statistics.",
    "topic_id": 3,
    "practice_test_id": 5,
    "related_articles": [
      175,
      51,
      176,
      177,
      183
    ],
    "source": "333776_Ch08",
    "choice_e": "Memory utilization"
  },
  {
    "id": 243,
    "question": "What type of scaling involves replacing an existing server with another that has more capabilities?",
    "choice_a": "Horizontal",
    "choice_b": "Round-robin",
    "choice_c": "Elasticity",
    "choice_d": "Autoscale",
    "correct_answer": "E",
    "explanation": "Vertical scaling is the process of upgrading or replacing a server with one that has greater capabilities.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      163,
      182,
      199,
      208,
      183
    ],
    "source": "333776_Ch08",
    "choice_e": "Vertical"
  },
  {
    "id": 244,
    "question": "Incident reports include which of the following? (Choose three.)",
    "choice_a": "Trouble tickets",
    "choice_b": "SLAs",
    "choice_c": "Scaling",
    "choice_d": "Support engagements",
    "correct_answer": [
      "A",
      "D",
      "E"
    ],
    "explanation": "Incident reports include events such as opening trouble tickets and contacting customer support and outages. Scaling and service level agreements are not considered impairments.",
    "topic_id": 6,
    "practice_test_id": null,
    "related_articles": [
      185,
      186,
      187,
      159,
      227
    ],
    "source": "333776_Ch08",
    "choice_e": "Outages"
  },
  {
    "id": 245,
    "question": "How can relational database read performance be improved? (Choose all that apply.)",
    "choice_a": "Adding a read replica",
    "choice_b": "Scaling vertically",
    "choice_c": "Autosizing",
    "choice_d": "Scoping horizontally",
    "correct_answer": [
      "A",
      "B"
    ],
    "explanation": "Most databases are designed to scale vertically. They can also be scaled (not scoped) horizontally by adding a read replica.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      201,
      181,
      17,
      208,
      183
    ],
    "source": "333776_Ch08"
  },
  {
    "id": 246,
    "question": "Cloud provider SLAs outline which of the following? (Choose two.)",
    "choice_a": "Device configuration",
    "choice_b": "DNS configurations",
    "choice_c": "Uptime",
    "choice_d": "Network performance",
    "correct_answer": [
      "C",
      "D"
    ],
    "explanation": "Service level agreements outline performance and availability commitments and not configurations.",
    "topic_id": 1,
    "practice_test_id": 3,
    "related_articles": [
      141,
      24,
      4,
      26,
      21
    ],
    "source": "333776_Ch08",
    "choice_e": "Autocache"
  },
  {
    "id": 247,
    "question": "Reports are often provided to which interested parties? (Choose four.)",
    "choice_a": "Marketing",
    "choice_b": "Management",
    "choice_c": "Cloud provider operations",
    "choice_d": "Accounting",
    "correct_answer": [
      "A",
      "B",
      "D",
      "E"
    ],
    "explanation": "Cloud reporting is intended for internal corporate groups such as marketing, management, accounting, and operations.",
    "topic_id": 1,
    "practice_test_id": 5,
    "related_articles": [
      50,
      4,
      26,
      8,
      2
    ],
    "source": "333776_Ch08",
    "choice_e": "Internal operation centers",
    "choice_f": "Customers"
  },
  {
    "id": 248,
    "question": "To collect metrics, you set up your management application to measure what?",
    "choice_a": "Database",
    "choice_b": "Server",
    "choice_c": "Hypervisor",
    "choice_d": "Objects",
    "correct_answer": "D",
    "explanation": "Objects are queried to gather metric data.",
    "topic_id": 3,
    "practice_test_id": 7,
    "related_articles": [
      157,
      173,
      34,
      175,
      177
    ],
    "source": "333776_Ch08"
  },
  {
    "id": 249,
    "question": "Where are reports generated?",
    "choice_a": "Hypervisors",
    "choice_b": "Databases",
    "choice_c": "Logging servers",
    "choice_d": "Cloud management and monitoring applications",
    "correct_answer": "D",
    "explanation": "Cloud reports are formatted collections of data contained in the management or monitoring applications.",
    "topic_id": 3,
    "practice_test_id": 7,
    "related_articles": [
      34,
      105,
      157,
      173,
      158
    ],
    "source": "333776_Ch08"
  },
  {
    "id": 250,
    "question": "What is a visual representation of your current cloud operations?",
    "choice_a": "Operational matrix",
    "choice_b": "Management console",
    "choice_c": "Dashboard",
    "choice_d": "Health check",
    "correct_answer": "C",
    "explanation": "A dashboard is a configurable graphical representation of current operational data.",
    "topic_id": 3,
    "practice_test_id": 6,
    "related_articles": [
      105,
      34,
      173,
      157,
      179
    ],
    "source": "333776_Ch08"
  },
  {
    "id": 251,
    "question": "Upgrading a server to a newer operating system may require that you update what?",
    "choice_a": "The SLA",
    "choice_b": "The server\u2019s DNS hostname",
    "choice_c": "The baseline",
    "choice_d": "The VPC membership",
    "correct_answer": "C",
    "explanation": "After performing a major system upgrade, you should collect new baseline data as the overall system performance has changed.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      175,
      177,
      51,
      173,
      183
    ],
    "source": "333776_Ch08"
  },
  {
    "id": 252,
    "question": "Autoscaling can be configured to which of the following? (Choose four.)",
    "choice_a": "Add capacity",
    "choice_b": "Configure time-of-day capacity",
    "choice_c": "Generate metric reports",
    "choice_d": "Remove capacity",
    "correct_answer": [
      "A",
      "B",
      "D",
      "E"
    ],
    "explanation": "Autoscaling allows for adding and removing cloud compute capacity, providing capacity changes based on the time of day, and maintaining a minimum number of VMs. Report generation and SLA object tracking are not autoscaling functions.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      164,
      14,
      22,
      105,
      161
    ],
    "source": "333776_Ch08",
    "choice_e": "Maintain a minimum number of servers",
    "choice_f": "Track SLA objects",
    "choice_g": "Perform patch management"
  },
  {
    "id": 253,
    "question": "Cloud-based reports can be generated in which formats? (Choose two.)",
    "choice_a": "SQL",
    "choice_b": "PDF",
    "choice_c": "Python",
    "choice_d": "JSON",
    "correct_answer": [
      "B",
      "E"
    ],
    "explanation": "Both Excel and PDF are the most common reporting formats. The other database, programming, and scripting options are not applicable to report generation.",
    "topic_id": 2,
    "practice_test_id": 3,
    "related_articles": [
      20,
      33,
      120,
      112,
      104
    ],
    "source": "333776_Ch08",
    "choice_e": "Excel"
  },
  {
    "id": 254,
    "question": "What type of scaling involves adding servers to a pool?",
    "choice_a": "Horizontal",
    "choice_b": "Round-robin",
    "choice_c": "Elasticity",
    "choice_d": "Autoscale",
    "correct_answer": "A",
    "explanation": "Horizontal scaling is the process of adding extra servers for increased capacity. Round-robin is a load-balancing metric and does not apply. Elasticity is the ability to add and remove resources. Autoscaling is the automated process of adding and removing capacity. Vertical scaling is expanding a server.",
    "topic_id": 3,
    "practice_test_id": 1,
    "related_articles": [
      163,
      199,
      208,
      183,
      164
    ],
    "source": "333776_Ch08",
    "choice_e": "Vertical"
  },
  {
    "id": 255,
    "question": "Carl has noticed a slowdown in the response times of his SQL database and has been tasked with investigating the root cause of the delays. He has decided to configure his monitoring application to gather additional data on what may be the cause of the delays. What are some of the objects on which you would recommend that he collect data? (Choose three.)",
    "choice_a": "Read replica I/O",
    "choice_b": "Load balancer latency",
    "choice_c": "CPU",
    "choice_d": "Network packet drops",
    "correct_answer": [
      "A",
      "C",
      "D"
    ],
    "explanation": "Databases return data from read operations and are a critical performance metric. CPU saturation could cause a slowdown as well as network issues such as packet loss.",
    "topic_id": 3,
    "practice_test_id": 4,
    "related_articles": [
      176,
      157,
      173,
      15,
      181
    ],
    "source": "333776_Ch08",
    "choice_e": "Machine image",
    "choice_f": "SLA"
  },
  {
    "id": 256,
    "question": "Rebecca is writing a change management plan to increase the processing abilities of one of her middleware servers. What components can she upgrade to increase server performance? (Choose three.)",
    "choice_a": "CPU",
    "choice_b": "SLA",
    "choice_c": "RAM",
    "choice_d": "Network I/O",
    "correct_answer": [
      "A",
      "C",
      "D"
    ],
    "explanation": "Server performance can be increased by adding more CPU processing, memory, and network capacity. SLA, ACL, and DNS are not related to increasing server capacity.",
    "topic_id": 1,
    "practice_test_id": 3,
    "related_articles": [
      42,
      43,
      49,
      138,
      50
    ],
    "source": "333776_Ch08",
    "choice_e": "ACL",
    "choice_f": "DNS"
  },
  {
    "id": 257,
    "question": "Servers in high-performance computing clusters share which of the following? (Choose two.)",
    "choice_a": "Availability zone",
    "choice_b": "Group cache",
    "choice_c": "Identity group",
    "choice_d": "Hypervisor",
    "correct_answer": [
      "A",
      "D"
    ],
    "explanation": "High-performance computing relies on the servers being in close proximity to reduce network and storage latency. Being in the same availability zone and on the same hypervisor accomplishes this. There is no such thing as a group cache.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      21,
      3,
      10,
      42,
      71
    ],
    "source": "333776_Ch08"
  },
  {
    "id": 258,
    "question": "Charlotte has noticed an increase in the response time of the SQL database application that she runs in her IaaS deployment. When comparing current results against the baseline measurements that she recorded when the database was deployed, she verified that there has been a steady increase in the number of read requests. What should she focus her troubleshooting on?",
    "choice_a": "Memory",
    "choice_b": "CPU",
    "choice_c": "Storage",
    "choice_d": "Networking",
    "correct_answer": "C",
    "explanation": "Database read and write requests utilize storage I/O and should be the focus for troubleshooting.",
    "topic_id": 6,
    "practice_test_id": 6,
    "related_articles": [
      220,
      212,
      226,
      224,
      159
    ],
    "source": "333776_Ch09"
  },
  {
    "id": 259,
    "question": "What are the recommended procedures to take when preparing an outage response plan? (Choose three.)",
    "choice_a": "Configuration backups",
    "choice_b": "SLA",
    "choice_c": "Documentation",
    "choice_d": "Diagrams",
    "correct_answer": [
      "A",
      "C",
      "D"
    ],
    "explanation": "When troubleshooting, it is helpful to have access to configurations, documentation, and diagrams to provide information on your cloud deployment.",
    "topic_id": 6,
    "practice_test_id": null,
    "related_articles": [
      209,
      204,
      227,
      185,
      224
    ],
    "source": "333776_Ch09",
    "choice_e": "PaaS"
  },
  {
    "id": 260,
    "question": "Jeff has been monitoring resource usage increases in his webserver farm. Based on trending data that he collected, there will be regular requirements to increase CPU capacity for his webservers as usage increases. Jeff wants to use the automation capabilities of his private cloud to automatically use the orchestration software to add CPU cores as required. What can he implement to automate this?",
    "choice_a": "Puppet",
    "choice_b": "Chef",
    "choice_c": "Docker",
    "choice_d": "Autoscaling",
    "correct_answer": "D",
    "explanation": "Cloud autoscaling can dynamically add server capacity based on loading.",
    "topic_id": 3,
    "practice_test_id": 1,
    "related_articles": [
      14,
      164,
      163,
      149,
      208
    ],
    "source": "333776_Ch09",
    "choice_e": "SaaS",
    "choice_f": "OpenStack",
    "choice_g": "Resilient-scaling"
  },
  {
    "id": 261,
    "question": "Amber posted a new software update to her company\u2019s popular smartphone application. After announcing the release, she has been monitoring her dashboard information and has noticed a large spike in activity. What cloud resource should she focus on?",
    "choice_a": "CPU",
    "choice_b": "Network bandwidth",
    "choice_c": "RAM",
    "choice_d": "API",
    "correct_answer": "B",
    "explanation": "A large number of users downloading a new application would cause an increase in network bandwidth usage.",
    "topic_id": 6,
    "practice_test_id": null,
    "related_articles": [
      220,
      228,
      224,
      209,
      212
    ],
    "source": "333776_Ch09",
    "choice_e": "Storage"
  },
  {
    "id": 262,
    "question": "Jim has added a new group of users to his IaaS-based NoSQL database. What license requirements does he need to investigate to ensure compliance? (Choose all that apply.)",
    "choice_a": "Total connections",
    "choice_b": "Named users",
    "choice_c": "Current connections",
    "choice_d": "Usage metrics",
    "correct_answer": "E",
    "explanation": "Any of these answers would be correct depending on his licensing agreement with the database provider.",
    "topic_id": 2,
    "practice_test_id": 4,
    "related_articles": [
      7,
      30,
      32,
      66,
      72
    ],
    "source": "333776_Ch09",
    "choice_e": "All of the above"
  },
  {
    "id": 263,
    "question": "Asher designed an application tier for his company\u2019s new e-commerce site. He decided on using an IP subnet that uses a /28 IPv4 subnet. He is planning for a maximum of 14 servers. You are brought in as a cloud architect to validate his design. What other devices may be on this subnet other than the servers that would also require IP address assignments? (Choose three.)",
    "choice_a": "SLA",
    "choice_b": "Default gateway",
    "choice_c": "DNS",
    "choice_d": "NTP",
    "correct_answer": [
      "B",
      "C",
      "D"
    ],
    "explanation": "In addition to the webservers, IP addresses may be required for the NTP and DNS services and the default gateway.",
    "topic_id": 6,
    "practice_test_id": null,
    "related_articles": [
      210,
      211,
      214,
      220,
      216
    ],
    "source": "333776_Ch09",
    "choice_e": "API",
    "choice_f": "SNMP"
  },
  {
    "id": 264,
    "question": "Colson has been monitoring storage volume utilization and is writing a change request to add capacity. He has decided to automate the volume allocation size. What cloud feature can he take advantage of?",
    "choice_a": "SaaS",
    "choice_b": "API",
    "choice_c": "Elasticity",
    "choice_d": "OpenStack",
    "correct_answer": "C",
    "explanation": "Elasticity allows for cloud services to expand and contract based on actual usage and would be applicable to increasing storage capacity.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      22,
      164,
      200,
      14,
      105
    ],
    "source": "333776_Ch09"
  },
  {
    "id": 265,
    "question": "Performance issues are measured by the load on a system. Which of the following should Jane be concerned about as she integrates her new marketing group into her PaaS cloud fleet?",
    "choice_a": "APIs",
    "choice_b": "Users",
    "choice_c": "Cores",
    "choice_d": "Licensing",
    "correct_answer": "B",
    "explanation": "When troubleshooting cloud performance issues, the current number of users on the system can be an important indicator of load. When there are high user counts, you can track what parts of your deployment are most heavily used and track the load on all of the devices to see where the congestion points are.",
    "topic_id": 6,
    "practice_test_id": null,
    "related_articles": [
      220,
      212,
      228,
      209,
      224
    ],
    "source": "333776_Ch09"
  },
  {
    "id": 266,
    "question": "During a recent downtime window, the server team was applying patches to an application and the networking team was upgrading a router\u2019s interface to 10 Gbps. When the network was down for the upgrade, the server team complained that they could not download the needed software patches. During a post-downtime status meeting, it was determined which process should be modified to prevent this from happening in the future?",
    "choice_a": "Orchestration",
    "choice_b": "Automation",
    "choice_c": "Change management",
    "choice_d": "API calls",
    "correct_answer": "C",
    "explanation": "The change management process would need to be modified to prevent one change from affecting another that is taking place simultaneously.",
    "topic_id": 3,
    "practice_test_id": 7,
    "related_articles": [
      160,
      174,
      148,
      190,
      137
    ],
    "source": "333776_Ch09"
  },
  {
    "id": 267,
    "question": "Jerry is expanding a public subnet in his company\u2019s e-commerce site. After performing the address change for all of his public-facing webservers, he tested connecting from a bastion host located offshore. He was unable to connect. What does he need to change to allow the remote site to connect to the webserver?",
    "choice_a": "NTP",
    "choice_b": "STP",
    "choice_c": "DNS",
    "choice_d": "API",
    "correct_answer": "C",
    "explanation": "The Domain Name System records need to be changed to reflect the new IP address mapped to the domain name.",
    "topic_id": 6,
    "practice_test_id": null,
    "related_articles": [
      214,
      205,
      204,
      227,
      209
    ],
    "source": "333776_Ch09"
  },
  {
    "id": 268,
    "question": "What are software representations of a cloud network?",
    "choice_a": "Automation",
    "choice_b": "Templates",
    "choice_c": "Orchestration",
    "choice_d": "APIs",
    "correct_answer": "B",
    "explanation": "Templates are software definitions of a cloud network and are used for automated deployments.",
    "topic_id": 2,
    "practice_test_id": 1,
    "related_articles": [
      45,
      33,
      120,
      194,
      112
    ],
    "source": "333776_Ch09"
  },
  {
    "id": 269,
    "question": "Capacity boundaries can cause which of the following? (Choose three.)",
    "choice_a": "Application failure",
    "choice_b": "Latency",
    "choice_c": "API abends",
    "choice_d": "Request drops",
    "correct_answer": [
      "A",
      "B",
      "D"
    ],
    "explanation": "Symptoms of reaching the capacity boundary of a service include application failures, increased latency, and request drops.",
    "topic_id": 6,
    "practice_test_id": null,
    "related_articles": [
      196,
      220,
      212,
      224,
      159
    ],
    "source": "333776_Ch09",
    "choice_e": "Workflow loops"
  },
  {
    "id": 270,
    "question": "API request capacity is measured with what metric?",
    "choice_a": "Total lookups per second",
    "choice_b": "Connections per second",
    "choice_c": "Requests per second",
    "choice_d": "IOPS",
    "correct_answer": "C",
    "explanation": "The common measurement for an API is requests per second.",
    "topic_id": 3,
    "practice_test_id": 4,
    "related_articles": [
      34,
      176,
      161,
      178,
      189
    ],
    "source": "333776_Ch09"
  },
  {
    "id": 271,
    "question": "Large batch processing jobs are common for which type of application?",
    "choice_a": "DNS",
    "choice_b": "NTP",
    "choice_c": "Databases",
    "choice_d": "Middleware",
    "correct_answer": "C",
    "explanation": "It is common for batch processing to be performed on database applications.",
    "topic_id": 6,
    "practice_test_id": 7,
    "related_articles": [],
    "source": "333776_Ch09"
  },
  {
    "id": 272,
    "question": "When configuring a machine image, what compute resources do you define? (Choose two.)",
    "choice_a": "Slots",
    "choice_b": "Cores",
    "choice_c": "Clock speed",
    "choice_d": "Threads",
    "correct_answer": [
      "B",
      "C"
    ],
    "explanation": "The total number of CPU cores and clock speed are common parameters to define when configuring a machine image.",
    "topic_id": 2,
    "practice_test_id": 1,
    "related_articles": [
      45,
      64,
      112,
      32,
      6
    ],
    "source": "333776_Ch09"
  },
  {
    "id": 273,
    "question": "What determines the maximum number of IPv4 addresses in the same subnet?",
    "choice_a": "Default gateway",
    "choice_b": "DNS",
    "choice_c": "NTP",
    "choice_d": "CIDR block",
    "correct_answer": "D",
    "explanation": "The CIDR block determines the size of a subnet.",
    "topic_id": 6,
    "practice_test_id": null,
    "related_articles": [
      210,
      211,
      216,
      215,
      214
    ],
    "source": "333776_Ch09"
  },
  {
    "id": 274,
    "question": "Cari is researching various remote access options to access her Linux servers in a public cloud. She has been asked to provide a standardized and secure solution that protects against snooping. As a Cloud+ architect, you have been asked to assist. What protocol would you advise Cari to implement?",
    "choice_a": "RDP",
    "choice_b": "Telnet",
    "choice_c": "IPsec",
    "choice_d": "SSH",
    "correct_answer": "D",
    "explanation": "SSH is the encrypted replacement of the Telnet protocol, and it is used to access remote devices using a command-line interface. RDP is a Windows graphical interface. Telnet does not offer encryption, and terminal servers offer serial port access but may or may not support encrypted network access.",
    "topic_id": 6,
    "practice_test_id": null,
    "related_articles": [
      218,
      223,
      222,
      215,
      209
    ],
    "source": "333776_Ch10",
    "choice_e": "Terminal server"
  },
  {
    "id": 275,
    "question": "Kevin is troubleshooting a DNS issue and wants to look at DNS frames being sent and received from his network adapter card on a webserver. What command would he use to collect the traces?",
    "choice_a": "<code>dig</code>",
    "choice_b": "<code>netstat</code>",
    "choice_c": "<code>tcpdump</code>",
    "choice_d": "<code>nslookup</code>",
    "correct_answer": "C",
    "explanation": "<code>tcpdump</code> allows a Linux system to capture live network traffic, and it is useful in monitoring and troubleshooting. Sometimes called <i>sniffing</i>, <code>tcpdump</code> allows you to set up filters to select the traffic that you are interested in capturing for troubleshooting. Think of <code>tcpdump</code> as a command-line network analyzer. <code>dig</code> and <code>nslookup</code> show DNS resolution but do not display the actual packets going across the wire. <code>netstat</code> shows connection information and is not DNS related.",
    "topic_id": 6,
    "practice_test_id": null,
    "related_articles": [
      217,
      209,
      188,
      226,
      224
    ],
    "source": "333776_Ch10"
  },
  {
    "id": 276,
    "question": "An intern at your company is asking about the mappings between the Layer 2 MAC address and the gateway router. He wants to verify that the VM has the correct network mapping information. Which command would you tell him to use to gather this information?",
    "choice_a": "<code>dig</code>",
    "choice_b": "<code>ipconfig</code>",
    "choice_c": "<code>arp</code>",
    "choice_d": "<code>netstat</code>",
    "correct_answer": "C",
    "explanation": "ARP is the protocol that maps an IP address to a MAC address on a local network. The mappings can be seen with the <code>arp</code> command. <code>dig</code> is used for DNS resolution, <code>ipconfig</code> shows the network adapter parameters, and <code>netstat</code> shows connections.",
    "topic_id": 6,
    "practice_test_id": 1,
    "related_articles": [
      217,
      214,
      211,
      210,
      188
    ],
    "source": "333776_Ch10"
  },
  {
    "id": 277,
    "question": "Sharon is unable to reach her Linux-based webserver hosted in the Singapore zone of the cloud. She is located in Austin, Texas. What command can she use to see where packet loss might be occurring?",
    "choice_a": "<code>traceroute</code>",
    "choice_b": "<code>ipconfig</code>",
    "choice_c": "<code>arp</code>",
    "choice_d": "<code>netstat</code>",
    "correct_answer": "A",
    "explanation": "The <code>traceroute</code> (Linux) or <code>tracert</code> (Windows) command is useful for network path troubleshooting. It shows the routed path that a packet of data takes from source to destination. You can use it to determine whether routing is working as expected or whether there is a route failure in the path. The other options are incorrect since they do not provide network path data.",
    "topic_id": 6,
    "practice_test_id": 3,
    "related_articles": [
      217,
      188,
      212,
      224,
      226
    ],
    "source": "333776_Ch10",
    "choice_e": "<code>ping</code>",
    "choice_f": "<code>tcpdump</code>",
    "choice_g": "<code>route print</code>"
  },
  {
    "id": 278,
    "question": "Eric is documenting different methods that his remote operations center can use to access the Calgary fleet of servers operating in a community cloud. Which of the following are <i>not</i> viable methods? (Choose two.)",
    "choice_a": "RDP",
    "choice_b": "Telnet",
    "choice_c": "IDS/IPS",
    "choice_d": "Terminal server",
    "correct_answer": [
      "C",
      "E"
    ],
    "explanation": "Common remote access tools include RDP, SSH, and terminal servers. IDSs/IPSs are for intrusion detection, and DNS is for domain name\u2013to\u2013IP address mappings and is not a utility for remote access.",
    "topic_id": 6,
    "practice_test_id": 3,
    "related_articles": [
      218,
      217,
      214,
      205,
      215
    ],
    "source": "333776_Ch10",
    "choice_e": "DNS",
    "choice_f": "HTTP"
  },
  {
    "id": 279,
    "question": "Allison is in the process of migrating away from locally installed monitoring applications. What approach should she used instead?",
    "choice_a": "Java",
    "choice_b": "CSS",
    "choice_c": "Web",
    "choice_d": "RDP",
    "correct_answer": "C",
    "explanation": "Of the options given, the web approach does not require any local application installations and offers a graphical systems management interface.",
    "topic_id": 6,
    "practice_test_id": 4,
    "related_articles": [
      209,
      202,
      186,
      159,
      227
    ],
    "source": "333776_Ch10",
    "choice_e": "SSH"
  },
  {
    "id": 280,
    "question": "Mark\u2019s remote disaster recovery location follows the warm site model. To configure the network switches, routers, and firewalls remotely, Mark will need serial port access from his company\u2019s operations center. He has 14 serial ports currently, but he needs to be prepared for any unplanned expansion requirements during a disaster recover cutover. What device would you recommend that Mark implement at the warm site?",
    "choice_a": "RDP",
    "choice_b": "Telnet",
    "choice_c": "IPsec",
    "choice_d": "SSH",
    "correct_answer": "E",
    "explanation": "In a data center, terminal servers are deployed and have several serial ports, each cabled to a console port on a device that is being managed. This allows Mark to make an SSH or a Telnet connection to the terminal server and then use the serial interfaces to access the console ports on the devices to which you want to connect. The other options given do not provide serial port connections.",
    "topic_id": 6,
    "practice_test_id": 5,
    "related_articles": [
      218,
      229,
      215,
      222,
      209
    ],
    "source": "333776_Ch10",
    "choice_e": "Terminal server"
  },
  {
    "id": 281,
    "question": "Imani manages user accounts for her company\u2019s cloud presence. She has a trouble ticket open with Jill to assist her in accessing an SSD storage volume in the San Paulo region of the public cloud. What kind of user issue is she investigating?",
    "choice_a": "Authentication",
    "choice_b": "Authorization",
    "choice_c": "Federation",
    "choice_d": "SSO",
    "correct_answer": "B",
    "explanation": "The question is asking about being able to access a specific cloud service. This would concern Jill having authorization to access the storage volume. Authentication and SSO are login systems and not rights to services. A federation links user databases.",
    "topic_id": 6,
    "practice_test_id": null,
    "related_articles": [
      203,
      222,
      221,
      185,
      225
    ],
    "source": "333776_Ch10"
  },
  {
    "id": 282,
    "question": "Shaun is getting alarms from the public cloud\u2019s application load balancer about security failures. Harold reviews his problem resolution documentation to investigate, and there have been no troubles reported in the past year. The load balancer has been configured to offload port 443 web traffic from the backend fleet of webservers. As a Cloud+ consultant brought in to assist, you decide which of the following should be the focus of the investigation?",
    "choice_a": "HTTPS",
    "choice_b": "Certificates",
    "choice_c": "IPsec",
    "choice_d": "RDP",
    "correct_answer": "B",
    "explanation": "The question shows that the load balancer is terminating SSL/TLS traffic from the web. SSL certificates have expiration dates, and so as part of the troubleshooting approach, security certificate expirations need to be investigated. The other options do not accomplish this requirement.",
    "topic_id": 6,
    "practice_test_id": null,
    "related_articles": [
      224,
      226,
      225,
      227,
      223
    ],
    "source": "333776_Ch10",
    "choice_e": "<code>ssldump</code>",
    "choice_f": "<code>netstat</code>"
  },
  {
    "id": 283,
    "question": "Multiple users are complaining that they cannot access a cloud-based collaboration system. The operations center has been investigating and has, so far, verified that the MFA applications are operational. What user system are they troubleshooting?",
    "choice_a": "Authentication",
    "choice_b": "Authorization",
    "choice_c": "Federation",
    "choice_d": "SSO",
    "correct_answer": "A",
    "explanation": "Logging into systems is referred to as authentication. Also, the question references multifactor authentication (MFA) as part of the system. Authorization is the accessing of services after the authentication process, federations interconnect external user accounts to the cloud, and single sign-on (SSO) allows a user to authenticate one time to access all resources in the cloud.",
    "topic_id": 6,
    "practice_test_id": null,
    "related_articles": [
      222,
      203,
      185,
      225,
      226
    ],
    "source": "333776_Ch10"
  },
  {
    "id": 284,
    "question": "Your organization\u2019s backend fleet of webservers is intermittently failing load balancer health checks and dropping out of the pool. You are involved in troubleshooting and begin your investigation by making sure that the web application is operational. What approach are you undertaking?",
    "choice_a": "Top down",
    "choice_b": "Bottom up",
    "choice_c": "Divide and conquer",
    "choice_d": "Evaluation",
    "correct_answer": "A",
    "explanation": "The top-down approach references the OSI model; it starts at the application layer and works downward until the problem is identified. The application is checked first, and if that is operational, you continue to work down the network stack until you identify the problem.",
    "topic_id": 6,
    "practice_test_id": 6,
    "related_articles": [
      226,
      188,
      225,
      159,
      209
    ],
    "source": "333776_Ch10",
    "choice_e": "Validation"
  },
  {
    "id": 285,
    "question": "Your webservers have lost communications to the SQL backend database on your e-commerce public website. You are assisting in resolving the problem. After reviewing the log files and the monitoring system, you suspect that it may be a network-related issue. You devise a series of tests that starts with checking the server\u2019s connection to the database. What troubleshooting approach are you implementing?",
    "choice_a": "Top down",
    "choice_b": "Bottom up",
    "choice_c": "Divide and conquer",
    "choice_d": "Evaluation",
    "correct_answer": "B",
    "explanation": "The bottom-up approach starts at the lowest level of the ISO model with the physical network connections, such as cabling, and works upward by investigating VLANs, IP addressing, and so on, until the issue is located.",
    "topic_id": 6,
    "practice_test_id": 7,
    "related_articles": [
      226,
      217,
      210,
      211,
      209
    ],
    "source": "333776_Ch10",
    "choice_e": "Validation"
  },
  {
    "id": 286,
    "question": "A middleware application running in the cloud is reporting session drops in its log files. You need to resolve the issue quickly and get the server back online. You decide to run <code>ping</code> and <code>traceroute</code> tests on the server as your first line of troubleshooting. What approach are you using?",
    "choice_a": "Top down",
    "choice_b": "Bottom up",
    "choice_c": "Divide and conquer",
    "choice_d": "Evaluation",
    "correct_answer": "C",
    "explanation": "The divide-and-conquer troubleshooting approach starts in the middle of the OSI networking stack and, depending on the results, directs future tests. In this case, the troubleshooter began at the network layer, which is in the middle of the OSI model. This is the divide-and-conquer approach.",
    "topic_id": 6,
    "practice_test_id": 7,
    "related_articles": [
      226,
      188,
      217,
      212,
      224
    ],
    "source": "333776_Ch10",
    "choice_e": "Validation"
  },
  {
    "id": 287,
    "question": "Which of the following are valid troubleshooting steps? (Choose all that apply.)",
    "choice_a": "Gather information",
    "choice_b": "Identify the issue",
    "choice_c": "Reboot everything",
    "choice_d": "Create a plan of action",
    "correct_answer": [
      "A",
      "B",
      "D",
      "E"
    ],
    "explanation": "All of the answers except \u201creboot everything\u201d are valid troubleshooting steps.",
    "topic_id": 6,
    "practice_test_id": null,
    "related_articles": [
      224,
      225,
      226,
      227,
      188
    ],
    "source": "333776_Ch10",
    "choice_e": "Test and verify"
  },
  {
    "id": 288,
    "question": "Cloud providers are responsible for the security of which of the following? (Choose all that apply.)",
    "choice_a": "Building",
    "choice_b": "Device",
    "choice_c": "Infrastructure",
    "choice_d": "VPNs",
    "correct_answer": [
      "A",
      "B",
      "C"
    ],
    "explanation": "Building, device, and infrastructure security are all the responsibility of the cloud provider. The provider may implement measures such as having nondescript facilities, video surveillance, and biometric access.",
    "topic_id": 6,
    "practice_test_id": null,
    "related_articles": [
      222,
      223,
      221,
      229,
      215
    ],
    "source": "333776_Ch10",
    "choice_e": "User accounts"
  },
  {
    "id": 289,
    "question": "Kelly has picked up a trouble ticket that shows the connection between the Toledo field office and the Detroit cloud edge location has dropped. She confirms that it is a secure Internet-based access solution. What type of connection is this?",
    "choice_a": "Direct peering",
    "choice_b": "IDS",
    "choice_c": "VPN",
    "choice_d": "AES-256",
    "correct_answer": "C",
    "explanation": "A secure Internet-based connection would be a VPN.",
    "topic_id": 6,
    "practice_test_id": 6,
    "related_articles": [
      223,
      218,
      188,
      215,
      229
    ],
    "source": "333776_Ch10",
    "choice_e": "RDP"
  },
  {
    "id": 290,
    "question": "Nick is setting up a new fleet of IIS webservers in his IaaS e-commerce site. The company has elected to use a hybrid approach and desires graphical connections to the Windows bastion hosts. What traffic must he permit through the external-facing firewall to the host?",
    "choice_a": "SSH",
    "choice_b": "RDP",
    "choice_c": "DNS",
    "choice_d": "IPS",
    "correct_answer": "B",
    "explanation": "The Windows Remote Desktop Protocol allows for remote connections to a Windows graphical user desktop.",
    "topic_id": 6,
    "practice_test_id": 6,
    "related_articles": [
      218,
      215,
      229,
      222,
      188
    ],
    "source": "333776_Ch10"
  },
  {
    "id": 291,
    "question": "Jill logs into her NoSQL database server residing in a private subnet on a public cloud. She needs to verify IP connectivity with the application tier. What command can she use as a quick connectivity test?",
    "choice_a": "<code>arproute</code>",
    "choice_b": "<code>netstat</code>",
    "choice_c": "<code>tcpdump</code>",
    "choice_d": "<code>ping</code>",
    "correct_answer": "D",
    "explanation": "The <code>ping</code> command verifies end-to-end IP connectivity and is the correct answer. The other options either do not apply, such as <code>tcpdump</code> and <code>netstat</code>, or are not valid commands, such as <code>arproute</code>.",
    "topic_id": 6,
    "practice_test_id": 5,
    "related_articles": [
      188,
      212,
      215,
      211,
      209
    ],
    "source": "333776_Ch10"
  },
  {
    "id": 292,
    "question": "After deploying a new public website, your validation steps ask you to check the domain name\u2013to\u2013IP address mappings. Which utilities can you use for validation? (Choose two.)",
    "choice_a": "RDP",
    "choice_b": "<code>dig</code>",
    "choice_c": "SSH",
    "choice_d": "<code>nslookup</code>",
    "correct_answer": [
      "B",
      "D"
    ],
    "explanation": "<code>nslookup</code> is a Windows command-line utility for resolving domain names to IP addressing. The Linux equivalent is the <code>dig</code> utility. The other options are not valid for the solution required in the question.",
    "topic_id": 6,
    "practice_test_id": 7,
    "related_articles": [
      214,
      217,
      205,
      209,
      226
    ],
    "source": "333776_Ch10",
    "choice_e": "IPsec",
    "choice_f": "IPS"
  },
  {
    "id": 293,
    "question": "Donna logged into her cloud bastion host by making an SSH connection from her desktop. She uses the Linux host to connect to other systems in the private cloud. She needs to add an access control list rule to allow the bastion server to access a new subnet. Donna needs the source IP address of her host. What command can she run on the server to collect this information?",
    "choice_a": "<code>curl /localhost/metadata/global/interface</code>",
    "choice_b": "<code>ipconfig</code>",
    "choice_c": "<code>ifconfig</code>",
    "choice_d": "<code>netstat</code>",
    "correct_answer": "C",
    "explanation": "The Linux command <code>ifconfig</code> will display all network-related configuration information for that computer and is the correct answer. <code>ipconfig</code> is the Windows equivalent, and it is not relevant to this question. <code>netstat</code> and the query string are not applicable to the question.",
    "topic_id": 6,
    "practice_test_id": null,
    "related_articles": [
      217,
      210,
      215,
      218,
      209
    ],
    "source": "333776_Ch10"
  },
  {
    "id": 294,
    "question": "Cephas accesses his account in a public cloud, adds two middleware servers to his fleet, and logs back off. What type cloud feature allows him to add servers?",
    "choice_a": "Bursting",
    "choice_b": "Pay-as-you-grow",
    "choice_c": "Multitenancy",
    "choice_d": "On-demand",
    "correct_answer": "D",
    "explanation": "On-demand cloud computing allows a cloud customer to add resources dynamically with the use of an online portal.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      2,
      8,
      10,
      3,
      27
    ],
    "source": "333776_PracticeExam1"
  },
  {
    "id": 295,
    "question": "A bank\u2019s ATM is an example of what type of authentication?",
    "choice_a": "SSO",
    "choice_b": "Two-factor",
    "choice_c": "LDAP",
    "choice_d": "User based",
    "correct_answer": "B",
    "explanation": "Two-factor authentication includes something that you have and something that you know.",
    "topic_id": 4,
    "practice_test_id": 3,
    "related_articles": [
      101,
      95,
      165,
      69,
      97
    ],
    "source": "333776_PracticeExam1"
  },
  {
    "id": 296,
    "question": "You are installing a software update that is designed to address a known bug and to bring a system up-to-date with previously released fixes. What type of remediation is this?",
    "choice_a": "Hotfix",
    "choice_b": "Patch",
    "choice_c": "Version update",
    "choice_d": "Rollout",
    "correct_answer": "B",
    "explanation": "A patch is a piece of software that is intended to update an application, operating system, or any other software-based system to fix or improve its operations.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      122,
      116,
      177,
      160,
      123
    ],
    "source": "333776_PracticeExam1"
  },
  {
    "id": 297,
    "question": "The ability to add virtual machine compute resources dynamically on demand, such as storage, CPUs, and memory, is referred to as what?",
    "choice_a": "Bursting",
    "choice_b": "Pooling",
    "choice_c": "Elasticity",
    "choice_d": "Orchestration",
    "correct_answer": "C",
    "explanation": "Cloud automation systems offer the ability to add and remove resources dynamically as needed. This is referred to as elasticity.",
    "topic_id": 3,
    "practice_test_id": 3,
    "related_articles": [
      22,
      14,
      208,
      199,
      163
    ],
    "source": "333776_PracticeExam1"
  },
  {
    "id": 298,
    "question": "Who is responsible for maintaining orchestration systems in the public cloud?",
    "choice_a": "The customer",
    "choice_b": "The provider",
    "choice_c": "The automation vendor",
    "choice_d": "The DevOps",
    "correct_answer": "B",
    "explanation": "The cloud service provider owns its automation and orchestration systems, and they cannot be directly accessed by the customer.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      24,
      26,
      91,
      4,
      8
    ],
    "source": "333776_PracticeExam1"
  },
  {
    "id": 299,
    "question": "Jeremiah is explaining to his customer that the cloud virtualizes hardware resources such as memory, CPU, and storage. These resources are then allocated to virtual machines. What cloud concept is Jeremiah referring to?",
    "choice_a": "On-demand virtualization",
    "choice_b": "Dynamic scaling",
    "choice_c": "Resource pooling",
    "choice_d": "Elasticity",
    "correct_answer": "C",
    "explanation": "Resource pooling is the allocation of compute resources into a group or pool. These pools are then made available to VMs in a cloud environment.",
    "topic_id": 1,
    "practice_test_id": 4,
    "related_articles": [
      10,
      3,
      8,
      42,
      12
    ],
    "source": "333776_PracticeExam1"
  },
  {
    "id": 300,
    "question": "To ease the management requirements for the operations group, you are being asked to streamline user access control for your storage operations group. Many users and applications require rights to manage storage buckets and then put in a change request to have their rights removed when the change is completed. What rights management solution would you recommend to operations that reduces the labor of adding and removing users to the object storage management group?",
    "choice_a": "Mandatory access control",
    "choice_b": "Nondiscretionary",
    "choice_c": "Roles",
    "choice_d": "Multifactor",
    "correct_answer": "C",
    "explanation": "The question outlines the function of a role-based access control approach.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      94,
      68,
      93,
      165,
      69
    ],
    "source": "333776_PracticeExam1"
  },
  {
    "id": 301,
    "question": "What type of backup job takes the least time to complete?",
    "choice_a": "Full",
    "choice_b": "Differential",
    "choice_c": "Incremental",
    "choice_d": "Online",
    "correct_answer": "C",
    "explanation": "Incremental backups include only the data that has changed since the last backup, so it will be the quickest of the options.",
    "topic_id": 3,
    "practice_test_id": 4,
    "related_articles": [
      126,
      124,
      133,
      129,
      125
    ],
    "source": "333776_PracticeExam1"
  },
  {
    "id": 302,
    "question": "Art plans to implement a site backup plan for his company\u2019s inventory control database. To ensure a low RTO, he has decided to contract with multiple public cloud providers to back up each other. He is reviewing the service models as he prepares his migration plans. Which service model has the most lock-ins and is the most complex to migrate?",
    "choice_a": "IaaS",
    "choice_b": "PaaS",
    "choice_c": "SaaS",
    "choice_d": "XaaS",
    "correct_answer": "B",
    "explanation": "The higher up the services stack you go, from IaaS to PaaS to SaaS, the more difficult it will be to migrate. With IaaS, most of the cloud operations are under your direct control, which gives you the most flexibility to migrate. However, if the cloud provider controls the application, you may not have many migration options because of proprietary implementations.",
    "topic_id": 1,
    "practice_test_id": 4,
    "related_articles": [
      4,
      26,
      24,
      91,
      135
    ],
    "source": "333776_PracticeExam1"
  },
  {
    "id": 303,
    "question": "Your company has implemented a teleconferencing solution. Users are complaining about frames pausing and session drops. As your company\u2019s cloud support person, what cloud resource should you investigate to remedy the issue?",
    "choice_a": "CPU",
    "choice_b": "Network bandwidth",
    "choice_c": "RAM",
    "choice_d": "API",
    "correct_answer": "B",
    "explanation": "Frames freezing and sessions dropping is indicative of a network bandwidth issue.",
    "topic_id": 6,
    "practice_test_id": null,
    "related_articles": [
      220,
      228,
      213,
      212,
      224
    ],
    "source": "333776_PracticeExam1",
    "choice_e": "Storage"
  },
  {
    "id": 304,
    "question": "Shara is searching for a cloud-based service that manages all underlying infrastructure, including updating the operating system. What service would you recommend to her?",
    "choice_a": "IaaS",
    "choice_b": "PaaS",
    "choice_c": "SaaS",
    "choice_d": "CaaS",
    "correct_answer": "B",
    "explanation": "Platform-as-a-Service offers computing hardware, storage, networking, and the operating system that is managed by the cloud provider.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      4,
      26,
      24,
      91,
      113
    ],
    "source": "333776_PracticeExam1"
  },
  {
    "id": 305,
    "question": "Your cloud migration requirements are limited to application management only, with the public cloud provider responsible for the operation and maintenance of the server operating system and hardware virtualization. What cloud service model would best meet these requirements?",
    "choice_a": "IaaS",
    "choice_b": "PaaS",
    "choice_c": "SaaS",
    "choice_d": "CaaS",
    "correct_answer": "B",
    "explanation": "The platform-as-a-service model offers operating system maintenance to be provided by the service provider, and you are responsible for the installation and maintenance of the application.",
    "topic_id": 1,
    "practice_test_id": 1,
    "related_articles": [
      4,
      24,
      26,
      91,
      113
    ],
    "source": "333776_PracticeExam1"
  },
  {
    "id": 306,
    "question": "What systems abstract and hide much of the service provisioning complexity of modern cloud systems from end users?",
    "choice_a": "Runbooks",
    "choice_b": "Workflow",
    "choice_c": "Orchestration",
    "choice_d": "REST/API",
    "correct_answer": "C",
    "explanation": "Orchestration systems enable large-scale cloud deployments by automating operations.",
    "topic_id": 1,
    "practice_test_id": 3,
    "related_articles": [
      47,
      3,
      8,
      27,
      24
    ],
    "source": "333776_PracticeExam1"
  },
  {
    "id": 307,
    "question": "A MySQL database operates on a multi-CPU instance that is nearing 100 percent utilization. However, the database can only run on a single server. What options are available to support the requirements of this database?",
    "choice_a": "Horizontal scaling",
    "choice_b": "Vertical scaling",
    "choice_c": "Pooling",
    "choice_d": "Bursting",
    "correct_answer": "B",
    "explanation": "Scaling up, or vertical scaling, will add resources such as CPU instances or more RAM. When you scale up, you are increasing your compute, network, or storage capabilities.",
    "topic_id": 3,
    "practice_test_id": 5,
    "related_articles": [
      199,
      163,
      208,
      182,
      183
    ],
    "source": "333776_PracticeExam1"
  },
  {
    "id": 308,
    "question": "You have been involved in a project to migrate a fleet of webservers from one cloud service provider to another. After performing address changes for all of your public-facing webservers, you validate connectivity by connecting from a bastion host located offshore to the new website. However, you find that the browser times out. What needs to be modified to allow the remote site to connect to the webserver?",
    "choice_a": "NTP",
    "choice_b": "STP",
    "choice_c": "DNS",
    "choice_d": "API",
    "correct_answer": "C",
    "explanation": "The Domain Name System records need to be changed to reflect the IP address of the new site to be mapped to the domain name.",
    "topic_id": 6,
    "practice_test_id": null,
    "related_articles": [
      214,
      205,
      217,
      215,
      209
    ],
    "source": "333776_PracticeExam1"
  },
  {
    "id": 309,
    "question": "Timothy is requesting assistance in configuring a cloud solution that allows him to access his server fleet\u2019s management console hosted in a community cloud. He wants you to recommend a solution that allows access over the Internet from multiple remote locations. What solution would you recommend that Timothy use?",
    "choice_a": "Load balancing",
    "choice_b": "Automation",
    "choice_c": "VPN",
    "choice_d": "Firewall",
    "correct_answer": "C",
    "explanation": "A virtual private network allows a secure remote connection over an insecure network and would be the solution to the requirements.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      16,
      35,
      36,
      70,
      27
    ],
    "source": "333776_PracticeExam1"
  },
  {
    "id": 310,
    "question": "A company is undertaking a large project to migrate all accounting operations to a hybrid cloud model. You are being asked about firewall and DDoS security requirements in the Dallas region of the cloud. What document should you create to define your company\u2019s requirements for this deployment?",
    "choice_a": "DIACAP",
    "choice_b": "Security policy",
    "choice_c": "Service level agreement",
    "choice_d": "SOC-2",
    "correct_answer": "B",
    "explanation": "A security policy outlines all aspects of your cloud security posture.",
    "topic_id": 4,
    "practice_test_id": 4,
    "related_articles": [
      75,
      37,
      88,
      97,
      102
    ],
    "source": "333776_PracticeExam1"
  },
  {
    "id": 311,
    "question": "A fleet of 20 load-balanced Internet-facing e-commerce webservers needs to be upgraded to remediate a critical bug in the web application. Your company cannot afford to be offline during the update. What is the upgrade type that allows you to fix the bug and remain online during the process?",
    "choice_a": "Orchestration",
    "choice_b": "Rolling",
    "choice_c": "Hotfix",
    "choice_d": "Blue-green",
    "correct_answer": "B",
    "explanation": "A rolling configuration will sequentially upgrade the webservers without causing a complete outage and would meet the requirements outlined in the question.",
    "topic_id": 2,
    "practice_test_id": 4,
    "related_articles": [
      114,
      132,
      29,
      33,
      31
    ],
    "source": "333776_PracticeExam1"
  },
  {
    "id": 312,
    "question": "What is the term associated with using a second cloud to accommodate peak loads?",
    "choice_a": "Elasticity",
    "choice_b": "Bursting",
    "choice_c": "Vertical-scaling",
    "choice_d": "Autoscaling",
    "correct_answer": "B",
    "explanation": "Cloud bursting allows for adding capacity from another cloud service during times when additional resources are needed.",
    "topic_id": 1,
    "practice_test_id": 3,
    "related_articles": [
      35,
      2,
      21,
      8,
      141
    ],
    "source": "333776_PracticeExam1"
  },
  {
    "id": 313,
    "question": "Hezekiah has been tracking volume allocations, and he is preparing to add capacity to his backend server farm. He has decided to automate the volume allocation size. What cloud feature can he take advantage of?",
    "choice_a": "SaaS",
    "choice_b": "API",
    "choice_c": "Elasticity",
    "choice_d": "OpenStack",
    "correct_answer": "C",
    "explanation": "Elasticity allows for cloud services to expand and contract based on actual usage and would be applicable to increasing storage capacity.",
    "topic_id": 3,
    "practice_test_id": 4,
    "related_articles": [
      22,
      164,
      200,
      14,
      208
    ],
    "source": "333776_PracticeExam1"
  },
  {
    "id": 314,
    "question": "You have been asked in a company security meeting about demarcation of security responsibilities between your private cloud and your public cloud provider. What model would you explain to your management the public cloud provider follows?",
    "choice_a": "Availability zones",
    "choice_b": "Community",
    "choice_c": "Shared responsibility",
    "choice_d": "Baselines",
    "correct_answer": "C",
    "explanation": "The shared responsibility model outlines what services and portions of the cloud operations the cloud consumer and provider are responsible for.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      24,
      91,
      26,
      35,
      141
    ],
    "source": "333776_PracticeExam1"
  },
  {
    "id": 315,
    "question": "Johanna has been hired as an outside consultant to manage a migration of customer medical records to a cloud-based service offering long-term archival requirements. Which U.S. compliance mandate must her company align with?",
    "choice_a": "SOC 3",
    "choice_b": "HIPAA",
    "choice_c": "MPAA",
    "choice_d": "ISA 2701",
    "correct_answer": "B",
    "explanation": "The Health Insurance Portability and Accountability Act (HIPAA) defines the standards for protecting medical data.",
    "topic_id": 4,
    "practice_test_id": 6,
    "related_articles": [
      73,
      76,
      98,
      79,
      102
    ],
    "source": "333776_PracticeExam1"
  },
  {
    "id": 316,
    "question": "The applications development team has created a new patch that is being validated prior to posting the fix on your website\u2019s support page. However, before the release, the DevOps manager is requesting a report that shows the pass/fail data to verify that the fix does, in fact, resolve the problem. What process is the DevOps manager verifying?",
    "choice_a": "Rollout",
    "choice_b": "Orchestration",
    "choice_c": "Automation",
    "choice_d": "Quality assurance",
    "correct_answer": "D",
    "explanation": "Quality assurance (QA) tests the fix prior to release.",
    "topic_id": 3,
    "practice_test_id": 3,
    "related_articles": [
      116,
      177,
      123,
      51,
      142
    ],
    "source": "333776_PracticeExam1"
  },
  {
    "id": 317,
    "question": "Sarah plans to modify a firewall access control list to allow RDP connections from a new remote office into her private cloud data center. She is creating a document that details all of the steps required to implement the new rule set. What process is she following?",
    "choice_a": "Cloud automation",
    "choice_b": "Change advisory",
    "choice_c": "Change management",
    "choice_d": "Rollout",
    "correct_answer": "C",
    "explanation": "Change management includes recording the change, planning for the change, testing the documentation, getting approvals, evaluating and validating, writing instructions for backing out the change if needed, and doing post-change review if desired.",
    "topic_id": 3,
    "practice_test_id": 4,
    "related_articles": [
      160,
      174,
      154,
      148,
      116
    ],
    "source": "333776_PracticeExam1"
  },
  {
    "id": 318,
    "question": "Common cloud resources that may become fully utilized over time include which of the following? (Choose three.)",
    "choice_a": "RAM",
    "choice_b": "Power",
    "choice_c": "CPU",
    "choice_d": "Storage",
    "correct_answer": [
      "A",
      "C",
      "D"
    ],
    "explanation": "Resources such as the amount of RAM needed, CPU cycles, and storage capacity are common systems that may become fully utilized as your cloud compute requirements grow.",
    "topic_id": 1,
    "practice_test_id": 7,
    "related_articles": [
      42,
      43,
      12,
      50,
      3
    ],
    "source": "333776_PracticeExam1",
    "choice_e": "Monitoring",
    "choice_f": "IaaS"
  },
  {
    "id": 319,
    "question": "You are reviewing your private cloud\u2019s infrastructure and are validating the resiliency of all systems. The data center has six racks of storage arrays that are configured to each lose one drive and remain operational. The servers hosting the hypervisors interconnect to these arrays and need to access block data that is lossless. What is the interconnect method commonly used?",
    "choice_a": "RAID 5",
    "choice_b": "Zoning",
    "choice_c": "VMFS",
    "choice_d": "SAN",
    "correct_answer": "D",
    "explanation": "A storage area network (SAN) is a high-speed network dedicated to storage transfers across a shared network. RAID is a disk resiliency technology and does not apply to the question, zoning is for restricting LUNs in a SAN, VMFS is a VMware filesystem, and DAS is direct-attached storage and not remote.",
    "topic_id": 1,
    "practice_test_id": 7,
    "related_articles": [
      53,
      71,
      12,
      52,
      55
    ],
    "source": "333776_PracticeExam1",
    "choice_e": "DAS"
  },
  {
    "id": 320,
    "question": "Harley is a systems architect for a large manufacturing firm in England. While testing a new application that will be deployed in an IaaS-based public cloud, he builds a test image and deploys a test VM in his development virtual private cloud zone. When he restarts one of the Linux-based servers, he notices that his storage volume data is missing. What type of storage did he implement? (Choose all that apply.)",
    "choice_a": "Durable",
    "choice_b": "RAID",
    "choice_c": "Ephemeral",
    "choice_d": "Nondurable",
    "correct_answer": "D",
    "explanation": "Temporary storage volumes that are destroyed when the VM is stopped are referred to as ephemeral or nondurable storage.",
    "topic_id": 1,
    "practice_test_id": 7,
    "related_articles": [
      52,
      12,
      55,
      8,
      3
    ],
    "source": "333776_PracticeExam1",
    "choice_e": "Block",
    "choice_f": "Object"
  },
  {
    "id": 321,
    "question": "A medical transcription firm must retain all records for seven years to meet governmental regulations. Since the records will rarely be accessed after the first few years, they can be stored offline to reduce storage expenses. What type of storage should they implement to achieve their objectives?",
    "choice_a": "File transfer",
    "choice_b": "Archive",
    "choice_c": "Replication",
    "choice_d": "Data store",
    "correct_answer": "B",
    "explanation": "Inactive data moved to a separate storage facility for long-term storage is referred to as archiving.",
    "topic_id": 1,
    "practice_test_id": 3,
    "related_articles": [
      58,
      54,
      50,
      1,
      35
    ],
    "source": "333776_PracticeExam1"
  },
  {
    "id": 322,
    "question": "The network operations center has implemented object tracking on their monitoring application. What information can this give them? (Choose three.)",
    "choice_a": "Resiliency",
    "choice_b": "Trends",
    "choice_c": "User satisfaction",
    "choice_d": "ACLs",
    "correct_answer": [
      "B",
      "E",
      "F"
    ],
    "explanation": "Trends, usage, and anomalies are all management report outputs that can be identified using object tracking.",
    "topic_id": 3,
    "practice_test_id": 5,
    "related_articles": [
      173,
      157,
      178,
      105,
      175
    ],
    "source": "333776_PracticeExam1",
    "choice_e": "Peak usage",
    "choice_f": "Anomalies"
  },
  {
    "id": 323,
    "question": "The DevOps team is requesting read/write access to a storage bucket in the public cloud that is located in a backup region. What kind of services are they requesting?",
    "choice_a": "Authentication",
    "choice_b": "Authorization",
    "choice_c": "Federation",
    "choice_d": "SSO",
    "correct_answer": "B",
    "explanation": "The question is asking about being able to access a specific cloud service. This would concern DevOps having authorization to access the storage volume. Authentication and SSO are login systems and not rights to services. A federation links user account databases.",
    "topic_id": 4,
    "practice_test_id": 6,
    "related_articles": [
      167,
      68,
      60,
      92,
      93
    ],
    "source": "333776_PracticeExam1"
  },
  {
    "id": 324,
    "question": "You have been hired as a cloud architect at a large corporation that maintains their own operations in six different data centers that are geographically diverse for high availability. What deployment model is this?",
    "choice_a": "Hybrid",
    "choice_b": "Public",
    "choice_c": "Private",
    "choice_d": "Community",
    "correct_answer": "C",
    "explanation": "A private cloud is operated and used by a single organization.",
    "topic_id": 2,
    "practice_test_id": 4,
    "related_articles": [
      5,
      96,
      28,
      6,
      7
    ],
    "source": "333776_PracticeExam1"
  },
  {
    "id": 325,
    "question": "You are being asked by your company\u2019s network operations center about visibility into a newly implemented hybrid cloud deployment. After consulting with the ops center, you configure a web-based interface that shows all critical operations at the public cloud. This referred to as what?",
    "choice_a": "Puppet automation",
    "choice_b": "Gemalto system",
    "choice_c": "Dashboard",
    "choice_d": "Vendor-based security appliance",
    "correct_answer": "C",
    "explanation": "A dashboard is a graphical portal that provides updates and an overview of operations.",
    "topic_id": 3,
    "practice_test_id": 4,
    "related_articles": [
      105,
      34,
      157,
      173,
      15
    ],
    "source": "333776_PracticeExam1"
  },
  {
    "id": 326,
    "question": "Ruth is deploying a new MySQL database in her private cloud. She needs a fault-tolerant solution and plans to create read replicas of the database in a different availability zone. For performance reasons, she has decided to update the replica on a delayed schedule after the initial write operation on the primary database. What type of solution is this?",
    "choice_a": "Synchronous",
    "choice_b": "Asynchronous",
    "choice_c": "Volume sync",
    "choice_d": "remote mirroring",
    "correct_answer": "B",
    "explanation": "Asynchronous replication is when data is written to the primary database first and then later a copy is written to the remote site on a scheduled arrangement or in near real time.",
    "topic_id": 1,
    "practice_test_id": 6,
    "related_articles": [
      131,
      21,
      135,
      143,
      71
    ],
    "source": "333776_PracticeExam1",
    "choice_e": "RAID 5"
  },
  {
    "id": 327,
    "question": "What is monitored in cloud management systems to collect performance metrics?",
    "choice_a": "Database",
    "choice_b": "Server",
    "choice_c": "Hypervisor",
    "choice_d": "Objects",
    "correct_answer": "D",
    "explanation": "Objects are queried to gather metric data.",
    "topic_id": 3,
    "practice_test_id": 3,
    "related_articles": [
      34,
      157,
      173,
      105,
      162
    ],
    "source": "333776_PracticeExam1"
  },
  {
    "id": 328,
    "question": "What utilities are used to verify domain name\u2013to\u2013IP address mappings? (Choose two.)",
    "choice_a": "RDP",
    "choice_b": "<code>dig</code>",
    "choice_c": "SSH",
    "choice_d": "<code>nslookup</code>",
    "correct_answer": "D",
    "explanation": "<code>nslookup</code> is a Windows command for resolving domain names to IP addressing. The Linux equivalent is the <code>dig</code> command.",
    "topic_id": 6,
    "practice_test_id": 4,
    "related_articles": [
      214,
      217,
      205,
      212,
      188
    ],
    "source": "333776_PracticeExam1",
    "choice_e": "IPsec",
    "choice_f": "IPS"
  },
  {
    "id": 329,
    "question": "Saul is configuring a MySQL database server in the public cloud. He is asking about mounting LUNs on which he plans to host his databases. What storage type should you tell him that he is using for his application?",
    "choice_a": "Meta",
    "choice_b": "Object",
    "choice_c": "Block",
    "choice_d": "File",
    "correct_answer": "C",
    "explanation": "Storage area networks support block-based storage.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      53,
      52,
      12,
      55,
      71
    ],
    "source": "333776_PracticeExam1"
  },
  {
    "id": 330,
    "question": "John is a software developer working on a program that will pass messages between two different applications. You have been brought in as a Cloud+ certified consultant to assist on the project. What software interface would you recommend that John use?",
    "choice_a": "Python",
    "choice_b": "XML",
    "choice_c": "API",
    "choice_d": "SNMP",
    "correct_answer": "C",
    "explanation": "An application programming interface (API) offers programmatic access, control, and configuration of a device between different and discrete software components.",
    "topic_id": 5,
    "practice_test_id": 3,
    "related_articles": [
      103
    ],
    "source": "333776_PracticeExam1",
    "choice_e": "TLS"
  },
  {
    "id": 331,
    "question": "Your firm\u2019s disaster recovery plan states that operations must be restored within 48 hours of a disaster. What disaster recovery objective is this?",
    "choice_a": "RSO",
    "choice_b": "RPO",
    "choice_c": "RTO",
    "choice_d": "DBO",
    "correct_answer": "C",
    "explanation": "The recovery time objective is the amount of time it takes to get a service online and available after a failure.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      135,
      141,
      21,
      143,
      146
    ],
    "source": "333776_PracticeExam1"
  },
  {
    "id": 332,
    "question": "What is a visual representation of current cloud operations that consolidates data into an easy-to-read format?",
    "choice_a": "Operational matrix",
    "choice_b": "Management console",
    "choice_c": "Dashboard",
    "choice_d": "Object monitor",
    "correct_answer": "C",
    "explanation": "A dashboard is a configurable graphical representation of current operational data.",
    "topic_id": 3,
    "practice_test_id": 7,
    "related_articles": [
      105,
      157,
      173,
      15,
      179
    ],
    "source": "333776_PracticeExam1"
  },
  {
    "id": 333,
    "question": "Dimitry is troubleshooting a Linux SQL server that is experiencing poor read/write performance from the middleware servers. The vendor support team is requesting that he send them packet traces to further investigate the issue. What command would he use to collect the traces?",
    "choice_a": "<code>dig</code>",
    "choice_b": "<code>netstat</code>",
    "choice_c": "<code>tcpdump</code>",
    "choice_d": "<code>nslookup</code>",
    "correct_answer": "C",
    "explanation": "<code>tcpdump</code> allows a Linux system to capture live network traffic, and it is useful in monitoring and troubleshooting. Think of <code>tcpdump</code> as a command-line network analyzer. <code>dig</code> and <code>nslookup</code> show DNS resolution but do not display the actual packets going across the wire. <code>netstat</code> shows connection information and is not DNS related.",
    "topic_id": 6,
    "practice_test_id": 1,
    "related_articles": [
      217,
      188,
      209,
      220,
      224
    ],
    "source": "333776_PracticeExam1"
  },
  {
    "id": 334,
    "question": "Piper works as an IT manager for a small chain of dental offices. Because of budget constraints, she is unable to purchase, install, and maintain an enterprise-class application to provide HIPAA-compliant recordkeeping, billing, and scheduling. She has been investigating other options and has found a cloud company that offers the same application in a shared environment with other small dental chains. What type of cloud is Piper investigating?",
    "choice_a": "Hybrid",
    "choice_b": "Public",
    "choice_c": "Private",
    "choice_d": "Community",
    "correct_answer": "D",
    "explanation": "A community cloud is used by companies with similar needs, such as the dental companies in this example.",
    "topic_id": 2,
    "practice_test_id": 3,
    "related_articles": [
      5,
      96,
      7,
      6,
      25
    ],
    "source": "333776_PracticeExam1"
  },
  {
    "id": 335,
    "question": "A new security directive has been issued that requires active preventive measures be taken during an attempted security breach. What system can monitor malicious activity and actively deploy countermeasures to shut down the hacking attempts as they occur?",
    "choice_a": "DMZ",
    "choice_b": "IDS",
    "choice_c": "IPS",
    "choice_d": "RAID",
    "correct_answer": "C",
    "explanation": "Intrusion prevention systems will monitor for malicious activity and actively take countermeasures in real time to eliminate or reduce the effects of the intrusion.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      107,
      111,
      87,
      108,
      106
    ],
    "source": "333776_PracticeExam1",
    "choice_e": "HIDS"
  },
  {
    "id": 336,
    "question": "You have been asked to create a disaster recovery plan in the event of a catastrophic failure of the primary data center. The DR facility will need to be ready with floor space, power, and cooling and have loading docks to unload server and equipment racks to restore service. What type of DR implementation is this?",
    "choice_a": "Hot site",
    "choice_b": "Active/active",
    "choice_c": "Warm site",
    "choice_d": "Active/passive",
    "correct_answer": "E",
    "explanation": "A cold site is a backup data center provisioned to take over operations in the event of a primary data center failure, but the servers and infrastructure are not deployed or operational until needed.",
    "topic_id": 1,
    "practice_test_id": 7,
    "related_articles": [
      135,
      141,
      143,
      138,
      146
    ],
    "source": "333776_PracticeExam1",
    "choice_e": "Cold site",
    "choice_f": "Rollover"
  },
  {
    "id": 337,
    "question": "What type of scaling includes adding additional servers to an existing pool?",
    "choice_a": "Horizontal",
    "choice_b": "Round robin",
    "choice_c": "Elasticity",
    "choice_d": "Autoscale",
    "correct_answer": "A",
    "explanation": "Horizontal scaling is the process of adding servers to a pool for increased capacity. Round robin is a load-balancing metric and does not apply. Elasticity is the ability to add and remove resources, autoscaling is the automated process of adding and removing capacity, and vertical scaling is expanding a server.",
    "topic_id": 3,
    "practice_test_id": 1,
    "related_articles": [
      163,
      182,
      208,
      164,
      183
    ],
    "source": "333776_PracticeExam1",
    "choice_e": "Vertical"
  },
  {
    "id": 338,
    "question": "Your public cloud provider has located an availability zone data center in a large industrial park with no company signage, deployed extensive video cameras around the property, erected tall security fences, and deployed biometrics at the guard shack. What type of security is the cloud provider implementing?",
    "choice_a": "Building",
    "choice_b": "Device",
    "choice_c": "Infrastructure",
    "choice_d": "Tunneling",
    "correct_answer": "C",
    "explanation": "Infrastructure security is the hardening of the facility, and it includes the steps outlined in the question, including nondescript facilities, video surveillance, and biometric access.",
    "topic_id": 4,
    "practice_test_id": 7,
    "related_articles": [
      89,
      75,
      73,
      76,
      77
    ],
    "source": "333776_PracticeExam1"
  },
  {
    "id": 339,
    "question": "Because of cost savings and the need to be able to scale resources dynamically, you have decided to move a fleet of virtual machines from your corporate data center to a public cloud IaaS service. However, the cloud provider has special hypervisor requirements that are different from your operations. What type of migration would you need to perform to move the VMs to the cloud?",
    "choice_a": "Orchestration",
    "choice_b": "P2V",
    "choice_c": "Private to public",
    "choice_d": "V2V",
    "correct_answer": "D",
    "explanation": "To migrate a virtualized machine image to a different format, you would need to perform a virtual-to-virtual (V2V) migration.",
    "topic_id": 2,
    "practice_test_id": 4,
    "related_articles": [
      28,
      64,
      72,
      66,
      67
    ],
    "source": "333776_PracticeExam1",
    "choice_e": "Synchronous replication"
  },
  {
    "id": 340,
    "question": "Allison is working on her company\u2019s new e-commerce rollout at a large public cloud provider. She wants to secure all web traffic between the client and her site when a user proceeds to checkout and places orders. What security protocol would she be implementing?",
    "choice_a": "MD5",
    "choice_b": "SSL/TLS",
    "choice_c": "IPsec",
    "choice_d": "VPN",
    "correct_answer": "B",
    "explanation": "SSL/TLS is commonly used in browsers and smartphone applications for secure web access. MD5 is a hash algorithm, and IPsec is a security framework; they do not apply to the question. VPNs are not as common as SSL/TLS for the scenario given.<br>Question Type: TB <br>Level of Bloom\u2019s Taxonomy.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      85,
      82,
      83,
      57,
      100
    ],
    "source": "333776_PracticeExam1"
  },
  {
    "id": 341,
    "question": "Your disaster recovery facility is using DNS to load-balance the primary and backup sites. You need to verify that the database in the DR facility is updated in real time and remains current with the production replica in the primary data center at all times. What type of updates would you configure in the primary data center servers prior to enabling the DNS load balancing?",
    "choice_a": "Synchronous replication",
    "choice_b": "Asynchronous replication",
    "choice_c": "Volume sync",
    "choice_d": "Mirroring",
    "correct_answer": "A",
    "explanation": "Synchronous replication offerings write data to both the primary storage system and the replica simultaneously in order to ensure that the remote data is current with local replicas.",
    "topic_id": 1,
    "practice_test_id": 4,
    "related_articles": [
      131,
      135,
      18,
      138,
      70
    ],
    "source": "333776_PracticeExam1",
    "choice_e": "RAID 5"
  },
  {
    "id": 342,
    "question": "What hypervisor virtualized pools can be upgraded to increase virtual server capacity? (Choose three.)",
    "choice_a": "CPU",
    "choice_b": "SLA",
    "choice_c": "RAM",
    "choice_d": "Network I/O",
    "correct_answer": [
      "A",
      "C",
      "D"
    ],
    "explanation": "Server capacity and performance can be increased by adding CPU processing, memory, and network capacity. SLA, ACL, and DNS are not related to increasing server capacity.",
    "topic_id": 1,
    "practice_test_id": 4,
    "related_articles": [
      42,
      10,
      71,
      49,
      43
    ],
    "source": "333776_PracticeExam1",
    "choice_e": "ACL",
    "choice_f": "DNS"
  },
  {
    "id": 343,
    "question": "What technology allows for a secure connection over an insecure network?",
    "choice_a": "Direct peering",
    "choice_b": "IDS",
    "choice_c": "VPN",
    "choice_d": "AES-256",
    "correct_answer": "C",
    "explanation": "A secure Internet-based connection would be a virtual private network (VPN).",
    "topic_id": 1,
    "practice_test_id": 3,
    "related_articles": [
      16,
      36,
      70,
      27,
      8
    ],
    "source": "333776_PracticeExam1",
    "choice_e": "RDP"
  },
  {
    "id": 344,
    "question": "Noah is drafting a change document to migrate a back-office application from his company\u2019s private cloud to a global public cloud provider. As part of the migration, he plans on directly interconnecting the two clouds. What type of cloud is this?",
    "choice_a": "Public",
    "choice_b": "Hybrid",
    "choice_c": "Community",
    "choice_d": "Private",
    "correct_answer": "B",
    "explanation": "The interconnection of multiple cloud models is referred to as a hybrid cloud.",
    "topic_id": 2,
    "practice_test_id": 3,
    "related_articles": [
      5,
      96,
      72,
      6,
      29
    ],
    "source": "333776_PracticeExam2"
  },
  {
    "id": 345,
    "question": "A critical application has sensitive data stored in cloud-based object storage in three Canadian public cloud regions. Because of regulatory requirements, a high-security user access solution is required that needs explicitly defined user groups that are allowed to modify specific objects. You are asked to provide a solution that meets these requirements. What would you suggest that they implement?",
    "choice_a": "Mandatory access control",
    "choice_b": "Nondiscretionary",
    "choice_c": "Roles",
    "choice_d": "Multifactor",
    "correct_answer": "A",
    "explanation": "The mandatory access control approach is implemented in environments where access to sensitive data needs to be highly controlled. Based on the user\u2019s identity and security levels of the individual, access rights will be determined by comparing that data against the security properties of the system being accessed.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      94,
      93,
      98,
      167,
      68
    ],
    "source": "333776_PracticeExam2"
  },
  {
    "id": 346,
    "question": "You have designed a web architecture that allows you to have an exact copy of your production fleet that can be brought online to replace your existing deployment for patching and maintenance. What type of model did you implement?",
    "choice_a": "Cluster",
    "choice_b": "DevOps",
    "choice_c": "Blue-green",
    "choice_d": "Rolling",
    "correct_answer": "C",
    "explanation": "Blue-green is a software deployment methodology that uses two configurations for production that are identical. These deployments can alternate, with one active and the other inactive.",
    "topic_id": 2,
    "practice_test_id": 3,
    "related_articles": [
      114,
      132,
      29,
      45,
      33
    ],
    "source": "333776_PracticeExam2"
  },
  {
    "id": 347,
    "question": "A public cloud company offers a service that takes responsibility for the operating system but not the applications and services running on the operating system. What type of service model is this?",
    "choice_a": "IaaS",
    "choice_b": "PaaS",
    "choice_c": "SaaS",
    "choice_d": "XaaS",
    "correct_answer": "B",
    "explanation": "With the PaaS model, the cloud provider maintains the operating system and all supporting infrastructure but not any applications running on the server.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      4,
      24,
      26,
      91,
      113
    ],
    "source": "333776_PracticeExam2"
  },
  {
    "id": 348,
    "question": "What application is used to synchronize time across multiple systems?",
    "choice_a": "DNS",
    "choice_b": "NTP",
    "choice_c": "Databases",
    "choice_d": "Middleware",
    "correct_answer": "B",
    "explanation": "The Network Time Protocol provides a master clock source to allow all servers to be time synchronized.",
    "topic_id": 6,
    "practice_test_id": 3,
    "related_articles": [
      212,
      217,
      209,
      224,
      226
    ],
    "source": "333776_PracticeExam2"
  },
  {
    "id": 349,
    "question": "Carol is a solutions architect who has been hired to assist a company in migrating to a public cloud provider. When investigating a highly customized application server, she finds that the standard Linux image has been modified and is not a standard distribution. What type of cloud service model would be most appropriate for hosting this machine image?",
    "choice_a": "IaaS",
    "choice_b": "PaaS",
    "choice_c": "SaaS",
    "choice_d": "CaaS",
    "correct_answer": "A",
    "explanation": "Infrastructure-as-a-Service offers computing hardware, storage, and networking. It also allows the customer to install and manage the operating system.",
    "topic_id": 1,
    "practice_test_id": 5,
    "related_articles": [
      4,
      26,
      24,
      91,
      3
    ],
    "source": "333776_PracticeExam2"
  },
  {
    "id": 350,
    "question": "A U.S.-based defense contractor must meet server compliance requirements needed to be certified to meet the U.S. Department of Defense security requirements that apply to contractors. What federal requirement would you recommend the contractor focus on?",
    "choice_a": "FedRAMP",
    "choice_b": "DIACAP",
    "choice_c": "FISMA",
    "choice_d": "Section 405.13 for DoD rule A286",
    "correct_answer": "B",
    "explanation": "The Department of Defense Information Assurance Certification and Accreditation Process (DIACAP) is the process for computer systems IT security. DIACAP compliance is required to be certified to meet the U.S. Department of Defense security requirements for contractors.",
    "topic_id": 4,
    "practice_test_id": 3,
    "related_articles": [
      76,
      73,
      79,
      102,
      75
    ],
    "source": "333776_PracticeExam2"
  },
  {
    "id": 351,
    "question": "Priscilla is preparing to perform a major upgrade on a critical virtual machine. She wants to have a backout plan if the upgrade validation fails. What virtual machine backup method creates a file-based image of the current state of a VM, including the complete operating system and all applications that are stored on it, that she can use to restore the VM if the testing of the upgrade fails?",
    "choice_a": "Full backup",
    "choice_b": "Snapshot",
    "choice_c": "Clone",
    "choice_d": "Replicate",
    "correct_answer": "B",
    "explanation": "A snapshot is a file-based image of the current state of a VM, including the complete operating systems and all applications that are stored on it. The snapshot will record the data on the disk, its current state, and the VM\u2019s configuration at that instant in time and can be restored to operational state if needed.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      119,
      124,
      123,
      160,
      129
    ],
    "source": "333776_PracticeExam2"
  },
  {
    "id": 352,
    "question": "David is planning for a large advertising campaign his company will unveil. He is concerned that his current e-commerce server farm hosted in a public cloud will be overwhelmed and suffer performance problems. He is researching cost-effective options to add capacity dynamically to the webserver farm to handle the anticipated additional workload. You are brought in to consult with him on his options. What can you recommend as possible solutions? (Choose two.)",
    "choice_a": "Vertical scaling",
    "choice_b": "Horizontal scaling",
    "choice_c": "Edge cache",
    "choice_d": "Cloud bursting",
    "correct_answer": [
      "B",
      "D"
    ],
    "explanation": "Cloud computing operates with a utility business model that charges you only for the resources you consume. This model enables you to scale your cloud fleet to meet its current workload and be able to add and remove capacity as needed. There are many options that use elasticity to scale cloud operations, including horizontal scaling and bursting.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      22,
      164,
      163,
      170,
      208
    ],
    "source": "333776_PracticeExam2",
    "choice_e": "Core elasticity"
  },
  {
    "id": 353,
    "question": "Kezia is the chief information officer at a medium-sized accounting firm. During tax preparation season, the internal demand for computing resources rises, and then after the taxes are filed, the computing capacity is no longer needed. She is being asked to create a more efficient and agile solution to her company\u2019s operations that maximizes operational expenditures. What servers does the public cloud offer to meet her needs? (Choose three.)",
    "choice_a": "Elasticity",
    "choice_b": "On-demand computing",
    "choice_c": "Availability zones",
    "choice_d": "Resiliency virtualization",
    "correct_answer": [
      "A",
      "B",
      "E"
    ],
    "explanation": "Elasticity, on-demand-computing, and pay-as-you-grow are all examples of being able to expand and contract cloud compute resources as your needs require.",
    "topic_id": 1,
    "practice_test_id": 7,
    "related_articles": [
      2,
      3,
      10,
      4,
      8
    ],
    "source": "333776_PracticeExam2",
    "choice_e": "Pay-as-you grow",
    "choice_f": "Resource pooling"
  },
  {
    "id": 354,
    "question": "Phoebe is in the process of implementing a hybrid cloud model that connects her company\u2019s private cloud to a public cloud that supports on-demand web hosting. To ease the management of the remote resources for her network operations center, she wants to implement LDAP in the remote cloud services to interconnect with her locally hosted Active Directory servers. What type of system is she deploying?",
    "choice_a": "Token-based 2FA",
    "choice_b": "SSO",
    "choice_c": "RSA",
    "choice_d": "Nondiscretionary",
    "correct_answer": "B",
    "explanation": "Single sign-on allows a user to log in one time and be granted access to multiple systems without having to authenticate to each one individually.",
    "topic_id": 4,
    "practice_test_id": 7,
    "related_articles": [
      95,
      165,
      97,
      93,
      102
    ],
    "source": "333776_PracticeExam2"
  },
  {
    "id": 355,
    "question": "What are common automation systems that are used for patch management? (Choose three.)",
    "choice_a": "Chef",
    "choice_b": "Cloud-patch",
    "choice_c": "Ansible",
    "choice_d": "DevOps",
    "correct_answer": [
      "A",
      "C",
      "E"
    ],
    "explanation": "Common patch management offerings are Chef, Puppet, and Ansible.",
    "topic_id": 3,
    "practice_test_id": 5,
    "related_articles": [
      149,
      122,
      160,
      115,
      148
    ],
    "source": "333776_PracticeExam2",
    "choice_e": "Puppet",
    "choice_f": "Cloud Deploy"
  },
  {
    "id": 356,
    "question": "What type of cloud dataset measures object metrics to determine normal operations?",
    "choice_a": "Metric",
    "choice_b": "Variance",
    "choice_c": "Baseline",
    "choice_d": "Smoothing",
    "correct_answer": "C",
    "explanation": "The establishment of average usage over time is the data that gets collected for a baseline report.",
    "topic_id": 3,
    "practice_test_id": 3,
    "related_articles": [
      175,
      173,
      157,
      183,
      161
    ],
    "source": "333776_PracticeExam2"
  },
  {
    "id": 357,
    "question": "There has been a large increase in the number of pending read requests over time on your SQL database. You have been asked to evaluate the baseline variances. What would be the focus of your troubleshooting?",
    "choice_a": "Memory",
    "choice_b": "CPU",
    "choice_c": "Storage",
    "choice_d": "Networking",
    "correct_answer": "C",
    "explanation": "Databases read and write requests utilize storage I/O and should be the focus for troubleshooting.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      62,
      53,
      71,
      55,
      58
    ],
    "source": "333776_PracticeExam2"
  },
  {
    "id": 358,
    "question": "Randall is investigating the various cloud service models. His primary needs require the service offered by a community cloud provider that offers a specialized retail sales reporting application. The application is owned and operated by the provider, and he pays only for what his company uses. What service type of cloud is this?",
    "choice_a": "IaaS",
    "choice_b": "PaaS",
    "choice_c": "SaaS",
    "choice_d": "CaaS",
    "correct_answer": "C",
    "explanation": "Software-as a-Service offers cloud-managed applications as well as the underlying platform and infrastructure support.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      4,
      26,
      24,
      35,
      91
    ],
    "source": "333776_PracticeExam2"
  },
  {
    "id": 359,
    "question": "To secure a data center interconnection between your company\u2019s Sydney and Berlin regions, you are being asked for a common solution that allows interoperability between the various vendors\u2019 firewalls and routers in each region. What is a good solution for securing interconnections over the Internet and between dissimilar hardware and software security devices?",
    "choice_a": "AES",
    "choice_b": "SOC-3",
    "choice_c": "IPsec",
    "choice_d": "RC5",
    "correct_answer": "C",
    "explanation": "IPsec implementations are found in routers and firewalls with VPN services to provide a secure connection over an insecure network such as the Internet and are interoperability standards.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      16,
      36,
      70,
      8,
      11
    ],
    "source": "333776_PracticeExam2"
  },
  {
    "id": 360,
    "question": "Anna has created a master image of a webserver that she plans to use for adding new servers for her horizontally scaled e-commerce site. What VM backup method can be used to create an image to be used as a template to create additional systems?",
    "choice_a": "Full backup",
    "choice_b": "Snapshot",
    "choice_c": "Clone",
    "choice_d": "Replicate",
    "correct_answer": "C",
    "explanation": "Cloning takes the master image and clones it to be used as another separate and independent VM. Important components of a server are changed to prevent address conflicts; these include the UUID and MAC addresses of the cloned server.",
    "topic_id": 1,
    "practice_test_id": 6,
    "related_articles": [
      10,
      27,
      42,
      113,
      52
    ],
    "source": "333776_PracticeExam2"
  },
  {
    "id": 361,
    "question": "You are monitoring your public cloud\u2019s object reporting system on a web-based dashboard. A custom graph has been created that compares actual memory and CPU load to the baseline. What is the difference between these two values called?",
    "choice_a": "Deviation",
    "choice_b": "Variance",
    "choice_c": "Triggers",
    "choice_d": "Baseline imbalance",
    "correct_answer": "B",
    "explanation": "The measurement of the difference between a current reading and the baseline value is referred to as the variance.",
    "topic_id": 3,
    "practice_test_id": 3,
    "related_articles": [
      173,
      177,
      157,
      175,
      183
    ],
    "source": "333776_PracticeExam2"
  },
  {
    "id": 362,
    "question": "You are evaluating the physical layout of a large public cloud company. Your company\u2019s operations require local data centers in Japan, Kuwait, Berlin, and Chicago to host low-latency webservices for your customers. What cloud architecture should you implement?",
    "choice_a": "Regions",
    "choice_b": "Autoscaling groups",
    "choice_c": "Availability zones",
    "choice_d": "Global DNS affinity",
    "correct_answer": "A",
    "explanation": "Cloud operators segment their operations into regions for customer proximity, regulatory compliance, resiliency, and survivability.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      21,
      143,
      146,
      35,
      141
    ],
    "source": "333776_PracticeExam2"
  },
  {
    "id": 363,
    "question": "A new federal regulation has been released that requires stringent new encryption requirements for data at rest. You are investigating different types of data security protection technologies. What is the best encryption option for this requirement?",
    "choice_a": "3DES",
    "choice_b": "RSA",
    "choice_c": "AES-256",
    "choice_d": "Rivest Cipher 5",
    "correct_answer": "C",
    "explanation": "Advanced Encryption Standard is a symmetrical block cipher that has options to use three lengths, including 128, 192, and 256 bits. AES 256 is a very secure standard.",
    "topic_id": 4,
    "practice_test_id": 6,
    "related_articles": [
      83,
      57,
      82,
      100,
      111
    ],
    "source": "333776_PracticeExam2"
  },
  {
    "id": 364,
    "question": "Peter is troubleshooting a SQL database hosted in a public cloud using the IaaS service model. The database vendor has identified a bug in the table merge feature and is requesting that Peter install a software change that is designed for rapid deployment and that corrects a specific and critical issue. What type of fix is this?",
    "choice_a": "Hotfix",
    "choice_b": "Patch",
    "choice_c": "Version update",
    "choice_d": "Rollout",
    "correct_answer": "A",
    "explanation": "A hotfix is a software update type that is intended to fix an immediate and specific problem.",
    "topic_id": 3,
    "practice_test_id": 1,
    "related_articles": [
      160,
      168,
      123,
      192,
      41
    ],
    "source": "333776_PracticeExam2"
  },
  {
    "id": 365,
    "question": "As a Cloud+ certified professional, you have been asked to review your company\u2019s hybrid servers to ensure that they are properly hardened from a malicious attack. You review the servers\u2019 active user accounts and see that there are accounts that belong to consultants who review your operations once each year. They are not scheduled to return for ten more months. What should you do with these accounts?",
    "choice_a": "Do nothing.",
    "choice_b": "Delete the accounts.",
    "choice_c": "Disable the accounts.",
    "choice_d": "Change the resource access definitions.",
    "correct_answer": "C",
    "explanation": "The ability to disable an account can be helpful in situations where the account will need to be reactivated at a future date and does not need to be deleted.",
    "topic_id": 4,
    "practice_test_id": 4,
    "related_articles": [
      166,
      89,
      165,
      75,
      79
    ],
    "source": "333776_PracticeExam2",
    "choice_e": "Modify the confederation settings.",
    "choice_f": "Change the access control"
  },
  {
    "id": 366,
    "question": "You are architecting a new cloud virtual container. There will be a maximum of 11 servers in the subnet that will each require a private IP address. You decide to use a /28 subnet mask for the IPv4 addressing plan. What other services may be consuming IP addresses on this subnet other than the servers? (Choose three.)",
    "choice_a": "SLA",
    "choice_b": "Default gateway",
    "choice_c": "DNS",
    "choice_d": "NTP",
    "correct_answer": [
      "B",
      "C",
      "D"
    ],
    "explanation": "In addition to the webservers, IP addresses may be required for the NTP and DNS services and the default gateway.",
    "topic_id": 1,
    "practice_test_id": 5,
    "related_articles": [
      39,
      70,
      11,
      36,
      8
    ],
    "source": "333776_PracticeExam2",
    "choice_e": "API",
    "choice_f": "SNMP"
  },
  {
    "id": 367,
    "question": "You are preparing a presentation to your company\u2019s IT management that explains physical resources that become virtualized and presented as resources to virtual machines running on hypervisors. What resources do the hypervisors consume? (Choose three.)",
    "choice_a": "Bare-metal cores",
    "choice_b": "Virtual RAM",
    "choice_c": "SaaS",
    "choice_d": "Virtual CPUs",
    "correct_answer": [
      "A",
      "D",
      "F"
    ],
    "explanation": "A hypervisor virtualizes RAM, compute, and storage; the VMs operating on the hypervisor will access these pools.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      3,
      42,
      10,
      8,
      71
    ],
    "source": "333776_PracticeExam2",
    "choice_e": "RAID",
    "choice_f": "Virtual storage"
  },
  {
    "id": 368,
    "question": "After upgrading an accounting application in your IaaS fleet of servers, you notice that the newly installed features in the upgrade dramatically increase the local processing requirements for the servers. What virtual resource can be increased to account for the new application\u2019s added requirements?",
    "choice_a": "DMA",
    "choice_b": "BIOS",
    "choice_c": "CPU",
    "choice_d": "IPsec",
    "correct_answer": "C",
    "explanation": "Implementing new application features may cause increased CPU usage and require that you add CPU resources to meet the requirements of the application.",
    "topic_id": 2,
    "practice_test_id": 3,
    "related_articles": [
      64,
      6,
      25,
      45,
      19
    ],
    "source": "333776_PracticeExam2",
    "choice_e": "I/O"
  },
  {
    "id": 369,
    "question": "Brian is working on a disaster recovery plan for his employer. If there is extended downtime, the company could be materially impacted since all of their revenue is generated from online sales. Brian\u2019s plan will restore operations in the shortest amount of time possible if there was an outage. What disaster recovery model is he implementing?",
    "choice_a": "Hot site",
    "choice_b": "Active/active",
    "choice_c": "Warm site",
    "choice_d": "Active/passive",
    "correct_answer": "A",
    "explanation": "The hot site model is the most viable option given the requirements. A hot site is a fully functional backup site that can assume operations in a short amount of time should the primary location fail or go offline.",
    "topic_id": 1,
    "practice_test_id": 7,
    "related_articles": [
      135,
      138,
      143,
      141,
      146
    ],
    "source": "333776_PracticeExam2",
    "choice_e": "Cold site",
    "choice_f": "Rollover"
  },
  {
    "id": 370,
    "question": "Capacity and utilization reporting often contains utilization information on which hypervisor objects? (Choose two.)",
    "choice_a": "CPU",
    "choice_b": "OS version",
    "choice_c": "Volume tier",
    "choice_d": "RAM",
    "correct_answer": [
      "A",
      "D"
    ],
    "explanation": "CPU and network utilization are all important objects to manage for capacity and utilization tracking. Storage volume tiers and OS versions do not apply to this scenario.",
    "topic_id": 1,
    "practice_test_id": 7,
    "related_articles": [
      43,
      42,
      71,
      50,
      10
    ],
    "source": "333776_PracticeExam2",
    "choice_e": "Network"
  },
  {
    "id": 371,
    "question": "Allison is testing reachability from the Internet to a new server farm that she is deploying in a public cloud data center in Paris. She is using a PaaS hosted system with an open source webserver. She logs into a jump server in Sydney for the test. What utility can she use to verify the path taken from the jump server to the cloud site?",
    "choice_a": "<code>traceroute</code>",
    "choice_b": "<code>ipconfig</code>",
    "choice_c": "<code>arp</code>",
    "choice_d": "<code>netstat</code>",
    "correct_answer": "A",
    "explanation": "The <code>tracert</code> and <code>traceroute</code> utilities are useful for reachability testing. <code>traceroute</code> shows the routed path a packet of data takes from source to destination. You can use it to determine whether routing is working as expected and whether there is a route failure in the path. The other answers were all incorrect because they do not provide network path data.",
    "topic_id": 6,
    "practice_test_id": null,
    "related_articles": [
      217,
      188,
      212,
      211,
      226
    ],
    "source": "333776_PracticeExam2",
    "choice_e": "<code>ping</code>",
    "choice_f": "<code>tcpdump</code>",
    "choice_g": "<code>route print</code>"
  },
  {
    "id": 372,
    "question": "When logging into the management console of her public cloud provider, what requirement does Marie first fulfill to identify herself?",
    "choice_a": "Authorization",
    "choice_b": "Accounting",
    "choice_c": "Authentication",
    "choice_d": "Federation",
    "correct_answer": "B",
    "explanation": "Authentication is the term used to describe the process of determining the identity of a user or device.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      69,
      165,
      92,
      97,
      101
    ],
    "source": "333776_PracticeExam2",
    "choice_e": "Identity access"
  },
  {
    "id": 373,
    "question": "Asher has been reviewing his company\u2019s SLA and statement of responsibilities with their public cloud provider\u2019s IaaS offerings. In this model, who would be responsible for the integrity of data stored in the cloud?",
    "choice_a": "Cloud provider",
    "choice_b": "Compliance agency",
    "choice_c": "Cloud customer",
    "choice_d": "Shared responsibility",
    "correct_answer": "D",
    "explanation": "Ultimately the responsibility for data in the cloud belongs to the organization that owns the data.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      24,
      91,
      26,
      4,
      141
    ],
    "source": "333776_PracticeExam2"
  },
  {
    "id": 374,
    "question": "Martha is architecting a public cloud-based design that allows data for her e-commerce site to be cached at remote locations. She wants to reduce the load on her webservers and reduce the network latency of geographically distant customers. What cloud service can she use to accomplish her objectives?",
    "choice_a": "Region",
    "choice_b": "Edge location",
    "choice_c": "Availability zone",
    "choice_d": "Replication",
    "correct_answer": "B",
    "explanation": "Edge locations are not complete cloud data centers. They are cloud connection points located in major cities that offer local caching of data for reduced response times.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      40,
      131,
      18,
      21,
      35
    ],
    "source": "333776_PracticeExam2"
  },
  {
    "id": 375,
    "question": "Object tracking metrics should be aligned with which cloud service provider requirements?",
    "choice_a": "VPC",
    "choice_b": "SLA",
    "choice_c": "RDP",
    "choice_d": "JSON",
    "correct_answer": "B",
    "explanation": "Tracking object performance data should match the guaranteed levels outlined in the service level agreement.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      141,
      24,
      4,
      26,
      91
    ],
    "source": "333776_PracticeExam2"
  },
  {
    "id": 376,
    "question": "You are rolling out new Windows-based webservers for a customer. You have been asked to configure remote graphical access to a bastion server co-located with the webservers. What Internet traffic must you permit through the external-facing firewall to the host to meet this requirement?",
    "choice_a": "SSH",
    "choice_b": "RDP",
    "choice_c": "DNS",
    "choice_d": "IPS",
    "correct_answer": "B",
    "explanation": "The Windows Remote Desktop Protocol allows for remote connections to a Windows graphical user desktop.",
    "topic_id": 4,
    "practice_test_id": 5,
    "related_articles": [
      86,
      37,
      93,
      88,
      99
    ],
    "source": "333776_PracticeExam2"
  },
  {
    "id": 377,
    "question": "Tobias is a DevOps engineer and is exploring the different options available to him to automate VM troubleshooting in a private cloud. What are common interfaces that you would suggest he investigate? (Choose three.)",
    "choice_a": "Web console",
    "choice_b": "SNMP",
    "choice_c": "API",
    "choice_d": "PaaS",
    "correct_answer": [
      "A",
      "C",
      "E"
    ],
    "explanation": "Application programming interfaces, command-line interfaces, and GUI-based interfaces are all commonly used tools to migrate, monitor, manage, and troubleshoot cloud-based resources.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      106,
      87,
      74,
      75,
      38
    ],
    "source": "333776_PracticeExam2",
    "choice_e": "CLI"
  },
  {
    "id": 378,
    "question": "What technology has been instrumental in the growth of on-demand cloud services?",
    "choice_a": "XML",
    "choice_b": "Python",
    "choice_c": "Automation",
    "choice_d": "Authentication",
    "correct_answer": "C",
    "explanation": "The automation of cloud deployments was instrumental in the growth of on-demand cloud-based services. The other options are widely implemented in cloud architectures but are not the best answer to the question given.",
    "topic_id": 5,
    "practice_test_id": 3,
    "related_articles": [
      121,
      103,
      117
    ],
    "source": "333776_PracticeExam2",
    "choice_e": "Scripting",
    "choice_f": "Workflow services",
    "choice_g": "Encryption"
  },
  {
    "id": 379,
    "question": "You are a Cloud+ certified consultant assisting a software company design a disaster recovery plan that includes a remote backup site that has an active SQL server instance that is synchronously refreshed from the master replica. Your plan calls for activating all other services if the primary private cloud data center should go offline. What DR model should you deploy?",
    "choice_a": "Hot site",
    "choice_b": "Warm site",
    "choice_c": "Cold site",
    "choice_d": "Active/passive",
    "correct_answer": "B",
    "explanation": "A warm site approach to recovering from a primary data center outage is when the remote backup of the site is offline except for critical data such as a database.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      135,
      131,
      141,
      143,
      21
    ],
    "source": "333776_PracticeExam2"
  },
  {
    "id": 380,
    "question": "Esther has been tracking the performance metrics on a busy NoSQL database server that has heavy write operations of large files from the second-tier application servers. She is concerned that network utilization is approaching 100 percent of the available network bandwidth. What action should she take that will resolve the problem?",
    "choice_a": "Implement 802.1Q tagging.",
    "choice_b": "Install a second network adapter.",
    "choice_c": "Update the network adapter\u2019s firmware.",
    "choice_d": "Install a network co-processor ASIC.",
    "correct_answer": "B",
    "explanation": "If a server is using all of its network bandwidth, then the most logical solution is to increase the network adapter\u2019s bandwidth or add a second adapter and create a teaming configuration.",
    "topic_id": 6,
    "practice_test_id": null,
    "related_articles": [
      220,
      228,
      213,
      224,
      227
    ],
    "source": "333776_PracticeExam2"
  },
  {
    "id": 381,
    "question": "Your company has elected to use the warm site model for their disaster recovery operations. The remote devices are Linux servers, firewalls, routers, and load balancers that utilize serial ports for command-line access. You need to access these ports from the network operations center at your private cloud location. What device would you recommend be installed at the warm site to fulfill this requirement?",
    "choice_a": "RDP",
    "choice_b": "Telnet",
    "choice_c": "IPsec",
    "choice_d": "SSH",
    "correct_answer": "E",
    "explanation": "In a data center, terminal servers are deployed and have multiple serial ports, each cabled to a console port on a device that is being managed. This allows you to make an SSH or a Telnet connection over the network to the terminal server and then use the serial interfaces to access the console ports on the remote devices. The other options given do not provide serial port connections.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      135,
      146,
      27,
      16,
      11
    ],
    "source": "333776_PracticeExam2",
    "choice_e": "Terminal server"
  },
  {
    "id": 382,
    "question": "The reference design for a database server recommends using a durable block storage option that is durable, offers high utilization rates, and supports striping that allows a parity bit to be used to reconstruct a volume if a single SSD fails in the array. Which storage type stripes file data and performs a parity check of data over multiple disks that can recover from a single hard disk failure?",
    "choice_a": "RAID 0",
    "choice_b": "RAID 1",
    "choice_c": "RAID 3",
    "choice_d": "RAID 5",
    "correct_answer": "D",
    "explanation": "RAID 5 can withstand a single drive failure in the array because of the use of parity data that can be used to reconstruct the storage volume. The other RAID types do not have parity data.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      55,
      53,
      62,
      71,
      58
    ],
    "source": "333776_PracticeExam2"
  },
  {
    "id": 383,
    "question": "Bill is a security engineer at your firm and is involved in a multifactor authentication project. What options do you suggest he offer to his user base to access their login tokens? (Choose two.)",
    "choice_a": "Python app",
    "choice_b": "Smartphone app",
    "choice_c": "Automation systems",
    "choice_d": "Keyfob",
    "correct_answer": [
      "B",
      "D"
    ],
    "explanation": "One-time numerical tokens are generated on keyfob hardware devices or smartphone soft-token software applications.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      101,
      97,
      165,
      95,
      60
    ],
    "source": "333776_PracticeExam2",
    "choice_e": "Cloud vendor management dashboard"
  },
  {
    "id": 384,
    "question": "Your company can only afford to lose a maximum of the last 30 minutes of data in the event of a disaster. What section of the corporate business continuity and disaster recovery plan addresses this issue?",
    "choice_a": "RSO",
    "choice_b": "RPO",
    "choice_c": "RTO",
    "choice_d": "DBO",
    "correct_answer": "C",
    "explanation": "The recovery point objective is the point in time that data can be recovered.",
    "topic_id": 1,
    "practice_test_id": 6,
    "related_articles": [
      135,
      141,
      131,
      21,
      143
    ],
    "source": "333776_PracticeExam2"
  },
  {
    "id": 385,
    "question": "Matthew is preparing a change management plan to add CPU capacity to a busy database server used by his order entry department. What type of scaling involves replacing an existing server with another that has more capabilities?",
    "choice_a": "Horizontal",
    "choice_b": "Round robin",
    "choice_c": "Elasticity",
    "choice_d": "Autoscale",
    "correct_answer": "E",
    "explanation": "Vertical scaling is the process of upgrading or replacing a server with one that has greater capabilities.",
    "topic_id": 3,
    "practice_test_id": 5,
    "related_articles": [
      163,
      199,
      208,
      183,
      182
    ],
    "source": "333776_PracticeExam2",
    "choice_e": "Vertical"
  },
  {
    "id": 386,
    "question": "Hank is researching the methods that his network operations center can use to access the Berlin-hosted servers operating in a hybrid cloud configuration. Which of the following are <i>not</i> viable methods? (Choose two.)",
    "choice_a": "RDP",
    "choice_b": "Telnet",
    "choice_c": "IDS/IPS",
    "choice_d": "Terminal server",
    "correct_answer": [
      "C",
      "E"
    ],
    "explanation": "Common remote access tools include RDP, SSH, and terminal servers. IDSs/IPSs are for intrusion detection, and DNS is for domain name\u2013to\u2013IP address mappings and is not a utility for remote access.",
    "topic_id": 4,
    "practice_test_id": 6,
    "related_articles": [
      86,
      107,
      80,
      165,
      69
    ],
    "source": "333776_PracticeExam2",
    "choice_e": "DNS",
    "choice_f": "HTTP"
  },
  {
    "id": 387,
    "question": "Your customer is asking about strengthening their authentication security by implementing a system that requires each user who logs into the system to present something they know and something they possess. What is this type of authentication called?",
    "choice_a": "Single sign-on",
    "choice_b": "Kerberos",
    "choice_c": "Active Directory/LDAP",
    "choice_d": "Multifactor",
    "correct_answer": "D",
    "explanation": "Multifactor authentication systems use a token generator as something that you have and a PIN/password as something you know.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      101,
      95,
      97,
      165,
      92
    ],
    "source": "333776_PracticeExam2"
  },
  {
    "id": 388,
    "question": "When installing a new virtualized intrusion prevention system that is designed for cloud-based network micro-segmentation deployments, the management application requires you to download a Java configuration utility. What kind of automation system is this?",
    "choice_a": "CLI",
    "choice_b": "GIU",
    "choice_c": "Vendor based",
    "choice_d": "API",
    "correct_answer": "C",
    "explanation": "Based on the information given, the description is for a vendor-based management application.",
    "topic_id": 5,
    "practice_test_id": 1,
    "related_articles": [
      103,
      117,
      121
    ],
    "source": "333776_PracticeExam2",
    "choice_e": "RESTful"
  },
  {
    "id": 389,
    "question": "Which metrics outline when you can expect operations to be back online and how much data loss can be tolerated when recovering from an outage? (Choose all that apply.)",
    "choice_a": "RSO",
    "choice_b": "RTO",
    "choice_c": "RPO",
    "choice_d": "DR",
    "correct_answer": [
      "B",
      "C"
    ],
    "explanation": "The recovery point and recovery time objectives are the measurements for the amount of data lost and the time needed to get back online after an outage.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      135,
      141,
      131,
      143,
      138
    ],
    "source": "333776_PracticeExam2",
    "choice_e": "VxRestore"
  },
  {
    "id": 390,
    "question": "Alex is creating a new set of baseline reports after performing a series of OS and application upgrades on his e-commerce deployment in a public cloud. You are asked to assist in generating the new baselines. What do you employ to accomplish this?",
    "choice_a": "Hypervisor",
    "choice_b": "Databases",
    "choice_c": "Logging servers",
    "choice_d": "Cloud management and monitoring application",
    "correct_answer": "D",
    "explanation": "The cloud management and monitoring application can provide reports that can be used to generate new baselines.",
    "topic_id": 3,
    "practice_test_id": 5,
    "related_articles": [
      175,
      173,
      177,
      34,
      157
    ],
    "source": "333776_PracticeExam2"
  },
  {
    "id": 391,
    "question": "You are working a trouble ticket opened to address a group of offsite users who are unable to log into a cloud-based application. What user system are you troubleshooting?",
    "choice_a": "Authentication",
    "choice_b": "Authorization",
    "choice_c": "Federation",
    "choice_d": "Kerberos",
    "correct_answer": "A",
    "explanation": "Logging into systems is referred to as authentication.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      92,
      69,
      165,
      95,
      109
    ],
    "source": "333776_PracticeExam2"
  },
  {
    "id": 393,
    "question": "Name the cloud service model delivers server hardware without the operating system?",
    "choice_a": "IaaS",
    "choice_b": "PaaS",
    "choice_c": "SaaS",
    "choice_d": "CaaS",
    "correct_answer": "A",
    "explanation": "Infrastructure-as-a-Service offers computing hardware, storage, and networking but not the operating systems or applications.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      4,
      26,
      24,
      91,
      8
    ],
    "source": "333776_PracticeExam3"
  },
  {
    "id": 394,
    "question": "What is the cloud characteristic that allows you to access a self-service portal and instantly create additional servers, storage, or other services?",
    "choice_a": "Bursting",
    "choice_b": "Pay-as-you-grow",
    "choice_c": "Multitenancy",
    "choice_d": "On-demand",
    "correct_answer": "D",
    "explanation": "On-demand cloud computing allows the dynamically add and change resources with the use of an online portal.",
    "topic_id": 1,
    "practice_test_id": 7,
    "related_articles": [
      2,
      8,
      10,
      3,
      27
    ],
    "source": "333776_PracticeExam3"
  },
  {
    "id": 395,
    "question": "What cloud model delivers all services, including the application?",
    "choice_a": "IaaS",
    "choice_b": "PaaS",
    "choice_c": "SaaS",
    "choice_d": "CaaS",
    "correct_answer": "C",
    "explanation": "Software-as-a-Service delivers cloud-managed applications as well as the underlying platform and infrastructure support.",
    "topic_id": 1,
    "practice_test_id": 5,
    "related_articles": [
      4,
      26,
      24,
      91,
      8
    ],
    "source": "333776_PracticeExam3"
  },
  {
    "id": 396,
    "question": "Name the system that cloud providers implement for rapid deployment of customer-requested services?",
    "choice_a": "RDMS",
    "choice_b": "Orchestration",
    "choice_c": "On-demand provisions",
    "choice_d": "Service catalogs",
    "correct_answer": "B",
    "explanation": "Orchestration platforms automate the provisioning of cloud services and often include a self-service dashboard that allows the consumer to manage and deploy cloud services with a web browser. The automation used by cloud providers allows for fast deployment of new services and applications.",
    "topic_id": 2,
    "practice_test_id": 1,
    "related_articles": [
      120,
      33,
      45,
      20,
      112
    ],
    "source": "333776_PracticeExam3"
  },
  {
    "id": 397,
    "question": "What cloud service model delivers all services except the application?",
    "choice_a": "IaaS",
    "choice_b": "PaaS",
    "choice_c": "SaaS",
    "choice_d": "CaaS",
    "correct_answer": "B",
    "explanation": "Platform-as-a-Service offers computing hardware, storage, networking, and the operating systems but not the application software.",
    "topic_id": 1,
    "practice_test_id": 6,
    "related_articles": [
      4,
      26,
      24,
      91,
      8
    ],
    "source": "333776_PracticeExam3"
  },
  {
    "id": 398,
    "question": "What cloud delivery model is used by a single organization?",
    "choice_a": "Hybrid",
    "choice_b": "Public",
    "choice_c": "Private",
    "choice_d": "Community",
    "correct_answer": "C",
    "explanation": "A private cloud is used exclusively by a single organization.",
    "topic_id": 2,
    "practice_test_id": 4,
    "related_articles": [
      5,
      96,
      7,
      6,
      30
    ],
    "source": "333776_PracticeExam3"
  },
  {
    "id": 399,
    "question": "Name the authentication system that requires something you have and something you know?",
    "choice_a": "Single sign-on",
    "choice_b": "Confederations",
    "choice_c": "Active Directory/LDAP",
    "choice_d": "Multifactor",
    "correct_answer": "D",
    "explanation": "Multifactor authentication systems use a token generator as something that you have and a PIN/password as something you know.",
    "topic_id": 4,
    "practice_test_id": 5,
    "related_articles": [
      101,
      97,
      95,
      92,
      165
    ],
    "source": "333776_PracticeExam3"
  },
  {
    "id": 400,
    "question": "Which three of the following are considered secure network communication protocols? (Choose three.)",
    "choice_a": "SHHTP",
    "choice_b": "DHCP",
    "choice_c": "HTTPS",
    "choice_d": "DNS",
    "correct_answer": [
      "C",
      "E",
      "G"
    ],
    "explanation": "Hypertext Transport Protocol Secure, Secure Shell, and File Transfer Protocol Secure all provide encrypted transmission of data.",
    "topic_id": 4,
    "practice_test_id": 3,
    "related_articles": [
      81,
      86,
      82,
      80,
      88
    ],
    "source": "333776_PracticeExam3",
    "choice_e": "SSH",
    "choice_f": "SMTP",
    "choice_g": "FTPS"
  },
  {
    "id": 401,
    "question": "What storage type stripes data and performs a parity check of data over multiple disks that can recover from a hard disk failure?",
    "choice_a": "RAID 0",
    "choice_b": "RAID 1",
    "choice_c": "RAID 1+0",
    "choice_d": "RAID 5",
    "correct_answer": "D",
    "explanation": "RAID 5 has parity information that is striped across multiple drives that allows the drive array to be rebuilt if a single drive in the array fails. The other options do not have parity data.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      12,
      52,
      62,
      58,
      71
    ],
    "source": "333776_PracticeExam3"
  },
  {
    "id": 402,
    "question": "What is the document that outlines specific metrics and the minimum performance that is offered by the cloud provider?",
    "choice_a": "SSL",
    "choice_b": "SLA",
    "choice_c": "Benchmark",
    "choice_d": "Baseline",
    "correct_answer": "B",
    "explanation": "The service level agreement outlines specific metrics and the minimum performance provided by the cloud provider.",
    "topic_id": 1,
    "practice_test_id": 5,
    "related_articles": [
      141,
      24,
      26,
      91,
      1
    ],
    "source": "333776_PracticeExam3"
  },
  {
    "id": 403,
    "question": "Name the process document that outlines your company\u2019s responsibilities to securely deploy your fleet of servers in the public cloud?",
    "choice_a": "DIACAP",
    "choice_b": "Security policy",
    "choice_c": "Service level agreement",
    "choice_d": "SOC-2",
    "correct_answer": "B",
    "explanation": "The company\u2019s security policy outlines all aspects of your cloud security posture.",
    "topic_id": 4,
    "practice_test_id": 7,
    "related_articles": [
      75,
      73,
      106,
      89,
      79
    ],
    "source": "333776_PracticeExam3"
  },
  {
    "id": 404,
    "question": "Which two low-level security methods does the cloud provider use on their storage area network and storage head end controllers? (Choose two.)",
    "choice_a": "ACL",
    "choice_b": "VSAN",
    "choice_c": "PKI",
    "choice_d": "LUN masking",
    "correct_answer": [
      "B",
      "D"
    ],
    "explanation": "Virtual storage area networks are implemented at the SAN level, and LUN masking is configured on storage controllers and are both low-level storage access methods.",
    "topic_id": 1,
    "practice_test_id": 5,
    "related_articles": [
      55,
      53,
      71,
      52,
      62
    ],
    "source": "333776_PracticeExam3",
    "choice_e": "Discretionary access"
  },
  {
    "id": 405,
    "question": "What is the HTTP security implementation used in e-commerce webservers?",
    "choice_a": "AH/ESP",
    "choice_b": "AES 256",
    "choice_c": "SSL",
    "choice_d": "IPSec",
    "correct_answer": "C",
    "explanation": "Secure Sockets Layer (SSL) makes up a protocol group that operates on top of TCP to provide an encrypted session between the client and the server. It is commonly seen on websites implemented as the Hypertext Transport Protocol Secure (HTTPS) protocol.",
    "topic_id": 4,
    "practice_test_id": 3,
    "related_articles": [
      81,
      82,
      83,
      80,
      100
    ],
    "source": "333776_PracticeExam3"
  },
  {
    "id": 406,
    "question": "What cloud-based VPN access technology is used for secure access from your corporate data center to the cloud that offers data integrity and confidentiality?",
    "choice_a": "AES",
    "choice_b": "SOC-3",
    "choice_c": "IPSec",
    "choice_d": "RC5",
    "correct_answer": "C",
    "explanation": "Many IPSec implementations are found in routers and firewalls within VPNs, application security, and network security to provide a secure connection over an insecure network such as the Internet.",
    "topic_id": 1,
    "practice_test_id": 4,
    "related_articles": [
      16,
      11,
      70,
      91,
      8
    ],
    "source": "333776_PracticeExam3"
  },
  {
    "id": 407,
    "question": "Name a user access technology that will allow access to all allowed systems at the time of user authentication.",
    "choice_a": "Token-based 2FA",
    "choice_b": "SSO",
    "choice_c": "RSA",
    "choice_d": "Nondiscretionary",
    "correct_answer": "B",
    "explanation": "Single sign-on allows a user to log in one time and be granted access to multiple systems without having to authenticate to each one individually.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      95,
      97,
      165,
      92,
      69
    ],
    "source": "333776_PracticeExam3"
  },
  {
    "id": 408,
    "question": "What technology was instrumental in the growth of cloud services?",
    "choice_a": "XML",
    "choice_b": "Python",
    "choice_c": "Automation",
    "choice_d": "Authentication",
    "correct_answer": "C",
    "explanation": "Automation of cloud deployments was instrumental in the growth of cloud-based services.",
    "topic_id": 5,
    "practice_test_id": 1,
    "related_articles": [
      121,
      103,
      117
    ],
    "source": "333776_PracticeExam3",
    "choice_e": "Scripting",
    "choice_f": "Workflow services",
    "choice_g": "Encryption"
  },
  {
    "id": 409,
    "question": "What are complex software systems that automate cloud operations and are offered by companies such as Chef and Puppet called?",
    "choice_a": "Authentication",
    "choice_b": "Federations",
    "choice_c": "Orchestration",
    "choice_d": "Ephemeral",
    "correct_answer": "C",
    "explanation": "Orchestration systems are software packages or services that automate cloud operations.",
    "topic_id": 1,
    "practice_test_id": 4,
    "related_articles": [
      47,
      8,
      27,
      10,
      26
    ],
    "source": "333776_PracticeExam3"
  },
  {
    "id": 410,
    "question": "A web-based dashboard is being deployed by your company. Hank has been tasked to develop the application but is concerned that the application must pull data from many different cloud locations and devices. What is a good interface for him to use to meet his requirements?",
    "choice_a": "Python",
    "choice_b": "XML",
    "choice_c": "API",
    "choice_d": "SNMP",
    "correct_answer": "C",
    "explanation": "An application programming interface (API) offers programmatic access, control, and configuration of a device between different and discrete software components.",
    "topic_id": 5,
    "practice_test_id": 3,
    "related_articles": [
      103
    ],
    "source": "333776_PracticeExam3",
    "choice_e": "TLS"
  },
  {
    "id": 411,
    "question": "Which network application detects hacking attempts and actively takes countermeasures to shut down the connections?",
    "choice_a": "DMZ",
    "choice_b": "IDS",
    "choice_c": "IPS",
    "choice_d": "RAID",
    "correct_answer": "C",
    "explanation": "Intrusion prevention systems will monitor for malicious activity and actively take countermeasures to eliminate or reduce the effects of the intrusion.",
    "topic_id": 4,
    "practice_test_id": 7,
    "related_articles": [
      107,
      108,
      111,
      87,
      38
    ],
    "source": "333776_PracticeExam3",
    "choice_e": "HIDS"
  },
  {
    "id": 412,
    "question": "Storage that does not survive a virtual machine removal is referred to as what classification? (Choose two.)",
    "choice_a": "Durable",
    "choice_b": "RAID",
    "choice_c": "Ephemeral",
    "choice_d": "Nondurable",
    "correct_answer": [
      "C",
      "D"
    ],
    "explanation": "Temporary storage volumes that are only in existence when the VM is deployed are referred to as ephemeral or nondurable storage.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      55,
      12,
      52,
      3,
      10
    ],
    "source": "333776_PracticeExam3"
  },
  {
    "id": 413,
    "question": "What are three common automation systems that are used for patch management? (Choose three.)",
    "choice_a": "Chef",
    "choice_b": "Cloudpatch",
    "choice_c": "Ansible",
    "choice_d": "DevOps",
    "correct_answer": [
      "A",
      "C",
      "E"
    ],
    "explanation": "Common patch management offerings are Chef, Puppet, and Ansible.",
    "topic_id": 2,
    "practice_test_id": 3,
    "related_articles": [
      120,
      33,
      104,
      114,
      132
    ],
    "source": "333776_PracticeExam3",
    "choice_e": "Puppet",
    "choice_f": "Cloud Deploy"
  },
  {
    "id": 414,
    "question": "What backup method is used to create a master copy of an image that can be used as a template to create additional systems?",
    "choice_a": "Full backup",
    "choice_b": "Snapshot",
    "choice_c": "Clone",
    "choice_d": "Replicate",
    "correct_answer": "C",
    "explanation": "Cloning takes the master image and clones it to be used as another separate and independent VM. Important components of a server are changed to prevent address conflicts; these include the UUID and MAC addresses of the cloned server.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      10,
      27,
      42,
      131,
      62
    ],
    "source": "333776_PracticeExam3"
  },
  {
    "id": 427,
    "question": "Data replication is often used to store copies of real-time data in remote zones. When there is a need to have the master data immediately updated and then on the backend update the remote zones, what type of replication would you recommend your operations department to configure?",
    "choice_a": "Synchronous",
    "choice_b": "Asynchronous",
    "choice_c": "Volume sync",
    "choice_d": "Mirroring",
    "correct_answer": "A",
    "explanation": "Synchronous replication offerings write data to both the primary storage system and the replica simultaneously to ensure that the remote data is current with local replicas.",
    "topic_id": 1,
    "practice_test_id": 6,
    "related_articles": [
      131,
      71,
      135,
      21,
      143
    ],
    "source": "333776_PracticeExam3",
    "choice_e": "RAID 5"
  },
  {
    "id": 428,
    "question": "Sharon has been directed to put together a disaster recovery plan based on directives from her company\u2019s executive management team. The company\u2019s core business is operating an e-commerce website selling winter apparel with 85 percent of its revenue received during the holiday season. If there was a prolonged outage, it would put the company\u2019s ability to continue as a financially viable operation in peril. Sharon has been instructed to create a plan that will restore operations in the shortest amount of time possible. What disaster recovery model should she implement?",
    "choice_a": "Hot site",
    "choice_b": "Active/active",
    "choice_c": "Warm site",
    "choice_d": "Active/passive",
    "correct_answer": "A",
    "explanation": "The hot site model is the most viable option given the requirements. A hot site is a fully functional backup site that can assume operations immediately should the primary location fail or go offline.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      135,
      141,
      138,
      143,
      146
    ],
    "source": "333776_PracticeExam3",
    "choice_e": "Cold site",
    "choice_f": "Rollover"
  },
  {
    "id": 429,
    "question": "Name the two disaster recovery metrics that are used to create a measurable SLA that outlines when you can expect your systems to be back online and how much data loss you sustained after an outage? (Choose two.)",
    "choice_a": "RSO",
    "choice_b": "RTO",
    "choice_c": "RPO",
    "choice_d": "DR",
    "correct_answer": [
      "B",
      "C"
    ],
    "explanation": "The restore point and restore time objectives are the measurements for the amount of data lost and the time needed to get back online after an outage.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      141,
      135,
      131,
      21,
      24
    ],
    "source": "333776_PracticeExam3",
    "choice_e": "VxRestore"
  },
  {
    "id": 430,
    "question": "Name the disaster recovery site that is a remote facility ready with floor space, power, and cooling that has facilities to load server racks to restore services.",
    "choice_a": "Hot site",
    "choice_b": "Active/active",
    "choice_c": "Warm site",
    "choice_d": "Active/passive",
    "correct_answer": "E",
    "explanation": "A cold site is a backup data center provisioned to take over operations in the event of a primary data center failure, but the servers and infrastructure are not deployed or operational until needed.",
    "topic_id": 1,
    "practice_test_id": 1,
    "related_articles": [
      135,
      143,
      138,
      141,
      21
    ],
    "source": "333776_PracticeExam3",
    "choice_e": "Cold site",
    "choice_f": "Rollover"
  },
  {
    "id": 431,
    "question": "What system needs to be regularly scrubbed to remove stale records from its database that were added by other applications but never deleted? This network application resolves human readable names to IP addresses.",
    "choice_a": "SNMP",
    "choice_b": "DHCP",
    "choice_c": "DNS",
    "choice_d": "FTP",
    "correct_answer": "C",
    "explanation": "DNS records can be modified by external operations and can map domain names to IP addresses. There you will find occurrences of DNS entries not being deleted and becoming stale over time.",
    "topic_id": 6,
    "practice_test_id": null,
    "related_articles": [
      214,
      205,
      217,
      209,
      227
    ],
    "source": "333776_PracticeExam3"
  },
  {
    "id": 432,
    "question": "The cloud provider takes maintenance responsibility for the operating system, and your company assumes responsibility for any applications or services running on the operating system. What type of service model is this?",
    "choice_a": "IaaS",
    "choice_b": "PaaS",
    "choice_c": "SaaS",
    "choice_d": "XaaS",
    "correct_answer": "B",
    "explanation": "With the PaaS model, the cloud provider will maintain the operating system and all supporting infrastructure. Your company is responsible for the application.",
    "topic_id": 1,
    "practice_test_id": 1,
    "related_articles": [
      4,
      24,
      26,
      91,
      113
    ],
    "source": "333776_PracticeExam3"
  },
  {
    "id": 415,
    "question": "Matt is preparing for an upcoming promotion his company is offering during a major soccer game. He needs to determine his options to add capacity to his company\u2019s webserver farm so it can handle the anticipated additional workload. You are brought in is consult with him on his options. What do you recommend as possible solutions? (Choose three.)",
    "choice_a": "Vertical scaling",
    "choice_b": "Horizontal scaling",
    "choice_c": "Edge cache",
    "choice_d": "Cloud bursting",
    "correct_answer": [
      "A",
      "B",
      "D"
    ],
    "explanation": "Cloud computing operates with a utility business model that charges you only for the resources you consume. This model enables you to scale your cloud fleet to meet its current workload and be able to add and remove capacity as needed. There are many options to use elasticity to scale cloud operations, including vertical and horizontal scaling and bursting.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      163,
      22,
      170,
      164,
      208
    ],
    "source": "333776_PracticeExam3",
    "choice_e": "Core elasticity"
  },
  {
    "id": 416,
    "question": "Samantha has been monitoring her cloud webserver dashboard and notices that the CPU utilization on her company\u2019s database servers has been consistently at more than 80 percent utilization. She checked her baselines and reported that 57 percent utilization is normal. What is she noticing?",
    "choice_a": "Deviation",
    "choice_b": "Variance",
    "choice_c": "Triggers",
    "choice_d": "Baseline imbalance",
    "correct_answer": "B",
    "explanation": "The measurement of the difference between a current reading and the baseline value is referred to as the variance.",
    "topic_id": 3,
    "practice_test_id": 7,
    "related_articles": [
      175,
      173,
      177,
      157,
      183
    ],
    "source": "333776_PracticeExam3"
  },
  {
    "id": 417,
    "question": "Name the ability to automatically and dynamically add resources such as storage, CPUs, memory, and servers in the cloud.",
    "choice_a": "Bursting",
    "choice_b": "Pooling",
    "choice_c": "Elasticity",
    "choice_d": "Orchestration",
    "correct_answer": "C",
    "explanation": "Cloud automation systems offer the ability to dynamically add and remove resources as needed; this is referred to as elasticity.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      8,
      3,
      10,
      55,
      47
    ],
    "source": "333776_PracticeExam3"
  },
  {
    "id": 418,
    "question": "When monitoring performance metrics on one of your servers, you notice that the server is utilizing 100 percent of the network bandwidth available to it. What modification could you make to the server that will most likely address the problem?",
    "choice_a": "Add memory to the system",
    "choice_b": "Install a second network adapter",
    "choice_c": "Update the network adapter\u2019s firmware",
    "choice_d": "Install a second processor",
    "correct_answer": "B",
    "explanation": "If a server is using all of its network bandwidth, then the most logical solution is to add more. You can do this by installing a second network adapter and connecting it to a different subnet. The other solutions could conceivably address the problem, but the success is less likely.",
    "topic_id": 6,
    "practice_test_id": 4,
    "related_articles": [
      220,
      228,
      213,
      224,
      227
    ],
    "source": "333776_PracticeExam3"
  },
  {
    "id": 419,
    "question": "What type of scaling involves replacing an existing server with another that has more capabilities?",
    "choice_a": "Horizontal",
    "choice_b": "Round-robin",
    "choice_c": "Elasticity",
    "choice_d": "Autoscaling",
    "correct_answer": "E",
    "explanation": "Vertical scaling is the process of upgrading or replacing a server with one that has greater capabilities.",
    "topic_id": 3,
    "practice_test_id": 3,
    "related_articles": [
      163,
      182,
      199,
      208,
      183
    ],
    "source": "333776_PracticeExam3",
    "choice_e": "Vertical"
  },
  {
    "id": 420,
    "question": "Name three recommended procedures to take when preparing an outage response plan. (Choose three.)",
    "choice_a": "Configuration backups",
    "choice_b": "SLA",
    "choice_c": "Documentation",
    "choice_d": "Diagrams",
    "correct_answer": [
      "A",
      "C",
      "D"
    ],
    "explanation": "When troubleshooting, it is helpful to have access to configurations, documentation, and diagrams to provide information on your cloud deployment.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      138,
      143,
      135,
      141,
      113
    ],
    "source": "333776_PracticeExam3",
    "choice_e": "PaaS"
  },
  {
    "id": 421,
    "question": "During a recent downtime window, the server team was applying patches to an application, and the networking team was upgrading a router\u2019s interface to 10Gbps. When the network was down for the upgrade, the server team complained that they could not download the needed software patches. During a post-downtime status meeting, it was determined that which process should be modified to prevent this from happening in the future?",
    "choice_a": "Orchestration",
    "choice_b": "Automation",
    "choice_c": "Change management",
    "choice_d": "API calls",
    "correct_answer": "C",
    "explanation": "The change management process would need to be modified to prevent one change from affecting another that is taking place simultaneously.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      160,
      148,
      174,
      190,
      137
    ],
    "source": "333776_PracticeExam3"
  },
  {
    "id": 422,
    "question": "What determines the size of a group of servers sharing the same network range?",
    "choice_a": "Default gateway",
    "choice_b": "DNS",
    "choice_c": "NTP",
    "choice_d": "Subnet",
    "correct_answer": "D",
    "explanation": "The subnet mask determines the size of a IP network.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      39,
      11,
      36,
      16,
      8
    ],
    "source": "333776_PracticeExam3"
  },
  {
    "id": 423,
    "question": "The remote disaster recovery location follows the warm site model. To configure the network switches, routers, and firewalls remotely, Mark will need serial port access from his company\u2019s operations center. He has 14 serial ports currently but needs to be prepared for any unplanned expansion requirements during a disaster recover cutover. What device would you recommend he implement at the warm site?",
    "choice_a": "RDP",
    "choice_b": "Telnet",
    "choice_c": "IPsec",
    "choice_d": "SSH",
    "correct_answer": "E",
    "explanation": "In a data center, terminal servers are deployed and have several serial ports, each cabled to a console port on a device that is being managed. This allows you to make an SSH or a Telnet connection to the terminal server and then use the serial interfaces to access the console ports on the devices you want to connect to. The other options given do not provide serial port connections.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      135,
      146,
      27,
      16,
      138
    ],
    "source": "333776_PracticeExam3",
    "choice_e": "Terminal server"
  },
  {
    "id": 424,
    "question": "What are common troubleshooting steps? (Choose all that apply.)",
    "choice_a": "Gather information",
    "choice_b": "Distill the issue",
    "choice_c": "Research",
    "choice_d": "Create a plan of action",
    "correct_answer": [
      "A",
      "B",
      "C",
      "D",
      "E"
    ],
    "explanation": "All of the answers given are common troubleshooting steps.",
    "topic_id": 6,
    "practice_test_id": 4,
    "related_articles": [
      224,
      225,
      226,
      227,
      188
    ],
    "source": "333776_PracticeExam3",
    "choice_e": "Test and verify"
  },
  {
    "id": 425,
    "question": "Jill logs into her NoSQL database server residing in a private subnet on a public cloud. She needs to verify network reachability to the server. What utility can she use as a quick connectivity test?",
    "choice_a": "<code>arproute</code>",
    "choice_b": "<code>netstat</code>",
    "choice_c": "<code>tcpdump</code>",
    "choice_d": "<code>ping</code>",
    "correct_answer": "D",
    "explanation": "The <code>ping</code> utility verifies end-to-end network connectivity and is the correct answer. The other options offered either do not apply, such as <code>tcpdump</code> and <code>netstat</code>, or are not valid utilities, such as <code>arproute</code>.",
    "topic_id": 6,
    "practice_test_id": 5,
    "related_articles": [
      217,
      188,
      212,
      210,
      224
    ],
    "source": "333776_PracticeExam3"
  },
  {
    "id": 426,
    "question": "After deploying a new public website, your validation steps ask you to check the domain name to IP address mappings. Which utilities can you use for validation? (Choose two.)",
    "choice_a": "RDP",
    "choice_b": "<code>dig</code>",
    "choice_c": "SSH",
    "choice_d": "<code>nslookup</code>",
    "correct_answer": [
      "B",
      "D"
    ],
    "explanation": "<code>nslookup</code> is a Windows command-line utility for resolving domain names to IP addressing. The Linux equivalent is the <code>dig</code> utility. The other answers offered are not valid for the solution required in the question.",
    "topic_id": 6,
    "practice_test_id": 5,
    "related_articles": [
      214,
      217,
      205,
      209,
      226
    ],
    "source": "333776_PracticeExam3",
    "choice_e": "IPsec",
    "choice_f": "IPS"
  }
];
